const nl = {
  app: {
    name: 'Fit En Sterker',
  },
  auth: {
    coachPortalTitle: 'Coach Portal — inloggen',
    clientPortalTitle: 'Cliënt Portal — inloggen',
    email: 'E-mailadres',
    emailPlaceholder: 'naam@voorbeeld.nl',
    password: 'Wachtwoord',
    loading: 'Bezig...',
    startTraag: 'Verbinden met de server duurt langer dan gebruikelijk — dit kan gebeuren bij de eerste keer laden na een tijdje niet gebruikt te zijn. Even geduld, dit duurt meestal maximaal een paar minuten.',
    login: 'Inloggen',
    loginFooter: 'Gebruik hetzelfde account als in de Fit En Sterker app.',
    errorInvalidCredentials: 'Onjuist e-mailadres of wachtwoord.',
    errorGeneric: 'Inloggen mislukt. Probeer het opnieuw.',
    forgotPasswordQ: 'Wachtwoord vergeten?',
    forgotPasswordTitle: 'Wachtwoord vergeten',
    forgotPasswordSub: 'Vul je e-mailadres in. Je ontvangt een link om een nieuw wachtwoord in te stellen.',
    sendReset: 'Verstuur resetlink',
    backToLogin: 'Terug naar inloggen',
    resetEmailSent: 'Als dit e-mailadres bekend is, is er een resetlink verstuurd. Controleer je inbox.',
    errorResetGeneric: 'Aanvragen van de resetlink is mislukt. Probeer het opnieuw.',
  },
  dashboard: {
    coachFallback: 'coach',
    begroeting: 'Goedemorgen, {naam}',
    weekSubtitel: 'Week {nummer} · {van} t/m {tot}',
    naarRooster: 'Naar rooster',
    trainingPlannen: '+ Training plannen',
    actieveLeden: 'Actieve leden',
    eigenClienten: 'aan jou gekoppeld',
    trainingenDezeWeek: 'Trainingen deze week',
    trainingenVerdeling: '{groep} groepslessen · {pt} PT',
    openPlekken: 'Open plekken',
    groepslessenAantal: 'verdeeld over {aantal} groepslessen',
    bezettingsgraad: 'Bezettingsgraad',
    dezeWeek: 'deze week',
    vandaagMorgen: 'Vandaag & morgen',
    eerstvolgendeTrainingen: 'Jouw eerstvolgende trainingen',
    volledigRooster: 'Volledig rooster →',
    geenTrainingenVandaagMorgen: 'Je hebt vandaag en morgen geen trainingen gepland.',
    minuten: 'min',
    pt: 'PT',
    jarigDezeWeek: 'Jarig deze week',
    clientenAantal: '{aantal} cliënt(en)',
    geenVerjaardagen: 'Geen gekoppelde cliënten jarig deze week.',
    vandaagJarig: 'Vandaag jarig',
    jaar: '{aantal} jaar',
    meldingInstellen: 'Verjaardagsmelding instellen',
    weekmelding: 'Weekmelding',
    meldingUit: 'Uitgeschakeld',
    meldingSamenvatting: '{kanaal} · {dag} om {tijd}',
    ontvangenVia: 'Ontvangen via',
    opWelkeDag: 'Dag',
    omWelkeTijd: 'Tijd',
    voorkeurOpslaan: 'Voorkeur opslaan',
    opslaanBezig: 'Opslaan…',
    meldingOpgeslagen: 'Je verjaardagsmelding is opgeslagen.',
    foutOpslaanMelding: 'De meldingsvoorkeur kon niet worden opgeslagen: ',
    foutLaden: 'Het dashboard kon niet worden geladen: ',
    vraagtAandacht: 'Vraagt aandacht',
    openstaandeTaken: 'Zaken die niet moeten blijven liggen',
    ptAanvragen: 'PT-aanvragen',
    prospectActies: 'Prospectacties vandaag',
    uitzonderingen: 'Overige uitzonderingen',
    openAantal: '{aantal} open',
    nietGelogdeSessies: 'Nog te loggen PT-sessies',
    nietGelogdeSessiesAantal: '{aantal} sessies nog niet gelogd · laatste {dagen} dagen',
    geenNietGelogdeSessies: 'Alle recente PT-sessies zijn gelogd.',
    bekijkAlles: 'Bekijk alles →',
    kanaal: { push: 'Pushmelding', email: 'E-mail', both: 'Push & e-mail' },
    weekdag: {
      1: 'maandag', 2: 'dinsdag', 3: 'woensdag', 4: 'donderdag',
      5: 'vrijdag', 6: 'zaterdag', 7: 'zondag',
    },
  },
  nav: {
    mijnTrainingen: 'Trainingslogboek',
    dashboard: 'Dashboard',
    coachPortal: 'Coach Portal',
    clientPortal: 'Cliënt Portal',
    rooster: 'Rooster',
    clients: 'Cliënten',
    prospects: 'Prospecten',
    facturering: 'Facturering',
    opzeggingen: 'Opzeggingen',
    mijnFacturen: 'Mijn Facturen',
    mijnCredits: 'Mijn Credits',
    mijnLessen: 'Mijn lessen',
    voeding: 'Voeding',
    mijnAbonnement: 'Mijn abonnement',
    mijnAfspraken: 'PT-afspraken',
    instellingen: 'Instellingen',
    beheer: 'Beheer',
    persoonlijk: 'Persoonlijk',
    abonnementen: 'Abonnementen',
    locaties: 'Locaties',
    communicatie: 'Communicatie',
    organisatie: 'Organisatie',
    mijnCoachprofiel: 'Mijn coachprofiel',
    uitloggen: 'Uitloggen',
    accountMenu: 'Accountmenu openen',
    credits: 'credits',
    creditsResterend: 'credits resterend',
    klantnummer: 'Klantnr.',
    mijnBuddies: "Mijn buddy's",
    mijnGegevens: 'Mijn gegevens',
    recepten: 'Recepten',
    oefeningen: 'Oefeningen',
    pushNotificaties: 'Push notificaties',
    ptAanvragen: 'PT-aanvragen',
    acties: 'Actiecentrum',
    cronDashboard: 'Cron-dashboard',
    gebruikersBeheer: 'Gebruikersbeheer',
    bugrapporten: 'Bugrapporten',
    menuOpenen: 'Menu openen',
    roles: {
      superadmin: 'Superadmin',
      admin_coach: 'Admin Coach',
      coach: 'Coach',
      client: 'Cliënt',
    },
  },
  bugReports: {
    titel: 'Bugrapporten',
    subtitel: 'Meldingen uit de app beoordelen en opvolgen',
    vernieuwen: 'Vernieuwen',
    filterLabel: 'Bugrapporten filteren',
    filter: { open: 'Open', nieuw: 'Nieuw', in_behandeling: 'In behandeling', afgehandeld: 'Opgelost', afgewezen: 'Afgewezen', alles: 'Alles' },
    status: { nieuw: 'Nieuw', in_behandeling: 'In behandeling', afgehandeld: 'Opgelost', afgewezen: 'Afgewezen' },
    leegTitel: 'Nog geen bugrapporten',
    leegTekst: 'Meldingen die vanuit de app worden verstuurd verschijnen hier.',
    lijstLabel: 'Lijst met bugrapporten',
    filterLeeg: 'Geen meldingen binnen dit filter.',
    onbekendeMelder: 'Onbekende melder',
    schermOnbekend: 'Scherm onbekend',
    scherm: 'Scherm',
    actie: 'Actie',
    categorie: 'Foutcategorie',
    platform: 'Toestel',
    versie: 'Appversie',
    buildNummer: 'build {nummer}',
    netwerk: 'Netwerkstatus',
    statusLabel: 'Status',
    notitieLabel: 'Interne notitie',
    notitiePlaceholder: 'Leg vast wat is onderzocht of opgelost…',
    notitieHint: 'Deze notitie is alleen zichtbaar voor beheerders, niet voor de melder.',
    laatstBehandeld: 'Laatst behandeld op {datum} door {naam}.',
    beheerder: 'beheerder',
    opslaan: 'Wijzigingen opslaan',
    opslaanBezig: 'Opslaan…',
    opgeslagen: 'Bugrapport bijgewerkt.',
    nietOpgeslagen: 'Het bugrapport kon niet worden bijgewerkt.',
  },
  prospects: {
    eyebrow: 'Van eerste contact naar lidmaatschap',
    title: 'Prospecten',
    subtitle: 'Werk eerst de belangrijkste opvolging af. Binnen iedere fase staan acties van vandaag bovenaan.',
    addProspect: 'Prospect toevoegen',
    createTitle: 'Nieuwe prospect',
    prospectCreated: 'Prospect toegevoegd.',
    stages: {
      nieuwe_lead: 'Nieuwe lead',
      in_behandeling: 'In behandeling',
      kennismaking: 'Kennismaking',
      proeftraining: 'Proeftraining',
      afgerond: 'Afgerond',
    },
    priority: {
      today: 'Prioriteit 1 · vandaag',
      overdue: 'Prioriteit 1 · {count} d te laat',
      idle: 'Prioriteit 2 · {count} d stil',
      tomorrow: 'Prioriteit 3 · morgen',
      future: 'Over {count} dagen',
    },
    noAction: 'Geen volgende actie',
    noCoach: 'Geen coach',
    emptyStage: 'Sleep een prospect naar deze fase',
    dragLabel: '{name} naar een andere fase slepen',
    detailTitle: 'Prospectdetails van {name}',
    closeDetail: 'Details sluiten',
    planIntro: 'Kennismaking plannen',
    planTrial: 'Proeftraining plannen',
    nextActionTitle: 'Volgende actie',
    nextAction: 'Wat moet er gebeuren?',
    actionMoment: 'Datum en tijd',
    saveAction: 'Actie opslaan',
    notesTitle: 'Notities',
    notePlaceholder: 'Leg het gesprek, wensen of bezwaren vast…',
    addNote: 'Notitie toevoegen',
    noActivities: 'Nog geen notities of wijzigingen vastgelegd.',
    systemActor: 'Systeem',
    openRelation: 'Volledige relatie bekijken',
    activity: {
      note: 'Notitie toegevoegd',
      stage_change: 'Fase gewijzigd',
      next_action: 'Volgende actie ingesteld',
      appointment: 'Afspraak gemaakt',
    },
    loadError: 'Prospecten konden niet worden geladen: ',
    activitiesError: 'Activiteiten konden niet worden geladen: ',
    stageSaveError: 'De fase kon niet worden opgeslagen: ',
    actionSaveError: 'De volgende actie kon niet worden opgeslagen: ',
    noteSaveError: 'De notitie kon niet worden opgeslagen: ',
    stageSaved: 'Verplaatst naar {stage}.',
    actionSaved: 'Volgende actie opgeslagen.',
    noteSaved: 'Notitie toegevoegd.',
    appointmentLogError: 'De afspraak is gemaakt, maar kon niet in het prospectlogboek worden vastgelegd: ',
    appointmentNames: {
      kennismaking: 'Kennismaking',
      proeftraining: 'Proeftraining',
      pt: 'PT',
    },
    completionReasons: {
      customer: 'Klant geworden',
      no_interest: 'Geen interesse',
      no_response: 'Reageert niet',
      unknown: 'Reden niet vastgelegd',
    },
    completeTitle: 'Prospect afronden',
    completeIntro: 'Waarom wordt {name} afgerond?',
    completeArchiveHint: 'De prospect blijft nog zeven dagen zichtbaar in Afgerond en verdwijnt daarna automatisch van het bord.',
    completeCancel: 'Annuleren',
    completeConfirm: 'Prospect afronden',
    clientPanelEyebrow: 'Prospectproces',
    completedBecause: 'Afrondreden:',
    openBoard: 'Open prospectenbord',
    chooseOtherStage: 'Andere fase kiezen',
    moveToStage: 'Naar {stage} →',
    processProgress: 'Voortgang door het prospectproces',
    quickNote: 'Snelle notitie',
    noteInternal: 'Alleen zichtbaar voor coaches',
    chooseStageHint: 'Gebruik dit voor uitzonderingen of om een prospect terug te zetten. Rond een prospect af via het prospectenbord, zodat ook de reden wordt vastgelegd.',
    completeOnBoard: 'Afronden via prospectenbord',
    currentStage: 'Huidige fase',
    selectStage: 'Naar deze fase',
    activityFilter: {
      all: 'Alles',
      notes: 'Notities',
      stage: 'Fase',
    },
  },
  unauthorized: {
    title: 'Geen toegang',
    body: 'Je account heeft geen toegang tot dit portaal. Neem contact op met je coach of beheerder als je denkt dat dit een fout is.',
    uitloggen: 'Uitloggen',
  },
  rooster: {
    title: 'Rooster',
    weekVan: 'Week van',
    tm: 't/m',
    vorigeWeek: '← Vorige week',
    vandaag: 'Vandaag',
    volgendeWeek: 'Volgende week →',
    vol: 'VOL',
    geannuleerd: 'GEANNULEERD',
    foutLaden: 'Fout bij laden rooster: ',
    min: 'min',
    omschrijving: 'Omschrijving',
    nieuweLes: '+ Nieuwe les',
    prospectPrefix: '[Prospect]',
    filterAll: 'Alle',
    filterGroup: 'Groepslessen',
    filterPersonal: 'PT-afspraken',
    filterWorkshop: 'Workshops',
    trialBanner: 'Proeftraining plannen voor {naam} — selecteer een groepsles en klik op "Client inschrijven".',
    trialBannerWis: 'Wissen',
  },
  clientRooster: {
    title: 'Rooster',
    weekVan: 'Week van',
    tm: 't/m',
    vorigeWeek: '← Vorige week',
    vandaag: 'Vandaag',
    volgendeWeek: 'Volgende week →',
    inschrijven: 'Inschrijven',
    uitschrijven: 'Uitschrijven',
    opWachtlijst: 'Op wachtlijst',
    vol: 'Vol',
    ingeschreven: 'Ingeschreven',
    geannuleerd: 'Geannuleerd',
    verlopen: 'Verlopen',
    gevolgd: 'Gevolgd',
    plaatsen: 'plaatsen',
    ingeschrevenSucces: 'Je bent succesvol ingeschreven voor de les.',
    uitgeschrevenSucces: 'Je bent uitgeschreven voor de les.',
    wachtlijstGeplaatst: 'Les is vol — je bent op de wachtlijst geplaatst.',
    foutInschrijven: 'Fout bij inschrijven: ',
    foutUitschrijven: 'Fout bij uitschrijven: ',
    foutLaden: 'Fout bij laden rooster: ',
    foutGeenLidmaatschap: 'Je hebt geen actief lidmaatschap.',
    foutOnvoldoendeCredits: 'Onvoldoende credits om in te schrijven.',
    foutAbonnementNietToegestaan: 'Je abonnement geeft geen toegang tot deze les.',
    foutDeadlineVerstreken: 'De annuleringstermijn voor deze les is verstreken.',
    foutLesBestaat: 'Les niet gevonden of geannuleerd.',
    foutNietIngeschreven: 'Je bent niet ingeschreven voor deze les.',
    foutLesVerleden: 'Inschrijven op een les in het verleden is niet mogelijk.',
    foutAccountGeblokkeerd: 'Je account is geblokkeerd wegens een openstaande incasso. Neem contact op met de gym.',
    min: 'min',
    coach: 'Coach',
    credits: 'credits',
    creditsResterend: 'credits resterend',
    accountGeblokkeerd: 'Je account is tijdelijk geblokkeerd. Neem contact op met je coach.',
    // Fase 2 (2026-08-06): PT-afspraken renderden tot nu toe als gewone
    // groepsles, mét deelnemersaantallen en in-/uitschrijfknoppen die daar
    // niet op van toepassing zijn. Ze krijgen nu een eigen weergave.
    ptLabel: 'PT-afspraak',
    workshopLabel: 'Workshop',
    ptGeenInschrijving: 'Ingepland door je coach',
    ptAanvraag: 'Aanvraag',
    ptAanvraagPending: 'Wacht op bevestiging van je coach',
    ptAanvraagRescheduled: 'Je coach stelde een ander moment voor',
    opWachtlijstPositie: 'Op wachtlijst (plek {positie})',
    geenTrainingen: 'Geen trainingen',
    bekijkDetails: 'Bekijk details',
    groepslesLabel: 'Groepsles',
    detailsSluiten: 'Trainingsdetails sluiten',
    wanneer: 'Wanneer',
    duur: 'Duur',
    locatie: 'Locatie',
    beschikbaarheid: 'Beschikbaarheid',
    overTraining: 'Over deze training',
    geenOmschrijving: 'Voor deze training is nog geen omschrijving toegevoegd.',
    meenemen: 'Neem mee',
    week: 'Week',
    creditsPerAbonnement: 'Credits per abonnement',
    onbekendAbonnement: 'Abonnement',
    detailsLaden: 'Aanvullende informatie laden…',
    detailsFout: 'De aanvullende trainingsinformatie kon niet worden geladen.',
    jouwCoach: 'Jouw coach',
    coachGeenIntro: 'Deze coach heeft nog geen introductie toegevoegd.',
    annuleerbeleid: 'Annuleerbeleid',
    annuleertermijnVerstreken: 'De kosteloze annuleringstermijn is verstreken.',
    annulerenTot: 'Kosteloos annuleren tot {moment}',
    annulerenTotStart: 'Kosteloos annuleren tot de start',
    prijs: 'Prijs',
    prijsCredits: '{count} credit(s)',
    gratis: 'Gratis',
    buddiesIngeschreven: "Buddy's die meedoen",
    buddyDoetMee: '{naam} is ook ingeschreven',
  },
  clients: {
    title: 'Cliënten',
    // F4-10: toegestane betaalmethoden per client
    betaalmethodenTitel: 'Toegestane betaalmethoden',
    betaalmethodenHint: 'Bepaal welke van de systeembreed ingeschakelde betaalmethoden deze cliënt mag kiezen bij het ondertekenen. Handmatige betaling is altijd beschikbaar.',
    betaalmethodenGeenSysteem: 'Er zijn systeembreed geen online betaalmethoden ingeschakeld. Alleen handmatige betaling is beschikbaar. Schakel iDEAL of SEPA in bij de systeeminstellingen om hier een keuze te maken.',
    betaalmethodenRadioAlle: 'Alle beschikbare methoden (geen beperking)',
    betaalmethodenRadioAangepast: 'Aangepast — alleen geselecteerde methoden',
    betaalmethodenLabelHandmatig: 'Handmatig (altijd beschikbaar)',
    betaalmethodenLabelIdeal: 'iDEAL',
    betaalmethodenLabelSepa: 'SEPA-incasso',
    betaalmethodenSysteemUit: 'systeembreed uitgeschakeld',
    betaalmethodenTooltipUit: 'Deze methode staat systeembreed uit en kan niet worden geselecteerd.',
    betaalmethodenOpslaan: 'Betaalmethoden opslaan',
    betaalmethodenOpgeslagen: 'Betaalmethoden voor cliënt opgeslagen.',
    betaalmethodenFout: 'Fout bij opslaan betaalmethoden: ',
    aantalGevonden: 'cliënten gevonden',
    zoekPlaceholder: 'Zoeken op naam or e-mail…',
    filterAll: 'Alle',
    filterActive: 'Actief',
    filterProspect: 'Prospects',
    filterInactive: 'Inactief',
    statusActive: 'Actief',
    statusProspect: 'Prospect',
    statusInactive: 'Inactief',
    statusVerwijderd: 'Verwijderd',
    foutLaden: 'Fout bij laden cliënten: ',
    // Foutcodes van de Edge Functions create-client / delete-client
    efFoutGeenAutorisatie: 'Geen autorisatie — log opnieuw in.',
    efFoutOngeldigeToken: 'Je sessie is verlopen. Log opnieuw in en probeer het nogmaals.',
    efFoutProfielNietGevonden: 'Je eigen profiel kon niet worden gevonden. Neem contact op met de beheerder.',
    efFoutGeenToegang: 'Je hebt geen rechten om cliënten aan te maken.',
    efFoutVerplichteVelden: 'Naam en e-mailadres zijn verplicht.',
    efFoutOngeldigeGeboortedatum: 'De geboortedatum is ongeldig. Gebruik DD-MM-JJJJ.',
    efFoutOngeldigeRol: 'De gekozen rol bestaat niet.',
    efFoutGeenRechtenVoorRol: 'Je hebt geen rechten om een gebruiker met deze rol aan te maken.',
    efFoutCoachVerplicht: 'Kies een coach — zonder coach is de cliënt niet zichtbaar in de portal.',
    efFoutAbonnementVerplicht: 'Kies een abonnement; dat is verplicht voor een actieve cliënt.',
    efFoutEmailInGebruik: 'Dit e-mailadres is al in gebruik door een bestaande gebruiker. Gebruik een ander adres, of verwijder eerst de bestaande gebruiker.',
    efFoutGebruikerAanmakenMislukt: 'De gebruiker kon niet worden aangemaakt. Probeer het opnieuw.',
    efFoutProfielUpdateMislukt: 'Het profiel kon niet worden opgeslagen. De cliënt is niet aangemaakt; je kunt het opnieuw proberen.',
    efFoutCoachKoppelingMislukt: 'De koppeling met de coach kon niet worden gemaakt. De cliënt is niet aangemaakt; je kunt het opnieuw proberen.',
    efFoutAbonnementstypeNietGevonden: 'Het gekozen abonnementstype bestaat niet (meer). De cliënt is niet aangemaakt; kies een ander abonnement.',
    efFoutLidmaatschapMislukt: 'Het lidmaatschap kon niet worden aangemaakt. De cliënt is niet aangemaakt; je kunt het opnieuw proberen.',
    efFoutAanmakenMislukt: 'Er ging iets mis bij het aanmaken. De cliënt is niet aangemaakt; je kunt het opnieuw proberen.',
    efFoutAuthVerwijderenMislukt: 'De gegevens van de cliënt zijn verwijderd, maar het inlogaccount kon niet worden verwijderd. Het e-mailadres blijft daardoor bezet — meld dit bij de beheerder.',
    efFoutRollbackMislukt: 'Let op: het e-mailadres is nu wél bezet door een onvolledig account. Meld dit bij de beheerder voordat je het opnieuw probeert.',
    efFoutOnbekend: 'Onbekende fout bij het aanmaken van de cliënt.',
    // Foutteksten voor het verwijder-/anonimiseerpad — bewust gescheiden van de
    // aanmaakteksten hierboven (zie clientAanmaakFouten.js).
    efFoutVerwijderOnbekend: 'Onbekende fout bij het verwijderen van dit account.',
    efFoutVerwijderGeenId: 'Er is geen gebruiker geselecteerd om te verwijderen.',
    efFoutVerwijderGekoppeld: 'Dit account kan niet verwijderd worden omdat er nog gegevens aan gekoppeld zijn (bijvoorbeeld lessen, afspraken, facturen of overeenkomsten). Ontkoppel of verwijder die eerst, of gebruik "Account verwijderen" — dan blijven de gegevens bewaard en worden alleen de persoonsgegevens gewist.',
    efFoutVerwijderStaf: 'Een coach- of beheerdersaccount kan niet definitief verwijderd worden: gekoppelde lessen, afspraken en administratie moeten bewaard blijven. Gebruik "Account verwijderen" — de persoonsgegevens worden gewist en inloggen wordt geblokkeerd.',
    efFoutVerwijderNogGekoppeld: 'Dit account is nog gekoppeld als coach ({onderdelen}). Wijs die eerst toe aan een andere coach of gebruik "Account verwijderen".',
    efFoutVerwijderDeelLessen: '{aantal} les(sen)',
    efFoutVerwijderDeelAanvragen: '{aantal} PT-aanvra(a)g(en)',
    efFoutVerwijderDeelOvereenkomsten: '{aantal} aangemaakte overeenkomst(en)',
    colNaam: 'Naam',
    colKlantnummer: 'Klantnr.',
    colEmail: 'E-mail',
    emailAutomatiseringTitel: 'E-mail automatisering',
    emailAutomatiseringRadioSysteem: 'Volgt systeeminstelling',
    emailAutomatiseringRadioAangepast: 'Aangepast',
    emailAutomatiseringLabelReminder: 'Herinnering automatisch versturen',
    emailAutomatiseringLabelFinalNotice: 'Aanmaning automatisch versturen',
    emailAutomatiseringOpslaan: 'Opslaan',
    emailAutomatiseringOpgeslagen: 'E-mail automatisering instellingen opgeslagen.',
    emailAutomatiseringFout: 'Fout bij opslaan e-mail automatisering: ',
    emailAutomatiseringNietTeruggezet: 'De aangepaste instelling kon niet worden teruggezet naar "Systeem" — je hebt hier geen rechten voor. De afwijkende instelling blijft actief.',
    emailAutomatiseringNietOpgeslagen: 'De aangepaste instelling kon niet worden opgeslagen — je hebt hier geen rechten voor.',
    emailAutomatiseringHint: 'Bij "Aangepast" wijken deze instellingen af van de systeeminstellingen. Bij "Volgt systeeminstelling" worden de standaard instellingen gebruikt.',
    agrReminderTitel: 'Overeenkomst herinneringen',
    agrReminderHint: 'Pas hier de herinnering-instellingen aan voor deze client. Laat op "Volgt systeeminstelling" staan om de globale instelling te gebruiken.',
    agrReminderEnabledLabel: 'Herinneringen inschakelen voor deze client',
    agrReminderIntervalLabel: 'Interval (dagen)',
    agrReminderMaxLabel: 'Maximum aantal herinneringen',
    agrReminderOpgeslagen: 'Overeenkomst herinnering instellingen opgeslagen.',
    agrReminderFout: 'Fout bij opslaan: ',
    colCoach: 'Coach',
    colAccount: 'Account',
    colProspectStage: 'Prospectfase',
    colLidmaatschap: 'Lidmaatschap',
    colGeldigTm: 'Geldig t/m',
    colCredits: 'Credits',
    geenResultaatZoek: 'Geen cliënten gevonden voor deze zoekopdracht.',
    geenClinten: 'Nog geen cliënten.',
    onbekend: 'Onbekend',
    geen: 'Geen',
    details: 'Details →',
    openClient: 'Open cliënt →',
    geenKlantnummer: 'Geen klantnummer',
    cardProspectStage: 'Prospectfase',
    layoutButton: 'Indeling',
    layoutTitle: 'Kaartindeling',
    layoutSubtitle: 'Bepaal welke informatie je op iedere cliëntkaart ziet en in welke volgorde.',
    layoutMyLayout: 'Mijn indeling',
    layoutTenantHint: 'Deze persoonlijke indeling overschrijft de organisatiestandaard.',
    layoutMoveUp: 'Omhoog verplaatsen',
    layoutMoveDown: 'Omlaag verplaatsen',
    layoutVisible: 'Zichtbaar',
    layoutHidden: 'Verborgen',
    layoutReset: 'Standaard herstellen',
    layoutSave: 'Indeling opslaan',
    layoutSaved: 'Je kaartindeling is opgeslagen.',
    layoutSaveError: 'De kaartindeling kon niet worden opgeslagen: ',
    cardFieldMembership: 'Abonnement',
    cardFieldCredits: 'Credits',
    cardFieldValidUntil: 'Geldig t/m',
    cardFieldCoach: 'Coach',
    cardFieldAccount: 'Account',
    cardFieldEmail: 'E-mailadres',
    verwijderClient: 'Client verwijderen',
    verwijderConfirmTitel: 'Client definitief verwijderen',
    verwijderConfirmTekst: 'Weet je zeker dat je deze client wilt verwijderen? Alle gegevens inclusief facturen, overeenkomsten en credits worden permanent verwijderd.',
    verwijderWaarschuwing: 'Dit kan niet ongedaan worden gemaakt.',
    verwijderSuccess: 'Client succesvol verwijderd.',
    verwijderFout: 'Fout bij verwijderen: ',
    verwijderBezig: 'Verwijderen...',
    clipboardFout: 'Link kon niet worden gekopieerd.',
    toevoegenKnop: '+ Cliënt toevoegen',
    trialPopupTitel: 'Proeftraining inplannen?',
    trialPopupUitleg: 'Wil je direct een gratis proeftraining inplannen voor {naam}?',
    trialPopupJaPT: 'Ja, PT-training',
    trialPopupJaGroepsles: 'Ja, groepsles',
    trialPopupNee: 'Nee',
    modalTitelNieuw: 'Nieuwe cliënt toevoegen',
    labelVoornaam: 'Voornaam',
    labelAchternaam: 'Achternaam',
    labelEmail: 'E-mailadres',
    labelPhone: 'Telefoonnummer',
    labelGeboortedatum: 'Geboortedatum',
    labelWachtwoord: 'Wachtwoord',
    labelCoach: 'Coach toewijzen',
    labelType: 'Type',
    labelAbonnement: 'Abonnement',
    labelStartdatum: 'Startdatum lidmaatschap',
    typeActief: 'Actief lid',
    typeProspect: 'Prospect',
    placeholderVoornaam: 'Jan',
    placeholderAchternaam: 'de Vries',
    placeholderEmail: 'jan@voorbeeld.nl',
    placeholderPhone: '+31612345678',
    placeholderGeboortedatum: 'DD-MM-JJJJ',
    hintGeboortedatum: 'Typ alleen de 8 cijfers, bijvoorbeeld 16041989.',
    selecteerCoach: 'Selecteer coach…',
    selecteerAbonnement: 'Selecteer abonnement…',
    opslaan: 'Opslaan',
    annuleren: 'Annuleren',
    validatieVoornaam: 'Voornaam is verplicht.',
    validatieAchternaam: 'Achternaam is verplicht.',
    validatieEmail: 'E-mailadres is verplicht.',
    validatieCoach: 'Coach toewijzen is verplicht.',
    validatieAbonnement: 'Bij "Actief lid" is een abonnement verplicht.',
    validatieGeboortedatum: 'Vul een geldige geboortedatum in als DD-MM-JJJJ.',
    foutAanmaken: 'Fout bij aanmaken cliënt: ',
    geenSessie: 'Sessie verlopen — log opnieuw in.',
    succesBericht: 'Cliënt succesvol aangemaakt.',
    wachtwoordTonenTitel: 'Wachtwoord voor {naam}',
    wachtwoordTonenUitleg: 'Dit wachtwoord is automatisch gegenereerd en wordt maar één keer getoond — noteer het of stuur het door.',
    wachtwoordTonenGemaild: 'Dit wachtwoord staat ook in de welkomstmail die zojuist is verstuurd.',
    wachtwoordTonenNietGemaild: 'Er is geen welkomstmail verstuurd — geef dit wachtwoord zelf door aan de cliënt.',
    wachtwoordTonenSluiten: 'Ik heb het genoteerd, sluiten',
    geenCoachesGevonden: 'Geen coaches gevonden.',
    geenAbonnementenGevonden: 'Geen abonnementen gevonden.',
    sectionAdres: 'Adresgegevens (optioneel)',
    labelStraat: 'Straat',
    labelHuisnummer: 'Huisnummer',
    labelPostcode: 'Postcode',
    labelWoonplaats: 'Woonplaats',
    labelProfielfoto: 'Profielfoto',
    profielfotoAlt: 'Jouw profielfoto',
    profielfotoKiezen: 'Afbeelding kiezen',
    profielfotoBezig: 'Uploadenâ€¦',
    profielfotoHint: 'JPG, PNG of WebP, maximaal 5 MB.',
    profielfotoOpgeslagen: 'Profielfoto opgeslagen.',
    profielfotoTeGroot: 'De afbeelding is groter dan 5 MB.',
    profielfotoFout: 'Kon de profielfoto niet uploaden.',
    labelStandaardLocatie: 'Standaard locatie',
    geenLocatie: 'Geen locatie',
    placeholderStraat: 'Bijv. Sportlaan',
    placeholderHuisnummer: 'Bijv. 12',
    placeholderPostcode: 'Bijv. 1234 AB',
    placeholderWoonplaats: 'Bijv. Amsterdam',
  },
  clientDetail: {
    tabsLabel: 'Onderdelen van het cliëntdossier',
    tabs: {
      overview: 'Overzicht',
      coaching: 'Coaching',
      training: 'Training & voeding',
      membership: 'Abonnement & credits',
      finance: 'Financiën & documenten',
      settings: 'Instellingen',
    },
    summaryMembership: 'Abonnement',
    summaryCredits: 'Credits',
    summaryNextAppointment: 'Volgende afspraak',
    summaryNoAppointment: 'Geen afspraak gepland',
    summaryInvoices: 'Openstaande facturen',
    labelToegewezenCoach: 'Toegewezen coach',
    coachGewijzigd: 'Toegewezen coach aangepast.',
    coachWijzigenFout: 'Coach kon niet worden aangepast: ',
    terugNaarClients: '← Terug naar cliënten',
    onbekend: 'Onbekend',
    klantnummer: 'Klantnummer',
    lidmaatschap: 'Lidmaatschap',
    type: 'Type',
    status: 'Status',
    actief: 'Actief',
    verlopen: 'Verlopen',
    startdatum: 'Startdatum',
    einddatum: 'Einddatum',
    creditsResterend: 'Credits resterend',
    ptCreditsLabel: 'PT-credits',
    ptPlusCreditsLabel: 'PT-plus credits',
    smallGroupCreditsLabel: 'Small Group credits',
    geenLidmaatschap: 'Geen actief lidmaatschap gevonden.',
    overzicht: 'Overzicht',
    creditbewegingen: 'Creditbewegingen',
    last20: 'laatste transacties',
    facturenTotaal: 'totaal',
    openstaand: 'Openstaand',
    facturenLabel: 'facturen',
    creditgeschiedenisTitel: 'Creditgeschiedenis (laatste 20)',
    creditbewegingenTitel: 'Creditbewegingen',
    geenTransacties: 'Geen transacties gevonden.',
    colDatum: 'Datum',
    colMutatie: 'Mutatie',
    colReden: 'Reden',
    colNotitie: 'Notitie',
    facturen: 'Facturen',
    geenFacturen: 'Geen facturen gevonden.',
    colNummer: 'Nummer',
    colPeriode: 'Periode',
    colTotaal: 'Totaal',
    colStatus: 'Status',
    overeenkomstenTitel: 'Overeenkomsten',
    geenOvereenkomsten: 'Nog geen overeenkomsten ondertekend.',
    colOndertekenddatum: 'Ondertekend op',
    colAbonnementstype: 'Abonnementstype',
    colActies: 'Acties',
    downloadPdf: 'Download PDF',
    clientNietGevonden: 'Cliënt niet gevonden',
    geenToegang: 'Je hebt geen toegang tot dit cliëntprofiel.',
    foutLaden: 'Fout bij laden cliëntdetail: ',
    nieuweFactuur: '+ Nieuwe factuur aanmaken',
    creditsTitel: 'Credits',
    creditsHuidig: 'Huidige creditbalans',
    creditsBijschrijven: 'Credits bijschrijven',
    creditsAfschrijven: 'Credits afschrijven',
    poolPT: '1-op-1 PT',
    poolPTPlus60: '1-op-2 PT (60 min)',
    poolPTPlus30: '1-op-2 PT (30 min)',
    poolSmallGroup: 'Small Group',
    geenCreditPools: 'Geen actieve abonnementen met credits.',
    creditModalTitelBij: 'Credits bijschrijven',
    creditModalTitelAf: 'Credits afschrijven',
    creditModalAantal: 'Aantal credits',
    creditModalReden: 'Reden',
    creditModalOpslaan: 'Opslaan',
    creditModalAnnuleren: 'Annuleren',
    creditSuccesBij: 'Credits bijgeschreven.',
    creditSuccesAf: 'Credits afgeschreven.',
    creditFoutGeenLidmaatschap: 'Geen actief lidmaatschap gevonden.',
    creditFoutOnvoldoende: 'Onvoldoende credits.',
    creditFoutAantal: 'Voer een geldig aantal in (minimaal 1).',
    creditFoutOpslaan: 'Fout bij bijwerken credits: ',
    creditModalKiesAbonnement: 'Abonnement',
    creditModalKiesAbonnementPlaceholder: 'Kies een abonnement…',
    creditFoutKiesAbonnement: 'Selecteer een abonnement.',
    persoonsgegevens: 'Persoonsgegevens',
    bewerken: 'Bewerken',
    opslaan: 'Opslaan',
    annuleren: 'Annuleren',
    labelVolledigeNaam: 'Volledige naam',
    labelEmail: 'E-mailadres (alleen lezen)',
    labelTelefoon: 'Telefoonnummer',
    labelGeboortedatum: 'Geboortedatum',
    placeholderGeboortedatum: 'DD-MM-JJJJ',
    hintGeboortedatum: 'Typ alleen de 8 cijfers, bijvoorbeeld 16041989.',
    geboortedatumNietIngevuld: 'Niet ingevuld',
    validatieGeboortedatum: 'Vul een geldige geboortedatum in als DD-MM-JJJJ.',
    labelStandaardLocatie: 'Standaard locatie',
    geenLocatie: 'Geen locatie',
    labelStraat: 'Straat',
    labelHuisnummer: 'Huisnummer',
    labelPostcode: 'Postcode',
    labelWoonplaats: 'Woonplaats',
    persoonOpslaanFout: 'Fout bij opslaan persoonsgegevens: ',
    profielUpdateNietToegestaan: 'Je mag deze cliëntgegevens niet aanpassen.',
    persoonOpslaanSucces: 'Persoonsgegevens opgeslagen.',
    lidmaatschapBewerken: 'Lidmaatschap aanpassen',
    labelAbonnementstype: 'Abonnementstype',
    labelStartdatum: 'Startdatum',
    labelEinddatum: 'Einddatum (optioneel)',
    labelStatusLidmaatschap: 'Status',
    lidmaatschapActief: 'Actief',
    lidmaatschapInactief: 'Inactief',
    lidmaatschapOpslaanFout: 'Fout bij opslaan lidmaatschap: ',
    lidmaatschapOpslaanSucces: 'Lidmaatschap opgeslagen.',
    selecteerType: 'Selecteer een type…',
    afspraken: 'Afspraken',
    ptAfspraakInplannen: 'PT-afspraak inplannen',
    geenAfspraken: 'Geen afspraken gevonden.',
    badgeGroepsles: 'Groepsles',
    badgePT: 'PT',
    badgeWorkshop: 'Workshop',
    badgeAankomend: 'Aankomend',
    badgeGevolgd: 'Gevolgd',
    colAfspraakNaam: 'Les / afspraak',
    colAfspraakDatum: 'Datum & tijd',
    colAfspraakType: 'Type',
    colAfspraakLocatie: 'Locatie',
    colAfspraakStatus: 'Status',
    toonMeer: 'Toon meer',
    toonMinder: 'Toon minder',
    foutAfspraken: 'Fout bij laden afspraken: ',
    btwLabel: 'BTW:',
    btwMaandprijsIncl: 'Maandprijs incl.:',
    afsprakenAankomend: 'Aankomend',
    afsprakenGeschiedenis: 'Geschiedenis',
    geenAankomend: 'Geen aankomende afspraken.',
    geenGeschiedenisTabel: 'Geen afspraken in de geschiedenis.',
    handmatigVerlengingInfo: 'Verlenging en creditverstrekking gaan automatisch via de dagelijkse cron job.',
    opzeggenKnop: 'Abonnement opzeggen',
    opzeggenBevestiging: 'Weet je zeker dat je het abonnement van {naam} wilt opzeggen? Het abonnement loopt door tot {datum} en stopt daarna automatisch.',
    opzeggenSucces: 'Abonnement succesvol opgezegd.',
    opzeggenFout: 'Fout bij opzeggen: ',
    opzeggenPushTitel: 'Abonnement opgezegd',
    opzeggenPushBody: 'Je abonnement is opgezegd door je coach. Je hebt nog toegang tot {datum}.',
    opgezegd: 'Opgezegd — loopt af op {datum}',
    lidmaatschapGeschiedenisTitel: 'Lidmaatschapsgeschiedenis',
    customVoorwaarden: 'Aangepaste voorwaarden',
    customVoorwaardenInfo: 'Maak een abonnement op maat met afwijkende prijs, credits of looptijd.',
    customNaam: 'Aangepaste naam (optioneel)',
    customPrijs: 'Prijs (€)',
    customCredits: 'Credits per periode',
    customLooptijd: 'Looptijd (dagen)',
    customOpslaanAlsType: 'Sla ook op als nieuw standaard abonnementstype',
    customVoorwaardenPrijsVerplicht: 'Prijs is verplicht bij aangepaste voorwaarden.',
    customVoorwaardenCreditsVerplicht: 'Credits zijn verplicht bij aangepaste voorwaarden.',
    customVoorwaardenLooptijdVerplicht: 'Looptijd is verplicht bij aangepaste voorwaarden.',
    badgeAangepast: 'Aangepast',
    lidmaatschapGeenGeschiedenis: 'Nog geen geschiedenis beschikbaar.',
    colHistDatum: 'Datum',
    colHistType: 'Type wijziging',
    colHistStartdatum: 'Startdatum',
    colHistEinddatum: 'Einddatum',
    bannierIncasso: '⚠ Account geblokkeerd — openstaande incasso. Bekijk de facturen voor details.',
    membReminderTitel: 'Herinneringen',
    membReminderHint: 'Stel in wanneer deze cliënt herinneringen ontvangt vóór de automatische verlenging van het abonnement.',
    membReminderSysteem: 'Systeemdefault',
    membReminderAangepast: 'Aangepast schema',
    membReminderUitgeschakeld: 'Herinneringen uitschakelen',
    membReminderDagen: 'dagen',
    membReminderWettelijk: 'De bevestiging op de dag van verlenging wordt altijd verstuurd (wettelijke vereiste).',
    membReminderOpgeslagen: 'Herinneringsinstelling opgeslagen.',
    membReminderFout: 'Fout bij opslaan herinnering: ',
    selfLoggingTitel: 'Zelfstandig trainingen loggen',
    selfLoggingHint: 'Bepaal of deze cliënt zelf trainingssessies mag loggen, los van het abonnementstype.',
    selfLoggingMeerdereMemberships: 'Deze cliënt heeft {aantal} actieve abonnementen tegelijk. "Altijd"/"Nooit toestaan" wordt op alle {aantal} abonnementen toegepast; "Volg abonnementstype" staat toe zodra minstens één van de abonnementstypes het toelaat.',
    selfLoggingVolgen: 'Volg abonnementstype (nu: {status})',
    selfLoggingAan: 'aan',
    selfLoggingUit: 'uit',
    selfLoggingAltijd: 'Altijd toestaan',
    selfLoggingNooit: 'Nooit toestaan',
    selfLoggingOpgeslagen: 'Instelling voor zelfstandig loggen opgeslagen.',
    selfLoggingFout: 'Fout bij opslaan instelling zelfstandig loggen: ',
    selfLoggingNietOpgeslagen: 'De instelling voor zelfstandig loggen kon niet (volledig) worden opgeslagen — je hebt hier mogelijk geen rechten voor. Het scherm is opnieuw geladen met de werkelijke situatie.',
    badgeGeblokkeerd: 'Geblokkeerd',
    foutProfielVerwijderd: 'Dit profiel is verwijderd en kan niet meer bewerkt worden.',
    bannerProfielVerwijderd: 'Dit profiel is op {datum} verwijderd (geanonimiseerd) door de cliënt of een coach. Persoonsgegevens zijn gewist; facturen, abonnementen en overeenkomsten blijven bewaard voor de bewaarplicht.',
    blokkeringOpheffen: 'Blokkering opheffen',
    blokkeringOpheffenBevestiging: 'Weet je zeker dat je de blokkering van {naam} wilt opheffen? Er staan mogelijk nog openstaande incasso-facturen.',
    blokkeringOpgeheven: 'Blokkering is opgeheven. De client heeft weer volledige toegang.',
    blokkeringOpheffenFout: 'Fout bij opheffen blokkering: ',
    // Lidmaatschap nieuw 3-acties model
    staffelLabel: '{months} maand{suffix}',
    staffelLabelMet: '{type} — {months} maand{suffix}',
    pricePerPeriod: 'Prijs per periode',
    pricePerMonth: 'Prijs per maand',
    creditsPerPeriod: 'Credits per periode',
    // Weekmodel: "verlenging" was een maandmodel-begrip. De regel toont nu
    // de laatste daadwerkelijke wekelijkse credittoekenning uit credit_batches.
    laatsteBijschrijving: 'Laatste bijschrijving',
    nogNietVerlengd: 'Nog niets bijgeschreven',
    opzegdatum: 'Opzegdatum',
    initialEndDate: 'Initiële einddatum',
    isRolling: 'Maandelijks opzegbaar',
    autoRenewLabel: 'Automatisch verlengen',
    reminderDaysLabel: 'Herinneringsdagen',
    lidmaatschapBeeindigen: 'Lidmaatschap beëindigen',
    // F4-10 stap4a: payment_method wijzigen op bestaande membership
    betaalmethodeLabel: 'Betaalmethode',
    betaalmethodeWijzigen: 'Wijzigen',
    betaalmethodeBevestigen: 'Bevestigen',
    betaalmethodeAnnuleren: 'Annuleren',
    betaalmethodeOpgeslagen: 'Betaalmethode gewijzigd.',
    betaalmethodeFout: 'Fout bij wijzigen betaalmethode: ',
    betaalmethodeSepaHint: 'SEPA-incasso is via deze weg nog niet beschikbaar — dit komt binnenkort via de mandaatflow.',
    beeindigenModalTitel: 'Lidmaatschap beëindigen',
    beeindigenPerEindeContract: 'Per einde contract ({datum})',
    beeindigenPerEindeMaand: 'Einde lopende periode ({datum})',
    beeindigenPerDatum: 'Per aangepaste datum',
    beeindigenDatumLabel: 'Einddatum (minimaal morgen)',
    beeindigenDatumOphalenFout: 'De einddatum van het lopende abonnement kon niet worden berekend. Herlaad de pagina en probeer het opnieuw.',
    beeindigenBevestigen: 'Beëindigen bevestigen',
    beeindigenAnnuleren: 'Annuleren',
    beeindigenSucces: 'Abonnement beëindigd.',
    beeindigenFout: 'Fout bij beëindigen: ',
    lidmaatschapNieuw: 'Nieuw lidmaatschap',
    nieuwModalTitel: 'Nieuw lidmaatschap toevoegen',
    nieuwLabelType: 'Abonnementstype',
    nieuwSelecteerType: 'Selecteer een type…',
    nieuwLabelStaffel: 'Staffel (looptijd & prijs)',
    nieuwSelecteerStaffel: 'Selecteer een staffel…',
    nieuwLabelStartdatum: 'Startdatum',
    nieuwLabelPrijs: 'Prijs per periode (€)',
    nieuwLabelCredits: 'Credits per periode',
    nieuwLabelWelkomstmail: 'Stuur welkomstmail',
    nieuwBevestigen: 'Lidmaatschap toevoegen',
    nieuwAnnuleren: 'Annuleren',
    nieuwSucces: 'Lidmaatschap aangemaakt.',
    nieuwFout: 'Fout bij aanmaken lidmaatschap: ',
    nieuwGeenStaffels: 'Geen actieve staffels voor dit type.',
    nieuwValidatieType: 'Selecteer een abonnementstype.',
    nieuwValidatieStaffel: 'Selecteer een staffel.',
    nieuwValidatieStartdatum: 'Startdatum is verplicht.',
    nieuwCustomBadge: 'Aangepaste prijs/credits',
    lidmaatschapHistorieTitel: 'Lidmaatschapshistorie',
    historieGeenData: 'Geen lidmaatschapshistorie beschikbaar.',
    historieColType: 'Type',
    historieColStaffel: 'Staffel',
    historieColPeriode: 'Periode',
    historieColPrijs: 'Prijs',
    historieColCredits: 'Credits',
    historieColStatus: 'Status',
    historieColStart: 'Start',
    historieColEind: 'Eind',
    historieStatusActief: 'Actief',
    historieStatusVerlopen: 'Verlopen',
    historieStatusOpgezegd: 'Opgezegd',
    historieOnbekendType: 'Onbekend',
    historieGeschiedenisLabel: 'Laad historiek',
  },
  facturen: {
    title: 'Facturering',
    aantalFacturen: 'facturen',
    nieuweFactuur: '+ Nieuwe factuur',
    alleStatussen: 'Alle statussen',
    alleClients: 'Alle cliënten',
    geenFacturen: 'Geen facturen gevonden.',
    colNummer: 'Nummer',
    colClient: 'Cliënt',
    colPeriode: 'Periode',
    colDatum: 'Datum',
    colTotaal: 'Totaal',
    colStatus: 'Status',
    colActies: 'Acties',
    modalTitel: 'Nieuwe factuur aanmaken',
    labelClient: 'Cliënt',
    selecteerClient: 'Selecteer een cliënt…',
    labelAbonnement: 'Koppel aan abonnement (optioneel)',
    geenAbonnementKoppeling: 'Geen koppeling — losse factuur',
    abonnementKoppelingHint: 'Bepaalt o.a. welk abonnement de SEPA-incasso/machtigingskenmerk gebruikt bij deze factuur.',
    labelPeriodeStart: 'Periode start',
    labelPeriodeEinde: 'Periode einde',
    labelBtwPercentage: 'BTW-percentage',
    btwOptie9: '9%',
    btwOptie21: '21%',
    regeloverzicht: 'Regeloverzicht',
    colOmschrijving: 'Omschrijving',
    colAantal: 'Aantal',
    colStukprijs: 'Stukprijs',
    colBtwPct: 'BTW%',
    colExcl: 'Excl. BTW',
    colBtw: 'BTW',
    colIncl: 'Incl. BTW',
    omschrijvingPlaceholder: 'Omschrijving',
    regelToevoegen: '+ Regel toevoegen',
    subtotaal: 'Subtotaal excl. BTW',
    btw: 'BTW',
    totaalIncl: 'Totaal incl. BTW',
    annuleren: 'Annuleren',
    opslaan: 'Opslaan…',
    aanmaken: 'Factuur aanmaken',
    markeerVerzonden: 'Markeer verzonden',
    markeerBetaald: 'Markeer betaald',
    genererenPdf: 'Genereren…',
    verstuurFactuur: 'Verstuur factuur',
    downloadPdf: 'Download PDF',
    verstuurHerinnering: 'Verstuur herinnering',
    verstuurAanmaning: 'Verstuur aanmaning',
    verstuurIncasso: 'Verstuur incasso',
    factuurVerstuurd: 'Factuur verstuurd',
    waarschuwingVerzendstatus: 'Let op: de factuur is wél gemaild, maar de verzendstatus kon niet worden vastgelegd (mogelijk onvoldoende rechten). Een volgende verstuur-actie stuurt de mail dan opnieuw — controleer dit met een beheerder.',
    herinneringVerstuurd: 'Herinnering verstuurd',
    aanmaningVerstuurd: 'Aanmaning verstuurd',
    incassoVerstuurd: 'Incasso verstuurd',
    blokkeringGeactiveerd: 'Account van de client is geblokkeerd.',
    blokkeringOpgeheven: 'Blokkering opgeheven. Client heeft weer volledige toegang.',
    pdfGedownload: 'PDF gedownload',
    foutLaden: 'Fout bij laden facturen: ',
    foutAanmaken: 'Fout bij aanmaken factuur: ',
    foutStatus: 'Fout bij statuswijziging: ',
    foutUpload: 'Fout bij uploaden van de factuur-PDF. De factuur is NIET verstuurd. Probeer het opnieuw: ',
    foutStatusNaUpload: 'De PDF is opgeslagen, maar de statuswijziging mislukte. De factuur is niet als verstuurd gemarkeerd. Probeer het opnieuw: ',
    validatieClient: 'Selecteer een cliënt.',
    validatieRegels: 'Vul alle regelomschrijvingen en prijzen in.',
    validatieDatum: 'Einddatum moet na startdatum liggen.',
    stukprijsExcl: 'Excl.',
    stukprijsIncl: 'Incl.',
    exclRef: 'excl.:',
    verwijderen: 'Verwijderen',
    verwijderenTitel: 'Concept verwijderen',
    verwijderenTekst: 'Weet je zeker dat je deze concept-factuur wilt verwijderen? Dit kan niet ongedaan worden gemaakt.',
    verwijderenSucces: 'Factuur verwijderd.',
    foutVerwijderen: 'Fout bij verwijderen: ',
    verwijderenGeenRechten: 'De factuur kon niet worden verwijderd — je hebt hier geen rechten voor. Vraag een beheerder om dit te doen.',
    creditnota: 'Creditnota',
    creditnotaTitel: 'Creditnota aanmaken',
    creditnotaTekstPrefix: 'Wil je een creditnota aanmaken voor factuur',
    creditnotaTekstSuffix: '? De originele factuur blijft bestaan. De creditnota neutraliseert het openstaande bedrag.',
    creditnotaSucces: 'Creditnota aangemaakt:',
    foutCreditnota: 'Fout bij aanmaken creditnota: ',
    badgeCreditnota: 'Creditnota',
    bijFactuur: 'Bij factuur',
    herinneringPdf: 'Herinnering PDF',
    bevestigen: 'Bevestigen',
    herinneringModalTitel: 'Betalingsherinnering registreren',
    aanmaningModalTitel: 'Laatste aanmaning registreren',
    herinneringModalLoading: 'Herinnering registreren…',
    herinneringModalSucces: 'De herinnering is geregistreerd. Download de PDF hieronder.',
    herinneringModalDownload: '⬇ Download PDF',
    herinneringModalSluiten: 'Sluiten',
    herinneringKnop: 'Herinnering PDF',
    aanmaningKnop: 'Laatste aanmaning PDF',
    incassoKnop: 'Overdragen aan incasso',
    incassoTitel: 'Dossier overdragen aan incasso',
    incassoTekst: 'Weet je zeker dat je dit dossier overdraagt aan een incassobureau? Dit wordt gelogd.',
    incassoBevestigen: 'Overdragen',
    incassoSucces: 'Dossier overgedragen aan incasso.',
    herinneringGeschieden: 'Geschiedenis',
    histTypeReminder: 'Herinnering verstuurd',
    histTypeFinalNotice: 'Laatste aanmaning verstuurd',
    histTypeCollections: 'Overgedragen aan incasso',
    histNieuweBetaaldatum: 'Nieuwe betaaldatum:',
    herinneringFoutLaden: 'Fout bij registreren: ',
    betaaldBevestigenTitel: 'Factuur markeren als betaald',
    betaaldBevestigenKnop: 'Ja, markeer betaald',
    collectionsNaarBetaaldTekst: 'Weet je zeker dat je deze factuur als betaald wilt markeren? De incasso-overdracht wordt hiermee afgesloten.',
    markeerBetaaldIncasso: 'Markeer als betaald',
    onbetaaldKnop: 'Markeer onbetaald',
    onbetaaldTitel: 'Factuur terugzetten naar Verzonden',
    onbetaaldKnopBevestigen: 'Ja, zet terug',
    foutOnbetaald: 'Fout bij terugzetten: ',
    gedeeltelijkBetaald: 'Gedeeltelijk betaald',
    gedeeltelijkModalTitel: 'Gedeeltelijke betaling registreren',
    gedeeltelijkTotaal: 'Totaalbedrag',
    gedeeltelijkBetaaldLabel: 'Reeds betaald',
    gedeeltelijkOpenstaand: 'Openstaand',
    gedeeltelijkOpslaan: 'Opslaan',
    gedeeltelijkFout: 'Fout bij opslaan: ',
    gedeeltelijkValidatie: 'Voer een geldig bedrag in.',
    volledigBetaaldKnop: 'Volledig betaald',
    volledigBetaaldTitel: 'Factuur als volledig betaald markeren',
    volledigBetaaldTekst: 'Weet je zeker dat je deze factuur als volledig betaald wilt markeren?',
    volledigBetaaldBevestigen: 'Ja, volledig betaald',
    betaaldInfoLabel: 'Betaald:',
    openstaandInfoLabel: 'Open:',
    pushVersturen: 'Push notificatie versturen naar cliënt',
    pushTekstLabel: 'Berichttekst',
    registrerenEnDownloadBtn: 'Registreer & download PDF',
    testmodusLabel: '⚠ Testmodus: wachtdagen worden genegeerd',
    downloadBevestigenTitel: 'Status wijzigen zonder e-mail',
    downloadBevestigenTekst: 'Wil je de status wijzigen naar {status}? De PDF wordt gedownload maar er wordt geen e-mail verstuurd.',
    downloadBevestigenStatus: {
      draft: 'Verzonden',
      reminder: 'Herinnering verstuurd',
      final_notice: 'Aanmaning verstuurd',
      collections: 'Incasso',
    },
    downloadBevestigenJa: 'Bevestigen',
    downloadBevestigenAlleenPdf: 'Alleen PDF downloaden',
    pushModalTitel: 'Wil je ook een pushbericht sturen naar [naam]?',
    pushModalLabel: 'Berichttekst',
    pushModalHint: 'Deze tekst is afkomstig uit de E-mail automatisering instellingen en kan hier worden aangepast voor dit specifieke bericht.',
    pushModalOverslaan: 'Overslaan',
    pushModalVerstuur: 'Verstuur push',
    pushAanmaningTitle: 'Laatste aanmaning',
    pushValidatie: 'Voer een berichttekst in.',
    pushGeenToken: 'Cliënt heeft geen push token. Kan geen notificatie versturen.',
    pushFout: 'Fout bij versturen push: ',
  },
  banner: {
    openstaandeAanmaning: 'U heeft een openstaande aanmaning.',
    bekijkFacturen: 'Bekijk facturen',
    openstaandeOvereenkomst: 'Er staat een overeenkomst klaar voor je handtekening.',
    bekijkOvereenkomst: 'Bekijk en onderteken',
  },
  mijnFacturen: {
    title: 'Mijn Facturen',
    aantalFacturen: 'facturen',
    geenFacturen: 'Geen facturen gevonden.',
    colNummer: 'Nummer',
    colDatum: 'Datum',
    colTotaal: 'Totaal',
    colStatus: 'Status',
    foutLaden: 'Fout bij laden facturen: ',
    genererenPdf: 'Genereren…',
    downloadFactuur: 'Download factuur',
    histTypeReminder: 'Betalingsherinnering verstuurd',
    histTypeFinalNotice: 'Laatste aanmaning verstuurd',
    histTypeCollections: 'Overgedragen aan incasso',
    histNieuweBetaaldatum: 'Nieuwe betaaldatum:',
  },
  status: {
    draft: 'Concept',
    sent: 'Verzonden',
    paid: 'Betaald',
    reminded: 'Herinnerd',
    final_notice: 'Laatste aanmaning',
    collections: 'Overgedragen aan incasso',
    partially_paid: 'Gedeeltelijk betaald',
  },
  creditReasons: {
    lesson_enrollment:      'Les ingeboekt',
    lesson_unenroll_refund: 'Terugboeking uitschrijving',
    lesson_cancelled_refund: 'Terugboeking geannuleerde les',
    manual_deduct:          'Handmatige afschrijving',
    manual_grant:           'Handmatige bijschrijving',
    manual_reset:           'Credits gereset',
    grant_initial:          'Initiële credits bij abonnement',
    custom_grant:           'Aanvullende afspraak bij overeenkomst',
    grant_renewal:          'Bijschrijving bij verlenging',
    grant_weekly:           'Wekelijkse bijschrijving',
    grant_compensation:     'Compensatie',
    credit_expired:         'Vervallen credits',
    lesson_enrollment_promoted: 'Inschrijving via wachtlijst',
    deduct:                 'Afschrijving',
    refund:                 'Terugboeking',
  },
  // Bronlabels van de batch-uitsplitsing (credit_batches.source). Alleen
  // gebruikt op de twee diagnostische plekken: de creditgeschiedenis van de
  // client en het creditbeheerpaneel van de coach.
  creditBatchSources: {
    initial_week: 'Eerste week',
    weekly_grant: 'Wekelijkse toekenning',
    custom_grant: 'Aanvullende afspraak',
    manual_grant: 'Handmatig toegekend',
    compensation: 'Compensatie',
  },
  credits: {
    vervaltSubregel: 'waarvan {aantal} vervallen op {datum}',
    // Compacte saldobalk, gelijk aan het homescherm van de app.
    saldoTitel: 'Resterende credits',
    saldoToegankelijk: '{type}: {aantal} resterende credits',
    creditTypes: {
      pt: 'PT training',
      pt_plus: '2-op-1 training',
      small_group: 'Small group',
      other: 'Abonnement',
    },
    // Cliëntgerichte geldigheidsweergave (gelijk aan de mobiele app):
    // per abonnement het beschikbare tegoed met zijn vervaldatum. Geen
    // batch-jargon — "batch" is een interne term.
    geldigheidTitel: 'Geldigheid van je credits',
    geldigheidIntro: 'Je credits zijn per abonnement gegroepeerd. Hier zie je wanneer het beschikbare tegoed vervalt.',
    beschikbaarAantal: '{aantal} credits beschikbaar',
    beschikbaarAantalEnkel: '1 credit beschikbaar',
    geldigTot: 'Geldig t/m {datum}',
    volgendeToekenning: 'Op {datum} ontvang je {aantal} nieuwe credits.',
    volgendeToekenningEnkel: 'Op {datum} ontvang je 1 nieuwe credit.',
    geenToekenningMeer: 'Er worden geen nieuwe credits meer bijgeschreven.',
    geenBeschikbaar: 'Je hebt momenteel geen beschikbare credits.',
    batchesTitel: 'Openstaande creditbatches',
    batchesLeeg: 'Geen openstaande creditbatches',
    batchVervalt: 'vervalt {datum}',
    batchVervallen: 'vervallen op {datum}',
    batchResterend: '{resterend} van {toegekend}',
    volgendeBijschrijving: 'Volgende bijschrijving',
    perWeek: '{aantal}/week',
  },
  mijnCredits: {
    title: 'Mijn Credits',
    geenLidmaatschap: 'Geen actief lidmaatschap gevonden.',
    geschiedenisTitel: 'Creditgeschiedenis',
    colDatum: 'Datum',
    colReden: 'Reden',
    colAantal: 'Aantal',
    geenGeschiedenis: 'Geen creditgeschiedenis gevonden.',
    foutLaden: 'Fout bij laden creditgeschiedenis: ',
  },
  pdf: {
    factuur: 'Factuur',
    van: 'Van',
    aan: 'Aan',
    factuurdatum: 'Factuurdatum',
    periode: 'Periode',
    btwPercentage: 'BTW-percentage',
    omschrijving: 'Omschrijving',
    aantal: 'Aantal',
    stukprijs: 'Stukprijs',
    totaal: 'Totaal',
    colExcl: 'Totaal excl.',
    colBtw: 'BTW',
    colIncl: 'Totaal incl.',
    colBtwPct: 'BTW%',
    subtotaal: 'Subtotaal',
    btw: 'BTW',
    totaalTeBetalen: 'Totaal te betalen',
    geenRegeldetails: 'Geen regeldetails beschikbaar.',
    pagina: 'Pagina',
    van2: 'van',
    kvk: 'KvK',
    btwnr: 'Btw-nr',
    brandTagline: 'Personal Training & Groepslessen',
    betaalgegevens: 'Betaalgegevens',
    factuurdetails: 'Factuurdetails',
    teBetalen: 'Te betalen',
    voor: 'voor',
    naarIban: 'IBAN',
    opNaamVan: 'Op naam van',
    omschrijvingBet: 'Omschrijving',
    factuurnummer: 'Factuurnummer',
    factuurdatumLabel: 'Factuurdatum',
    betalingstermijn: 'Betalingstermijn',
    klantnummer: 'Klantnummer',
    dagen: 'dagen',
    btwSpecificatie: 'BTW-specificatie',
    btwPercent: 'Btw %',
    grondslag: 'Grondslag',
    bedrag: 'Bedrag',
    totaalExclBtw: 'Totaal excl. btw',
    totaalBtw: 'Totaal btw',
    totaalInclBtw: 'Te betalen',
    betalingsherinnering: 'Betalingsherinnering',
    herinneringSubtitel: 'is nog niet voldaan',
    herinneringTekst1: 'Wij hebben geconstateerd dat onderstaande factuur nog niet is voldaan. Wij verzoeken u vriendelijk het openstaande bedrag van',
    herinneringTekst2: 'vóór',
    herinneringTekst3: 'over te maken op onderstaand rekeningnummer.',
    openstaand: 'Openstaand',
    vervaldatum: 'Vervaldatum',
    oorspronkelijkeRegels: 'Originele factuurregels',
    laaststeAanmaning: 'Laatste aanmaning',
    laaststeAanmaningSubtitel: 'is ondanks eerdere herinnering onbetaald',
    aanmaningTekst1: 'Ondanks onze betalingsherinnering hebben wij uw betaling nog niet ontvangen. Wij sommeren u hierbij het openstaande bedrag van',
    aanmaningTekst2: 'uiterlijk op',
    aanmaningTekst3: 'te voldoen.',
    aanmaningTekst4: 'Bij niet-tijdige betaling zijn wij genoodzaakt incassokosten in rekening te brengen conform de Wet Incassokosten (WIK). De minimale incassokosten bedragen € 40,00. Na het verstrijken van deze termijn wordt uw dossier overgedragen aan een incassobureau.',
  },
  instellingen: {
    title: 'Instellingen',
    subtitle: 'Beheer bedrijfsgegevens en logo',
    // F4-10: betaalmethoden (systeembreed)
    betaalmethodenTitel: 'Betaalmethoden',
    betaalmethodenUitleg: 'Bepaal welke online betaalmethoden systeembreed beschikbaar zijn. Handmatige betaling (factuur zonder online betaling) is altijd beschikbaar en staat niet in deze lijst.',
    betaalmethodenLabelIdeal: 'iDEAL inschakelen',
    betaalmethodenHintIdeal: 'Sta eenmalige iDEAL-betalingen toe bij het ondertekenen van een overeenkomst.',
    betaalmethodenLabelSepa: 'SEPA-incasso inschakelen',
    betaalmethodenHintSepa: 'Sta doorlopende SEPA-incassomachtigingen toe bij het ondertekenen van een overeenkomst.',
    betaalmethodenHandmatigInfo: 'Handmatige betaling blijft altijd beschikbaar, ongeacht deze instellingen.',
    creditsTitel: 'Credits',
    creditsUitleg: 'Cliënten krijgen wekelijks credits bijgeschreven, gelijk aan het aantal sessies per week van hun abonnement. Deze credits vervallen na de termijn hieronder. Per abonnementstype kun je hiervan afwijken.',
    creditsVervalLabel: 'Standaard vervaltermijn van credits',
    creditsVervalEenheid: 'Eenheid van de vervaltermijn',
    creditsEenheidWeken: 'weken',
    creditsEenheidMaanden: 'maanden',
    creditsVervalHint: 'De vervaldatum wordt vastgelegd op het moment dat de credits worden toegekend. Een wijziging hier geldt dus alleen voor nieuwe credits en raakt nooit de credits die cliënten al hebben.',
    creditsWaarschuwingLabel: 'Waarschuw cliënt zoveel dagen vooraf',
    creditsWaarschuwingHint: 'Aantal dagen vóór een training waarop een cliënt zonder voldoende credits een melding krijgt. Zodra de annuleringstermijn van de training verstrijkt en er nog steeds te weinig credits zijn, vervalt de training automatisch.',
    creditsVervalOngeldig: 'Vul een vervaltermijn van minimaal 1 in.',
    creditsWaarschuwingOngeldig: 'Vul een geldig aantal dagen in (0 of meer).',
    creditsOpgeslagen: 'Creditinstellingen opgeslagen.',
    creditsFout: 'Fout bij opslaan creditinstellingen: ',
    // Fitness tracking deel 7: herinnering niet-gelogde PT-sessies
    selfLoggingTitel: 'Zelfstandig trainingen loggen (systeembreed)',
    selfLoggingUitleg: 'Hoofdschakelaar voor de hele omgeving. Staat deze uit, dan kan geen enkele cliënt zelf een training loggen — ongeacht de instelling per abonnementstype of de uitzondering per cliënt.',
    selfLoggingLabel: 'Cliënten mogen zelfstandig trainingen loggen',
    selfLoggingHint: 'Aanzetten geeft niet meteen iedereen toegang: daarna geldt nog steeds de instelling per abonnementstype en de eventuele uitzondering per cliënt.',
    selfLoggingLagen: 'Volgorde van beslissen: 1) deze hoofdschakelaar, 2) de standaardinstelling op het abonnementstype (pagina Abonnementen), 3) de uitzondering per cliënt (cliëntdetail). Alleen wanneer alle lagen toegang geven, verschijnt de optie in de app.',
    unloggedReminderTitel: 'Herinnering niet-gelogde PT-sessies',
    unloggedReminderUitleg: 'Stuur de uitvoerende coach een pushmelding wanneer een PT-sessie een tijd na afloop nog niet is gelogd. De coach bepaalt zelf, via zijn eigen meldingsvoorkeuren (categorie "Cliëntactiviteit"), of hij dit type melding wil ontvangen.',
    unloggedReminderLabelEnabled: 'Stuur coaches een herinnering bij niet-gelogde PT-sessies',
    unloggedReminderHintEnabled: 'Staat standaard uit. Zet je dit aan, dan controleert een uurlijkse achtergrondtaak welke PT-sessies nog niet gelogd zijn.',
    unloggedReminderLabelVertraging: 'Vertraging na afloop van de les (uren)',
    unloggedReminderHintVertraging: 'Aantal uren na het einde van de les voordat de eerste herinnering verstuurd wordt.',
    unloggedReminderLabelFrequentie: 'Herhalingsfrequentie',
    unloggedReminderHintFrequentie: 'Bepaalt of, en hoe vaak, de herinnering wordt herhaald zolang de sessie nog niet gelogd is.',
    unloggedReminderFrequentieEenmalig: 'Eenmalig',
    unloggedReminderFrequentieWekelijks: 'Wekelijks',
    unloggedReminderFrequentieTweewekelijks: 'Tweewekelijks',
    unloggedReminderVertragingOngeldig: 'Vul een geldig aantal uren in (0 of meer).',
    betaalmethodenOpgeslagen: 'Betaalmethoden opgeslagen.',
    betaalmethodenFout: 'Fout bij opslaan betaalmethoden: ',
    // F4-10 Stap 2: waarschuwing bij uitschakelen van een betaalmethode
    betaalmethodenWaarschuwingIdealEnkelvoud: 'Let op: {aantal} actief abonnement gebruikt momenteel iDEAL. Bestaande abonnementen blijven gewoon doorlopen; er verandert niets automatisch.',
    betaalmethodenWaarschuwingIdealMeervoud: 'Let op: {aantal} actieve abonnementen gebruiken momenteel iDEAL. Bestaande abonnementen blijven gewoon doorlopen; er verandert niets automatisch.',
    betaalmethodenWaarschuwingSepaEnkelvoud: 'Let op: {aantal} actief abonnement gebruikt momenteel SEPA-incasso. Bestaande abonnementen blijven gewoon doorlopen; er verandert niets automatisch.',
    betaalmethodenWaarschuwingSepaMeervoud: 'Let op: {aantal} actieve abonnementen gebruiken momenteel SEPA-incasso. Bestaande abonnementen blijven gewoon doorlopen; er verandert niets automatisch.',
    // F4-10 SEPA-machtigingsaddendum: incassant-ID voor de machtigingstekst
    mollieIncassantIdLabel: 'Mollie incassant-ID',
    mollieIncassantIdPlaceholder: 'Bijv. NL12ZZZ123456780000',
    mollieIncassantIdWaarschuwing: 'Incassant-ID nog niet ingesteld — nodig voor een juridisch volledige machtiging vóór productiegebruik met echte incasso\'s.',
    bedrijfsgegevens: 'Bedrijfsgegevens',
    logo: 'Bedrijfslogo',
    labelBedrijfsnaam: 'Bedrijfsnaam',
    labelAdres: 'Adres',
    labelPostcode: 'Postcode',
    labelStad: 'Stad',
    labelKvk: 'KVK-nummer',
    labelBtw: 'BTW-nummer',
    labelIban: 'IBAN-rekeningnummer',
    labelEmail: 'E-mail',
    labelTelefoon: 'Telefoon',
    labelEmailFrom: 'Algemeen afzenderadres (fallback)',
    hintEmailFrom: 'Dit adres moet geverifieerd zijn in Resend. Wordt gebruikt als een van de onderstaande specifieke adressen leeg is gelaten.',
    labelEmailInvoices: 'Afzenderadres facturen',
    hintEmailInvoices: 'Afzenderadres voor facturen, herinneringen, aanmaningen en SEPA-herincassomails. Leeg = gebruik het algemene afzenderadres.',
    labelEmailAgreements: 'Afzenderadres overeenkomsten',
    hintEmailAgreements: 'Afzenderadres voor overeenkomst-e-mails: verzending, herinneringen en afwijzingsbevestigingen. Leeg = gebruik het algemene afzenderadres.',
    labelEmailNotifications: 'Afzenderadres notificaties',
    hintEmailNotifications: 'Afzenderadres voor overige systeemmails, zoals de welkomstmail en opzeggingsbevestigingen. Leeg = gebruik het algemene afzenderadres.',
    labelBetalingstermijn: 'Betalingstermijn (dagen)',
    labelFactuurvoetnoot: 'Factuurvoetnoot / opmerking',
    opslaan: 'Opslaan',
    opgeslagen: 'Instellingen opgeslagen.',
    foutLaden: 'Fout bij laden instellingen: ',
    foutOpslaan: 'Fout bij opslaan instellingen: ',
    logoHuidig: 'Huidig logo:',
    logoUpload: 'Logo uploaden (PNG/JPG, max 2 MB)',
    logoUploaden: 'Uploaden…',
    logoFoutGrootte: 'Bestand is te groot (max 2 MB).',
    logoFoutType: 'Alleen PNG of JPG toegestaan.',
    logoFoutUpload: 'Fout bij uploaden logo: ',
    logoGeenLogo: 'Nog geen logo geüpload.',
    factuurtekstenSectionTitel: 'Factuurteksten',
    factuurtekstenSectionSubtitel: 'Beheer alle teksten die op facturen en herinneringen verschijnen.',
    factuurtekstenBeheerLink: 'Factuurteksten beheren',
    emailtekstenSectionTitel: 'E-mailteksten',
    emailtekstenSectionSubtitel: 'Beheer de teksten en templates die in automatische e-mails worden gebruikt.',
    emailtekstenBeheerLink: 'E-mailteksten beheren',
    locatiebeheer: 'Locatiebeheer',
    locatieFoutLaden: 'Fout bij laden locaties: ',
    locatieFoutOpslaan: 'Fout bij opslaan locatie: ',
    afbeeldingUploadFout: 'Kon de afbeelding niet uploaden.',
    locatieFoutToggle: 'Fout bij wijzigen locatiestatus: ',
    locatieNaamVerplicht: 'Vul een naam in.',
    bewerken: 'Bewerken',
    emailAutomatiseringTitel: 'E-mail automatisering',
    emailAutomatiseringSubtitel: 'Stel in welke factuur e-mails automatisch worden verstuurd via de dagelijkse cron job.',
    labelAutoReminder: 'Herinnering automatisch versturen',
    hintAutoReminder: 'Verstuur automatisch een betalingsherinnering 14 dagen na vervaldatum en wijzig de status naar "reminded".',
    labelAutoFinalNotice: 'Aanmaning automatisch versturen',
    hintAutoFinalNotice: 'Verstuur automatisch een laatste aanmaning na herinnering en wijzig de status naar "final_notice". Incasso-overdracht blijft altijd handmatig.',
    labelPushEnabled: 'Push notificatie versturen bij laatste aanmaning',
    hintPushEnabled: 'Verstuur automatisch een push notificatie naar de cliënt bij het registreren van een laatste aanmaning.',
    labelPushText: 'Standaard push berichttekst',
    hintPushDatum: '[datum] wordt automatisch vervangen door de nieuwe betaaldatum.',
    labelAutoRecurringInvoices: 'Facturen bij automatische verlengingen direct versturen',
    hintAutoRecurringInvoices: 'Facturen die de cron job aanmaakt bij automatische abonnementsverlengingen worden direct verstuurd en gemaild naar de cliënt, in plaats van als concept klaargezet te worden.',
    autoRecurringInvoicesConfirmTitel: 'Automatisch factureren inschakelen',
    autoRecurringInvoicesConfirmTekst: 'Weet je het zeker? Facturen gaan vanaf nu automatisch naar de klant.',
    opslaanEmailAutomatisering: 'Opslaan',
    emailAutomatiseringOpgeslagen: 'E-mail automatisering instellingen opgeslagen.',
    foutEmailAutomatisering: 'Fout bij opslaan e-mail automatisering: ',
    prospectHerinneringenTitel: 'Prospect opvolgherinneringen',
    prospectHerinneringenSubtitel: 'Stel in hoe vaak en wanneer prospects automatisch een opvolgherinnering ontvangen.',
    labelProspectReminderEnabled: 'Herinneringen versturen',
    hintProspectReminderEnabled: 'Verstuur automatisch opvolgherinneringen naar prospects na proefsessie.',
    labelProspectReminderInterval: 'Interval (dagen)',
    hintProspectReminderInterval: 'Aantal dagen tussen elke herinnering. Standaard 7 dagen.',
    labelProspectReminderMax: 'Maximum aantal herinneringen',
    hintProspectReminderMax: 'Maximaal aantal herinneringen dat wordt verstuurd per prospect. Standaard 3.',
    prospectHerinneringenOpgeslagen: 'Prospect opvolgherinneringen instellingen opgeslagen.',
    foutProspectHerinneringen: 'Fout bij opslaan prospect herinneringen: ',
    overeenkomstHerinneringenTitel: 'Overeenkomst herinneringen',
    overeenkomstHerinneringenUitleg: 'Stuur automatisch een herinnering als een client een openstaande overeenkomst heeft die nog niet is ondertekend.',
    labelAgreementReminderEnabled: 'Automatische herinneringen inschakelen',
    labelAgreementReminderInterval: 'Interval (dagen)',
    hintAgreementReminderInterval: 'Aantal dagen tussen herinneringen. Standaard 3 dagen.',
    labelAgreementReminderMax: 'Maximum aantal herinneringen',
    hintAgreementReminderMax: 'Maximaal aantal herinneringen per openstaand token. Standaard 2.',
    overeenkomstHerinneringenOpgeslagen: 'Overeenkomst herinnering instellingen opgeslagen.',
    foutOvereenkomstHerinneringen: 'Fout bij opslaan overeenkomst herinneringen: ',
    ontbrekendeTekstenTitel: 'Let op',
    ontbrekendeTekstenBody: 'Let op: Er is geen tekst beschikbaar voor één of meerdere herinneringen',
    naarTekstenPagina: 'Naar teksten-beheerpagina',
    algemeeneVoorwaardenTitel: 'Centrale algemene overeenkomstvoorwaarden',
    algemeeneVoorwaardenUitleg: 'Deze tekst wordt bij élke nieuwe overeenkomst bovenaan getoond, vóór de abonnements-specifieke voorwaarden. Gebruik dit voor juridische basistekst die voor alle typen geldt.',
    algemeeneVoorwaardenPlaceholder: 'Voer hier de algemene voorwaarden in die gelden voor alle overeenkomsten...',
    algemeeneVoorwaardenOpgeslagen: 'Algemene overeenkomstvoorwaarden opgeslagen.',
    foutAlgemeneVoorwaarden: 'Fout bij opslaan algemene voorwaarden: ',
    membReminderTitel: 'Standaard herinneringen abonnementsverlenging',
    membReminderUitleg: 'Stel in hoeveel dagen vóór de automatische verlenging cliënten een herinnering ontvangen. Dit is het systeemdefault; per cliënt kan een afwijkend schema worden ingesteld.',
    membReminderDagen: 'dagen',
    membReminderWettelijk: 'De bevestiging op de dag van verlenging wordt altijd verstuurd (wettelijke vereiste, Wet van Dam).',
    membReminderOpgeslagen: 'Herinneringsinstellingen opgeslagen.',
    membReminderFout: 'Fout bij opslaan herinneringen: ',
    expiryTitel: 'Vervaltijd uitnodigingen',
    expiryUitleg: 'Na hoeveel uur vervalt een onbevestigde lesuitnodiging automatisch? De client wordt per push op de hoogte gesteld.',
    expiryLabel: 'Uren tot vervallen',
    expiryOpgeslagen: 'Vervaltijd opgeslagen.',
    expiryFout: 'Fout bij opslaan vervaltijd: ',
    broadcastsTitel: 'Dagcap broadcasts',
    broadcastsUitleg: 'Maximaal aantal broadcast-pushberichten dat een coach per dag mag versturen. Beschermt tegen onbedoeld of overmatig versturen.',
    broadcastsLabel: 'Max. broadcasts per dag',
    broadcastsOpgeslagen: 'Dagcap broadcasts opgeslagen.',
    broadcastsFout: 'Fout bij opslaan dagcap broadcasts: ',
  },
  mijnLessen: {
    title: 'Mijn lessen',
    tabAankomend: 'Aankomend',
    tabGevolgd: 'Gevolgd',
    geenAankomend: 'Geen aankomende lessen gevonden.',
    geenGevolgd: 'Geen gevolgde lessen gevonden.',
    foutLaden: 'Fout bij laden lessen: ',
    colLes: 'Les',
    colDatumTijd: 'Datum & tijd',
    colLocatie: 'Locatie',
    colCoach: 'Coach',
    colStatus: 'Status',
    badgeAankomend: 'Aankomend',
    badgeWachtlijst: 'Wachtlijst',
    badgeGevolgd: 'Gevolgd',
    annuleerKnop: 'Annuleer',
    annuleerTitel: 'Inschrijving annuleren',
    annuleerBevestig: 'Weet je zeker dat je je wil uitschrijven voor deze les?',
    annuleerJa: 'Ja, uitschrijven',
    annuleerNee: 'Nee, behouden',
    annulerenBezig: 'Bezig…',
    annuleerFout: 'Fout bij annuleren: ',
    errNietIngeschreven: 'Je bent niet ingeschreven voor deze les.',
    errDeadlineVerstreken: 'De annuleringstermijn is verstreken.',
    errOnbekend: 'Er is een onbekende fout opgetreden.',
  },
  common: {
    laden: 'Laden…',
    pdf: '⬇ PDF',
    geen: '—',
    annuleren: 'Annuleren',
    send: 'Versturen',
    sending: 'Versturen…',
    bezig: 'Bezig…',
    // Generieke melding bij een schrijfactie die door RLS 0 rijen raakte:
    // PostgREST geeft dan succes terug, dus zonder rij-check zou het scherm
    // "opgeslagen" melden terwijl er niets veranderde (zie BRIEFING h8).
    wijzigingNietOpgeslagen: 'Wijziging kon niet worden opgeslagen, probeer opnieuw.',
    wijzigingNietVerwijderd: 'Verwijderen is niet gelukt, probeer opnieuw.',
  },
  clientInstellingen: {
    title: 'Mijn gegevens',
    subtitle: 'Bekijk en bewerk je persoonlijke gegevens',
    labelProfielfoto: 'Profielfoto',
    profielfotoAlt: 'Je profielfoto',
    profielfotoKiezen: 'Foto kiezen',
    profielfotoBezig: 'Bezig met uploaden…',
    profielfotoHint: 'JPG, PNG of WebP, maximaal 5 MB.',
    profielfotoOpgeslagen: 'Profielfoto opgeslagen.',
    profielfotoTeGroot: 'Deze afbeelding is te groot. Kies een bestand van maximaal 5 MB.',
    profielfotoFout: 'Uploaden van de profielfoto is mislukt. Probeer het opnieuw.',
    labelKlantnummer: 'Klantnummer (alleen lezen)',
    labelVolledigeNaam: 'Volledige naam',
    labelEmail: 'E-mailadres (alleen lezen)',
    labelGeboortedatum: 'Geboortedatum (alleen lezen)',
    geboortedatumNietIngevuld: 'Niet ingevuld',
    labelTelefoon: 'Telefoonnummer',
    labelStraat: 'Straat',
    labelHuisnummer: 'Huisnummer',
    labelPostcode: 'Postcode',
    labelWoonplaats: 'Woonplaats',
    opslaan: 'Opslaan',
    opslaanSucces: 'Gegevens opgeslagen.',
    opslaanFout: 'Fout bij opslaan: ',
    foutLaden: 'Fout bij laden gegevens: ',
  },
  lesBewerken: {
    title: 'Les bewerken',
    terug: '← Terug',
    editScopeLabel: 'Welke lessen wilt u bewerken?',
    editScopeSingle: 'Alleen deze les',
    editScopeFromHere: 'Deze en volgende lessen',
    editScopeAll: 'Alle lessen in de reeks',
    opslaan: 'Opslaan',
    succesBewerken: 'Les opgeslagen.',
    foutLaden: 'Fout bij laden les: ',
    foutOpslaan: 'Fout bij opslaan: ',
    lesNietGevonden: 'Les niet gevonden.',
    overrideDetachedLabel: 'Ook individueel afgeweken lessen (met een eigen tijd) overschrijven met de nieuwe tijd',
    maxParticipantsGuardError: 'Kan max. deelnemers niet verlagen: {lessen} les(sen) hebben samen {inschrijvingen} actieve inschrijving(en) boven het nieuwe maximum.',
    creditCostWaarschuwingTitel: 'Credit-kosten wijzigen',
    creditCostWaarschuwing: '{count} les(sen) in dit bereik hebben al actieve inschrijvingen. De nieuwe credit-kosten gelden alleen voor toekomstige inschrijvingen; bestaande afschrijvingen wijzigen niet met terugwerkende kracht. Doorgaan?',
  },
  lesAanmaken: {
    titleNieuw: 'Nieuwe les aanmaken',
    terug: '← Terug naar rooster',
    sectionBasic: 'Basisgegevens',
    naamLabel: 'Naam',
    naamPlaceholder: 'Naam van de les…',
    beschrijvingLabel: 'Beschrijving (optioneel)',
    beschrijvingPlaceholder: 'Korte omschrijving…',
    meenemenLabel: 'Wat meenemen (optioneel)',
    meenemenPlaceholder: 'Bijv. handdoek, matje, waterfles',
    meenemenCounter: '{{count}}/{{max}} tekens',
    locatieLabel: 'Locatie',
    andereLocatie: 'Andere locatie…',
    andereLocatieHint: 'Vul hieronder de gegevens van de tijdelijke locatie in.',
    opslaanAlsVasteLocatie: 'Opslaan als vaste locatie',
    opslaanAlsVasteLocatieConfirm: 'Wil je deze locatie opslaan voor toekomstig gebruik?',
    foutOpslaanLocatie: 'Fout bij opslaan locatie: ',
    valCustomLocationName: 'Vul een naam in voor de locatie.',
    typeLabel: 'Type',
    typeGroepsles: 'Groepsles',
    typePT: 'PT-afspraak',
    typeWorkshop: 'Workshop',
    categoryLabel: 'Trainingscategorie',
    categoryHint: 'Deze categorie bepaalt het herkenbare icoon in het trainingenoverzicht.',
    coachLabel: 'Coach',
    clientLabel: 'Cliënt',
    selecteerClient: 'Selecteer een cliënt…',
    geenClients: 'Geen cliënten beschikbaar (selecteer eerst een coach).',
    valClient: 'Selecteer een cliënt bij een PT-afspraak.',
    sectionDatetime: 'Datum & tijd',
    datumLabel: 'Startdatum',
    tijdLabel: 'Starttijd',
    duurLabel: 'Duur (minuten)',
    duurPlaceholder: '60',
    sectionCapacity: 'Capaciteit & credits',
    maxDeelnemersLabel: 'Max. deelnemers',
    maxPlaceholder: '10',
    annuleringstermijnLabel: 'Annuleringstermijn (uren)',
    annuleringsPlaceholder: '24',
    creditCostLabel: 'Creditkosten',
    creditPlaceholder: '1',
    workshopCreditHint: 'Workshops zijn gratis (0 credits) — dit veld is niet van toepassing.',
    sectionAbonnementen: 'Toegestane abonnementen',
    abonnementenHint: 'Standaard kunnen alle abonnementen zich inschrijven. Selecteer specifieke typen om de toegang te beperken.',
    alleAbonnementen: 'Alle abonnementen',
    geenAbonnementenGevonden: 'Geen abonnementstypes gevonden.',
    sectionHerhaling: 'Herhaling',
    eenmalig: 'Eenmalig',
    terugkerend: 'Terugkerend',
    dagenLabel: 'Dagen van de week',
    einddatumLabel: 'Einddatum reeks',
    oneindigLabel: 'Oneindig (12 weken vooruit)',
    previewLabel: 'Eerste 5 geplande lessen:',
    geenPreview: 'Geen lessen in dit patroon.',
    opslaan: 'Les aanmaken',
    opslaanReeks: 'Reeks aanmaken',
    succesAanmaken: 'Les aangemaakt.',
    succesReeks: 'Lesreeks aangemaakt.',
    foutLaden: 'Fout bij laden: ',
    foutOpslaan: 'Fout bij opslaan: ',
    foutInschrijvenReeks: 'De lessen zijn aangemaakt, maar het inschrijven van de cliënt is mislukt: ',
    valNaam: 'Naam is verplicht.',
    valLocatie: 'Selecteer een locatie.',
    valDuur: 'Duur moet groter zijn dan 0.',
    valMax: 'Max. deelnemers is verplicht.',
    valDagen: 'Selecteer minimaal één dag.',
    valEinddatum: 'Einddatum is verplicht.',
    valInschrijvingenBestaand: 'Er zijn al {aantal} client(s) ingeschreven op {lessen} les(sen). Je kunt alleen een abonnementsrestrictie instellen op lessen zonder actieve inschrijvingen.',
    geenLocaties: 'Geen actieve locaties beschikbaar.',
    geenCoaches: 'Geen coaches beschikbaar.',
    weekdagen: { ma: 'Ma', di: 'Di', wo: 'Wo', do: 'Do', vr: 'Vr', za: 'Za', zo: 'Zo' },
    ptPlusToggle: '1-op-2 PT afspraak (twee cliënten)',
    tweedeClientLabel: 'Tweede cliënt',
    selecteerTweedeClient: 'Selecteer tweede cliënt…',
    sessieDuurLabel: 'Sessieduur',
    minuten: 'minuten',
    ptPlusWarnGeenAbo: 'Deze cliënt heeft geen actief abonnement met PT-plus credits.',
    ptPlusWarnCredits: 'Deze cliënt heeft onvoldoende PT-plus credits.',
    ptPlusWarnDuur: 'Sessieduur ({gekozen} min) wijkt af van het abonnement van deze cliënt ({abo} min).',
    valTweedeClient: 'Selecteer een tweede cliënt bij een 1-op-2 PT afspraak.',
    // Abonnementskeuze + creditaftrek bij coach-directe PT-aanmaak (2026-08-01)
    abonnementLabel: 'Credits afboeken op',
    abonnementTweedeLabel: 'Credits tweede cliënt afboeken op',
    abonnementOnbekend: 'Onbekend abonnement',
    kiesAbonnement: 'Kies een abonnement…',
    creditsResterend: '{aantal} credits over',
    valAbonnementLaden: 'De abonnementen worden nog geladen — probeer het zo opnieuw.',
    valGeenAbo: 'Deze cliënt heeft geen actief PT- of PT-plus-abonnement. Koppel eerst een abonnement, of zet de kosten op 0 credits.',
    valGeenAboTweede: 'De tweede cliënt heeft geen actief PT- of PT-plus-abonnement.',
    valKiesAbo: 'Kies op welk abonnement de credits van de cliënt worden afgeboekt.',
    valKiesAboTweede: 'Kies op welk abonnement de credits van de tweede cliënt worden afgeboekt.',
    valGeenCredits: 'Er zijn niet genoeg credits over op {naam} voor deze afspraak.',
    creditConfirmTitel: 'Niet genoeg credits voor de hele reeks',
    creditConfirmTekst: 'Deze reeks bevat {gevraagd} afspraken en kost {nodig} credits, maar er staan er nog {beschikbaar} op {naam}. Er worden dan {haalbaar} afspraken aangemaakt; de rest vervalt. Doorgaan?',
    creditConfirmKnop: 'Toch aanmaken',
    succesReeksGedeeltelijk: '{aangemaakt} van de {gevraagd} lessen aangemaakt — de credits waren daarna op.',
    foutGeenLessenAangemaakt: 'Er is geen enkele les aangemaakt — controleer het creditsaldo van de cliënt.',
  },
  lesDetail: {
    laden: 'Laden…',
    bewerken: 'Bewerken',
    annuleren: 'Les annuleren',
    cancelFormTitel: 'Les annuleren',
    cancelScopeLabel: 'Welke lessen wilt u annuleren?',
    cancelScopeSingle: 'Alleen deze les',
    cancelScopeFromHere: 'Deze en volgende lessen',
    cancelScopeAll: 'Alle lessen in de reeks',
    cancelRedenLabel: 'Reden (optioneel)',
    cancelRedenPlaceholder: 'Reden voor annulering…',
    cancelBevestigen: 'Ja, annuleren',
    cancelSucces: '{count} les(sen) geannuleerd.',
    cancelFout: 'Fout bij annuleren: ',
    foutLaden: 'Fout bij laden inschrijvingen: ',
    sluiten: 'Sluiten',
    typeGroepsles: 'Groepsles',
    typePT: 'PT-afspraak',
    typeWorkshop: 'Workshop',
    bezetting: 'Bezetting',
    vol: 'VOL',
    ingeschrevenen: 'Ingeschreven',
    wachtlijst: 'Wachtlijst',
    geenIngeschrevenen: 'Geen ingeschrevenen.',
    geenWachtlijst: 'Geen wachtlijst.',
    positie: 'positie',
    uitschrijven: 'Uitschrijven',
    uitschrijvenBevestiging: 'Weet je zeker dat je {naam} wilt uitschrijven?',
    uitschrijvenSucces: '{naam} is uitgeschreven.',
    uitschrijvenSuccesPushFout: '{naam} is uitgeschreven, maar het pushbericht kon niet worden verstuurd. Laat het de cliënt zelf weten.',
    uitschrijvenFout: 'Fout bij uitschrijven: ',
    pushKnop: 'Pushbericht versturen',
    pushFormTitel: 'Pushbericht versturen aan deelnemers',
    pushOntvangersLabel: 'Ontvangers',
    pushOntvangersEnrolled: 'Ingeschreven',
    pushOntvangersWaitlisted: 'Wachtlijst',
    pushOntvangersBoth: 'Beiden (ingeschreven + wachtlijst)',
    pushBerichtLabel: 'Bericht',
    pushBerichtPlaceholder: 'Typ een bericht voor de deelnemers…',
    pushVersturen: 'Verstuur pushbericht',
    pushBerichtVerplicht: 'Bericht is verplicht.',
    pushGeenOntvangers: 'Geen ontvangers in deze groep.',
    pushFoutTokens: 'Fout bij ophalen push tokens: ',
    pushVerzenden: 'Verzenden… {sent} / {total} berichten verstuurd',
    pushSucces: '✓ {sent} pushberichten verstuurd. {skipped} clients hebben geen push token.',
    pushSluiten: 'Sluiten',
    hoverLidmaatschap: 'Type lidmaatschap',
    hoverStartdatum: 'Startdatum',
    hoverGeldigTm: 'Geldig t/m',
    hoverGeenLidmaatschap: 'Geen actief lidmaatschap',
    hoverBekijkProfiel: 'Bekijk profiel →',
    hoverActief: 'Actief',
    hoverBlokkade: '⚠ Blokkade',
    unenrollJa: 'Ja, uitschrijven',
    unenrollNee: 'Nee',
    unenrollPushLabel: 'Pushbericht sturen',
    unenrollDefaultBericht: 'Je bent door {coach} uitgeschreven voor {les} op {datum} om {tijd}.',
    unenrollCoachFallback: 'de coach',
    clientInschrijvenKnop: '+ Client inschrijven',
    inschrijfFormTitel: 'Client inschrijven voor deze les',
    inschrijfClientLabel: 'Client',
    inschrijfClientPlaceholder: 'Selecteer een client…',
    inschrijfBevestigingLabel: 'Bevestiging vereist',
    inschrijfCreditsLabel: 'Credits in rekening brengen',
    inschrijfCreditInfo: 'Creditkosten: {cost} credit(s)',
    inschrijfOpslaan: 'Inschrijven',
    inschrijfSuccesEnrolled: 'Client ingeschreven.',
    inschrijfSuccesPending: 'Inschrijving aangemaakt, wacht op bevestiging van client.',
    inschrijfSuccesWaitlisted: 'Client op wachtlijst geplaatst.',
    inschrijfFout: 'Fout bij inschrijven: ',
    inschrijfGeenClients: 'Geen clients beschikbaar.',
    inschrijfLaden: 'Clients laden…',
    inschrijfPushEnrolled: 'Je bent ingeschreven voor {les} op {datum} om {tijd} door {coach}.',
    inschrijfPushPending: 'Je bent uitgenodigd voor {les} op {datum} om {tijd}. Bevestig je deelname in de app.',
    inschrijfPushWaitlisted: 'Je staat op de wachtlijst voor {les} op {datum} om {tijd}.',
    pendingTitel: 'Wacht op bevestiging',
    geenPending: 'Geen openstaande bevestigingen.',
    pendingAnnuleren: 'Annuleren',
    pendingAnnulerenFout: 'Fout bij annuleren: ',
    pendingAnnulerenSucces: '{naam} verwijderd uit uitnodigingen.',
  },
  clientRoosterUitnodigingen: {
    titel: 'Openstaande uitnodigingen',
    bevestigen: 'Bevestigen',
    afwijzen: 'Afwijzen',
    geenOpenstaand: 'Geen openstaande uitnodigingen.',
    bevestigdSucces: 'Deelname bevestigd!',
    afgewezenSucces: 'Uitnodiging afgewezen.',
    foutBevestigen: 'Fout bij bevestigen: ',
    foutAfwijzen: 'Fout bij afwijzen: ',
    foutLaden: 'Fout bij laden uitnodigingen: ',
  },
  communication: {
    title: 'Communicatie',
    loading: 'Laden…',
    empty: 'Nog geen communicatie gelogd.',
    loadMore: 'Toon meer',
    colDatum: 'Datum',
    colType: 'Type',
    colOnderwerp: 'Onderwerp',
    colBericht: 'Bericht',
    types: {
      message: 'In-app bericht',
      push: 'Pushbericht',
      reminder: 'Betalingsherinnering',
      final_notice: 'Laatste aanmaning',
      collections: 'Incasso-overdracht',
      agreement_sent: 'Overeenkomst',
      agreement_signed: 'Overeenkomst ondertekend',
      agreement_rejected: 'Overeenkomst',
      agreement_revoked: 'Overeenkomst',
      agreement_reminder: 'Overeenkomst herinnering',
      prospect_reminder: 'Prospect herinnering',
      welcome: 'Welkomstmail',
      cancellation_confirmation: 'Opzeggingsbevestiging',
    },
    geplandLabel: 'Gepland',
    stuurNuKnop: 'Stuur nu',
    stuurProspectHerinnering: 'Stuur herinnering nu',
    prospectReminderVerstuurd: 'Prospect herinnering verstuurd.',
    prospectReminderFout: 'Fout bij versturen herinnering: ',
    channels: {
      in_app: 'In-app',
      push: 'Push',
      system: 'Systeem',
    },
  },
  voeding: {
    titel: 'Voeding & Kcal',
    instellen: 'Kcal instellen / aanpassen',
    dagKcal: 'Dagelijks maximum',
    eiwitten: 'Eiwitten doel',
    koolhydraten: 'Koolhydraten doel',
    vetten: 'Vetten doel',
    ingesteldOp: 'Ingesteld op:',
    geenToewijzing: 'Nog geen kcal-toewijzing ingesteld.',
    modalTitel: 'Kcal instellen / aanpassen',
    labelDagKcal: 'Dagelijks kcal maximum',
    labelEiwitten: 'Eiwitten doel (gram)',
    labelKoolhydraten: 'Koolhydraten doel (gram)',
    labelVetten: 'Vetten doel (gram)',
    optioneel: 'optioneel',
    opslaan: 'Opslaan',
    annuleren: 'Annuleren',
    valDagKcal: 'Voer een geldig kcal-getal in.',
    foutOpslaan: 'Fout bij opslaan: ',
  },
  exercises: {
    title: 'Oefeningen',
    subtitle: 'Beheer de gedeelde oefeningenbibliotheek',
    nieuw: '+ Oefening toevoegen',
    zoekPlaceholder: 'Zoeken op naam…',
    alleSpiergroepen: 'Alle spiergroepen',
    aantalGevonden: '{aantal} oefeningen',
    toonVerborgen: 'Toon ook verborgen oefeningen',
    colNaam: 'Naam',
    colSpiergroep: 'Spiergroep',
    colHerkomst: 'Herkomst',
    colMedia: 'Media',
    colGebruik: 'Gebruik',
    colActies: 'Acties',
    badgeStandaard: 'Standaard',
    badgeDoorCoach: 'Door {coach}',
    badgeEigen: 'Door een coach',
    badgeVerborgen: 'Verborgen',
    mediaAfbeelding: 'Afbeelding',
    mediaVideo: 'Video',
    geenOefeningen: 'Geen oefeningen gevonden.',
    bewerken: 'Bewerken',
    bekijken: 'Bekijken',
    detailsTonen: 'Details tonen',
    detailsVerbergen: 'Details verbergen',
    detailInstructie: 'Instructie',
    geenInstructie: 'Nog geen instructie toegevoegd.',
    verbergen: 'Verbergen',
    tonen: 'Tonen',
    verwijderen: 'Verwijderen',
    gebruikGeen: 'Niet in gebruik',
    gebruikSjabloon: '1 sjabloon',
    gebruikSjablonen: '{aantal} sjablonen',
    gebruikSessie: '1 sessie',
    gebruikSessies: '{aantal} sessies',
    verwijderInGebruik: 'Deze oefening is in gebruik in {gebruik} en kan niet worden verwijderd — verberg hem in plaats daarvan.',
    verwijderAlleenEigen: 'Alleen de coach die deze oefening toevoegde of een beheerder kan hem verwijderen.',
    verwijderStandaardNooit: 'Standaardoefeningen kunnen niet worden verwijderd. Verberg ze als je ze niet wilt gebruiken.',
    verwijderTitel: 'Oefening verwijderen',
    verwijderTekst: 'Weet je zeker dat je “{naam}” definitief wilt verwijderen? Bijbehorende afbeelding en video worden ook verwijderd. Dit kan niet ongedaan worden gemaakt.',
    verwijderBevestigen: 'Definitief verwijderen',
    succesVerwijderd: 'Oefening verwijderd.',
    succesVerborgen: 'Oefening verborgen.',
    succesZichtbaar: 'Oefening weer zichtbaar.',
    foutVerwijderen: 'Fout bij verwijderen: ',
    foutZichtbaarheid: 'Fout bij wijzigen zichtbaarheid: ',
    modalTitelNieuw: 'Oefening toevoegen',
    modalTitelBewerken: 'Oefening bewerken',
    veldNaam: 'Naam',
    veldNaamPlaceholder: 'Bijv. Bench press',
    veldSpiergroep: 'Spiergroep',
    veldInstructie: 'Instructie (optioneel)',
    veldInstructiePlaceholder: 'Bijv. Voeten op heupbreedte, rug recht, rustig laten zakken…',
    veldAfbeelding: 'Afbeelding (optioneel)',
    veldVideo: 'Instructievideo (optioneel)',
    videoBekijken: 'Video bekijken',
    mediaVerwijderen: 'Verwijderen',
    mediaToelichting: 'De afbeelding verschijnt na opslaan in het bibliotheekoverzicht. In de app worden afbeelding en video nog niet getoond; ze worden alvast bewaard voor een volgend deel.',
    bezigUploaden: 'Bezig met uploaden…',
    standaardAlleenLezen: 'Dit is een standaardoefening. Alleen een beheerder kan deze aanpassen.',
    andereCoachAlleenLezen: 'Deze oefening is door een andere coach toegevoegd en kan alleen door die coach of een beheerder worden aangepast.',
    spiergroep: {
      benen: 'Benen',
      rug: 'Rug',
      borst: 'Borst',
      schouders: 'Schouders',
      armen: 'Armen',
      core: 'Core',
      overig: 'Overig',
    },
    opslaan: 'Opslaan',
    annuleren: 'Annuleren',
    succesOpgeslagen: 'Oefening opgeslagen.',
    foutLaden: 'Fout bij laden oefeningen: ',
    foutOpslaan: 'Fout bij opslaan: ',
    foutGeenRechten: 'Er is niets opgeslagen: je hebt geen rechten om deze oefening te wijzigen.',
    foutUpload: 'Fout bij uploaden: ',
    foutNaamVerplicht: 'Vul een naam in.',
    foutSpiergroepVerplicht: 'Kies een spiergroep.',
    foutCardioMetricVerplicht: 'Kies minimaal één veld om te loggen voor een cardio-oefening.',
    alleTypen: 'Alle typen',
    colType: 'Type',
    veldType: 'Type',
    type: {
      kracht: 'Kracht',
      cardio: 'Cardio',
    },
    veldCardioMetrics: 'Te loggen velden',
    veldCardioMetricsHint: 'Kies welke velden de coach tijdens het loggen te zien krijgt.',
    cardioMetric: {
      afstand: 'Afstand',
      tijd: 'Tijd',
      snelheid: 'Snelheid/tempo',
      helling: 'Helling',
      weerstand: 'Weerstand',
      hartslag: 'Hartslag',
      kcal: 'Kcal',
    },
  },
  trainingTemplates: {
    titel: 'Trainingssjablonen',
    subtitel: 'Vaste oefeningschema’s voor deze cliënt',
    nieuw: '+ Sjabloon aanmaken',
    geenSjablonen: 'Nog geen trainingssjablonen voor deze cliënt.',
    statusActief: 'Actief',
    statusGearchiveerd: 'Gearchiveerd',
    aantalOefeningen: '{aantal} oefeningen',
    laatstGebruikt: 'Laatst gebruikt {datum}',
    nooitGebruikt: 'Nog niet gebruikt',
    geldigTot: 'Geldig tot {datum}',
    enNogMeer: '+ nog {aantal}',
    bewerken: 'Bewerken',
    archiveren: 'Archiveren',
    terugzetten: 'Terugzetten',
    archiveerTitel: 'Sjabloon archiveren',
    archiveerTekst: 'Weet je zeker dat je “{naam}” wilt archiveren? Het sjabloon blijft zichtbaar, maar wordt niet meer aangeboden bij het starten van een nieuwe sessie.',
    succesGearchiveerd: 'Sjabloon gearchiveerd.',
    succesTeruggezet: 'Sjabloon teruggezet naar actief.',
    foutStatus: 'Fout bij wijzigen status: ',
    formTitelNieuw: 'Sjabloon aanmaken',
    formTitelBewerken: 'Sjabloon bewerken',
    formSubtitel: 'Voor {client}',
    terug: '← Terug naar cliënt',
    veldNaam: 'Naam van het sjabloon',
    veldNaamPlaceholder: 'Bijv. Bovenlichaam A',
    veldGeldigTot: 'Geldig tot (optioneel)',
    veldGeldigTotHint: 'Na deze datum wordt het sjabloon automatisch gearchiveerd. Leeg laten voor onbeperkt geldig.',
    gekozenTitel: 'Oefeningen in dit sjabloon',
    gekozenHint: 'Sleep met ⠿ om de volgorde aan te passen. Sets, reps en gewicht zijn uitgangspunten en optioneel.',
    geenOefeningenGekozen: 'Nog geen oefeningen toegevoegd. Kies ze rechts uit de bibliotheek.',
    bibliotheekTitel: 'Oefeningenbibliotheek',
    toevoegen: 'Toevoegen',
    alToegevoegd: 'Toegevoegd',
    sleepHandvat: 'Slepen om de volgorde te wijzigen',
    oefeningVerwijderen: 'Oefening uit sjabloon verwijderen',
    veldSets: 'Sets',
    veldReps: 'Reps',
    veldGewicht: 'Gewicht (kg)',
    filterTypeLabel: 'Filter op oefeningstype',
    filterTypeAlle: 'Alle types',
    filterSpiergroepUit: 'Spiergroep is niet van toepassing bij cardio-oefeningen.',
    doelVeld: 'Doel {metric}',
    doelMinuten: 'Doelminuten',
    doelSeconden: 'Doelseconden',
    cardioGeenMetrics: 'Voor deze cardio-oefening zijn nog geen logvelden ingesteld in de oefeningenbibliotheek, dus er zijn geen doelen op te geven.',
    veldAandachtspunt: 'Aandachtspunt voor de client (optioneel)',
    veldAandachtspuntPlaceholder: 'Bijv. Let op houding onderrug, rustig tempo…',
    opslaan: 'Sjabloon opslaan',
    annuleren: 'Annuleren',
    annuleerTitel: 'Wijzigingen verwerpen',
    annuleerTekst: 'Je hebt wijzigingen die nog niet zijn opgeslagen. Weet je zeker dat je wilt stoppen?',
    annuleerBevestigen: 'Verwerpen',
    valNaam: 'Vul een naam voor het sjabloon in.',
    valOefeningen: 'Voeg minimaal één oefening toe aan het sjabloon.',
    valSets: 'Sets moet minimaal 1 zijn.',
    valReps: 'Reps moet minimaal 1 zijn.',
    valGewicht: 'Gewicht kan niet negatief zijn.',
    foutLaden: 'Fout bij laden trainingssjablonen: ',
    foutOpslaan: 'Fout bij opslaan sjabloon: ',
    foutNietGevonden: 'Dit trainingssjabloon bestaat niet (meer).',
    foutAndereClient: 'Dit trainingssjabloon hoort bij een andere cliënt.',
  },
  trainingHistory: {
    titel: 'Trainingshistorie',
    subtitel: 'Gelogde trainingssessies van deze cliënt',
    foutLaden: 'Fout bij laden trainingshistorie: ',
    // Kerncijfers
    statSessiesTitel: 'Sessies deze maand',
    statSessiesEenheid: 'sessies',
    statSessiesEenheidEnkel: 'sessie',
    statTopsetTitel: 'Laatste topset',
    statTopsetKiesLabel: 'Oefening kiezen voor de topset',
    statTopsetGewicht: '{gewicht} kg × {reps}',
    statTopsetGewichtZonderReps: '{gewicht} kg',
    statTopsetZonderGewicht: '{reps} reps',
    statTopsetDatum: 'op {datum}',
    statTopsetLeeg: 'Nog geen sets gelogd',
    statRpeTitel: 'Gem. RPE laatste sessie',
    statRpeToelichting: 'over {aantal} sets',
    statRpeLeeg: 'Geen RPE ingevuld',
    leegWaarde: '—',
    leegNogGeenSessies: 'Nog geen sessies gelogd',
    // Sessielijst
    geenSessiesTitel: 'Nog geen trainingssessies',
    geenSessiesTekst: 'Zodra er een training wordt gelogd in de app, verschijnt de historie hier: datum, gebruikt sjabloon, de oefeningen met sets, reps en gewicht, en eventuele opmerkingen.',
    losseSessie: 'Losse sessie',
    gelogdDoor: 'Gelogd door {naam}',
    gelogdDoorClient: 'Zelf gelogd door de cliënt',
    gelogdDoorCoach: 'Gelogd door de coach',
    gelogdDoorOnbekend: 'Bron van deze registratie onbekend',
    badgeDoorCoach: 'Door coach',
    badgeZelfstandig: 'Zelfstandig',
    geenOefeningen: 'Geen oefeningen vastgelegd bij deze sessie.',
    oefeningSets: '{sets}×{reps}',
    oefeningSetsZonderReps: '{sets} sets',
    oefeningSetsZonderRepsEnkel: '{sets} set',
    oefeningGewicht: '{gewicht} kg',
    // Cardio-samenvatting (vatCardioSetsSamen in workoutHistoryUtils.js)
    cardioAfstand: '{waarde} km',
    cardioTijd: '{waarde}',
    cardioSnelheid: '{waarde} km/u',
    cardioHelling: '{waarde}% helling',
    cardioWeerstand: 'weerstand {waarde}',
    cardioHartslag: '{waarde} bpm',
    cardioKcal: '{waarde} kcal',
    aandachtspunt: 'Let op: {tekst}',
    meerLaden: 'Meer sessies laden',
    aantalGetoond: '{getoond} van {totaal} sessies getoond',
  },
  recipes: {
    title: 'Recepten',
    subtitle: 'Beheer de receptenbibliotheek',
    nieuw: '+ Nieuw recept',
    zoekPlaceholder: 'Zoeken op naam…',
    alleEetmomenten: 'Alle eetmomenten',
    toonInactief: 'Toon inactief',
    colNaam: 'Naam',
    colEetmoment: 'Eetmoment',
    colKcal: 'Kcal',
    colEiwitten: 'Eiwitten',
    colKoolhydraten: 'Koolhydraten',
    colVetten: 'Vetten',
    colAvondetenComponent: 'Avondeten component',
    colStatus: 'Status',
    colActies: 'Acties',
    badgeActief: 'Actief',
    badgeInactief: 'Inactief',
    bewerken: 'Bewerken',
    deactiveren: 'Deactiveren',
    activeren: 'Activeren',
    geenRecepten: 'Geen recepten gevonden.',
    modalTitelNieuw: 'Nieuw recept',
    modalTitelBewerken: 'Recept bewerken',
    labelNaam: 'Naam',
    labelEetmoment: 'Eetmomenten',
    labelKcal: 'Kcal',
    labelEiwitten: 'Eiwitten (gram)',
    labelKoolhydraten: 'Koolhydraten (gram)',
    labelVetten: 'Vetten (gram)',
    labelBeschrijving: 'Beschrijving (optioneel)',
    labelAvondetenComponent: 'Is avondeten component',
    labelComponentType: 'Component type',
    kiesComponentType: 'Kies een component type…',
    optioneel: 'optioneel',
    opslaan: 'Opslaan',
    annuleren: 'Annuleren',
    deactiverenTitel: 'Recept deactiveren',
    deactiverenTekst: 'Weet je zeker dat je dit recept wilt deactiveren? Het recept verdwijnt uit de keuzelijsten maar blijft zichtbaar in bestaande schema\'s.',
    deactiverenBevestigen: 'Ja, deactiveren',
    foutLaden: 'Fout bij laden recepten: ',
    foutOpslaan: 'Fout bij opslaan recept: ',
    valNaam: 'Naam is verplicht.',
    valEetmoment: 'Selecteer minimaal 1 eetmoment.',
    valKcal: 'Voer een geldig kcal-getal in.',
    badgeExtended: 'uitgebreid',
    colType: 'Type',
    recipeTypeLabel: 'Type recept',
    recipeTypeBasis: 'Basis',
    recipeTypeUitgebreid: 'Uitgebreid',
    labelVideoUrl: 'Video-URL',
    labelPhotos: "Foto's",
    addPhoto: 'Foto toevoegen',
    uploadingPhoto: 'Foto uploaden…',
    coverPhotoBadge: 'Omslagfoto',
    removePhoto: 'Foto verwijderen',
    movePhotoUp: 'Naar voren',
    movePhotoDown: 'Naar achteren',
    noPhotos: "Nog geen foto's toegevoegd.",
    photoUploadError: 'Foto uploaden is mislukt.',
    labelPrepTime: 'Voorbereidingstijd (min)',
    labelCookTime: 'Bereidingstijd (min)',
    labelDifficulty: 'Moeilijkheidsgraad',
    kiesDifficulty: 'Kies een moeilijkheidsgraad…',
    difficultyMakkelijk: 'Makkelijk',
    difficultyGemiddeld: 'Gemiddeld',
    difficultyMoeilijk: 'Moeilijk',
    labelServings: 'Aantal personen',
    labelIngredients: 'Ingrediënten',
    addIngredient: '+ Ingrediënt',
    ingredientNamePlaceholder: 'Naam (bijv. Rijst)',
    ingredientAmountPlaceholder: 'Hoeveelheid',
    ingredientUnitPlaceholder: 'Eenheid (bijv. g)',
    labelSteps: 'Bereidingsstappen',
    addStep: '+ Stap',
    stepTitlePlaceholder: 'Titel (optioneel)',
    stepInstructionPlaceholder: 'Instructie *',
    stepDurationPlaceholder: 'Tijdsduur (seconden, optioneel)',
    extendedRequiresStep: 'Een uitgebreid recept vereist minstens 1 bereidingsstap met instructie.',
    removeItem: 'Verwijderen',
    terug: '← Terug naar recepten',
    dragHandle: 'Sleep om te herordenen',
    verlatenTitel: 'Pagina verlaten?',
    verlatenTekst: 'Je hebt niet-opgeslagen wijzigingen. Als je nu teruggaat, gaan deze verloren.',
    verlatenBevestigen: 'Ja, verlaten zonder opslaan',

    // Cliënt-voedingsmodule (VoedingPage/WeekschemaPage/RecipeDetailPage) —
    // zelfde backend/RPC's en tekst als de app (DagschemaScreen.js/
    // WeekschemaScreen.js/RecipeDetailScreen.js), zie BRIEFING.md hfst. 7.
    mealBreakfast: 'Ontbijt',
    mealSnackMorning: 'Tussendoor 1',
    mealLunch: 'Lunch',
    mealSnackAfternoon: 'Tussendoor 2',
    mealDinner: 'Avondeten',
    mealEveningSnack: 'Avondsnack',
    dinnerProteinLabel: 'Vlees / Vis',
    dinnerCarbsLabel: 'Koolhydraten',
    dinnerVegetablesLabel: 'Groente',
    dagKort: { 0: 'Zo', 1: 'Ma', 2: 'Di', 3: 'Wo', 4: 'Do', 5: 'Vr', 6: 'Za' },
    // Volledige, kleine-letter dagnaam voor "Totaal {dag}"/"Kopieer {dag}…" —
    // de dagselector/startdag-instelling blijft bewust op dagKort (afkortingen).
    dagVol: { 0: 'zondag', 1: 'maandag', 2: 'dinsdag', 3: 'woensdag', 4: 'donderdag', 5: 'vrijdag', 6: 'zaterdag' },

    voedingTitle: 'Voeding',
    voedingSubtitle: 'Jouw eetmomenten van vandaag',
    kcalUsed: 'Verbruikt',
    kcalGoal: 'Doel',
    kcalRemaining: 'Resterend',
    kcalPctGoal: '{pct}% van dagdoel',
    mealsSectionTitle: 'Eetmomenten',
    notYetChosen: 'Nog niet gekozen',
    kcalLeftOver: '{kcal} kcal over',
    viewWeekschema: 'Weekschema bekijken & aanpassen',
    removeMealAction: 'Verwijderen',
    removeMealTitel: 'Maaltijdkeuze verwijderen?',
    removeMealTekst: 'Weet je zeker dat je deze keuze wilt verwijderen?',
    currentChoice: 'Huidige keuze',
    chooseParts: 'Kies alle onderdelen',
    allPartsRequired: 'Selecteer een optie voor vlees/vis, koolhydraten en groente.',
    dinnerHintText: 'Kies één optie uit elk onderdeel. Het totaal is altijd 450 kcal.',
    allChosen: 'Alle 3 onderdelen gekozen · Totaal 450 kcal',
    saveDinner: 'Avondeten opslaan',
    tooMuchKcal: 'Te veel kcal voor dit moment',
    noRecipesAvailable: 'Geen recepten beschikbaar',
    noRecipesSub: 'De coach heeft nog geen recepten toegevoegd voor dit eetmoment.',
    membershipRequiredTitel: 'Actief abonnement vereist',
    membershipRequiredTekst: 'Je hebt nog geen actief abonnement. Neem contact op met je coach om de voedingsmodule te gebruiken.',
    kiezenAction: 'Kiezen',
    foutOpslaanKeuze: 'Fout bij opslaan keuze: ',
    notFilledIn: 'Niet ingevuld',
    todayLabel: 'Vandaag',
    yesterdayLabel: 'Gisteren',
    previousDay: 'Vorige dag',
    nextDay: 'Volgende dag',
    openCalendar: 'Kalender openen',
    calendarTitle: 'Kalender',
    calendarPrevMonth: 'Vorige maand',
    calendarNextMonth: 'Volgende maand',

    weekschemaTitle: 'Weekschema',
    settingsTitle: 'Schema instellingen',
    recurring: 'Herhalend',
    recurringDesc: 'Elke week hetzelfde',
    oneTime: 'Eenmalig',
    oneTimeDesc: 'Alleen deze week',
    startDayLabel: 'Startdag van de week',
    saveSettings: 'Instellingen opslaan',
    savedTitel: '✓ Opgeslagen',
    savedRecurring: 'Je weekschema herhaalt zich elke week.',
    savedOneTime: 'Je weekschema geldt voor deze week. Je ontvangt een herinnering om het volgende week opnieuw in te stellen.',
    daySection: 'Dag instellen',
    notSet: 'Niet ingesteld',
    totalLabel: 'Totaal {day}',
    copyBtn: 'Kopieer {day} naar alle andere dagen',
    copyTitel: 'Kopiëren',
    copyMsg: 'Maaltijden van {day} kopiëren naar alle andere dagen?',
    copyAction: 'Kopiëren',
    copiedTitel: '✓ Gekopieerd',
    copiedMsg: 'Maaltijden zijn gekopieerd naar alle andere dagen.',
    conflictTitel: 'Er staan al voedingskeuzes voor deze week',
    conflictTekst: 'Voor {count} dag(en) deze week zijn al voedingskeuzes vastgelegd. Wat wil je doen?',
    conflictOverwrite: 'Overschrijf de {count} al ingevulde dagen met dit weekschema',
    conflictKeepExisting: 'Laat de al ingevulde dagen ongewijzigd, pas de rest van de week toe',
    weekschemaKonNietWordenAangemaakt: 'Weekschema kon niet worden aangemaakt.',

    recipeDetailTerug: '← Terug',
    prepTime: '{min} min voorbereiding',
    cookTime: '{min} min bereiding',
    servings: '{count} personen',
    macrosLabel: 'Voedingswaarden',
    caloriesLabel: 'Calorieën',
    proteinLabel: 'Eiwitten',
    carbsLabel: 'Koolhydraten',
    fatLabel: 'Vetten',
    ingredientsTitle: 'Ingrediënten',
    stepsTitle: 'Bereiding',
    chooseAction: 'Kiezen voor vandaag',
    startCooking: 'Start met koken',
    noRecipes: 'Geen recepten beschikbaar.',
    stepProgress: 'Stap {current} van {total}',
    stepPrev: '← Vorige',
    stepNext: 'Volgende →',
    stepDone: '✓ Klaar met koken',
    timerStart: 'Zet timer aan',
    timerStop: 'Pauzeer timer',
    fotoVolledigWeergaveSluiten: 'Sluiten',
  },
  beheer: {
    profielTitel: 'Mijn coachprofiel',
    profielSubtitel: 'Beheer je zichtbare profiel, agenda, meldingen en accountbeveiliging',
    locatiesTitel: 'Locaties',
    locatiesSubtitel: 'Beheer de locaties waar trainingen en afspraken plaatsvinden',
    organisatieTitel: 'Organisatie-instellingen',
    organisatieSubtitel: 'Beheer organisatiebrede gegevens, regels en automatisering',
    organisatieNavigatie: 'Onderdelen van organisatie-instellingen',
    bedrijfsgegevens: 'Bedrijfsgegevens',
    facturatieBetalingen: 'Facturatie en betalingen',
    automatisering: 'Automatisering',
    creditsTrainingen: 'Credits en trainingen',
    portaalBranding: 'Portaal en branding',
    juridisch: 'Juridisch',
    communicatieNavigatie: 'Onderdelen van communicatiebeheer',
    emailteksten: 'E-mailteksten',
    factuurteksten: 'Factuur- en PDF-teksten',
    voorbeeld: 'Voorbeeld',
    voorbeeldUitleg: 'Voorbeeldgegevens laten zien waar deze tekst terechtkomt.',
    voorbeeldKlant: 'Sanne de Vries',
    voorbeeldOnderwerp: 'Bericht van Fit En Sterker',
    factuurVoorbeeldTitel: 'Factuurvoorbeeld',
    factuurVoorbeeldNummer: 'Factuur 2026-0042',
    factuurVoorbeeldKlant: 'Sanne de Vries',
    factuurVoorbeeldBedrag: '€ 79,95',
    factuurVoorbeeldRegel: 'Personal training',
  },
  abonnementen: {
    title: 'Abonnementen',
    subtitle: 'Beheer pakketten, looptijdprijzen en beschikbaarheid',
    beheerLink: 'Beheer abonnementen',
    sectionTitel: 'Abonnementen / pakketten',
    nieuwType: '+ Nieuw abonnementstype',
    geenAbonnementen: 'Nog geen abonnementstypes aangemaakt.',
    toonInactief: 'Toon inactief',
    colNaam: 'Naam',
    colCredits: 'Credits/periode',
    colStatus: 'Status',
    colActies: 'Acties',
    badgeActief: 'Actief',
    badgeInactief: 'Inactief',
    deactiveren: 'Deactiveren',
    activeren: 'Activeren',
    typeModalTitelNieuw: 'Nieuw abonnementstype',
    typeModalTitelBewerken: 'Abonnementstype bewerken',
    typeModalTitelDupliceren: 'Abonnementstype dupliceren',
    labelNaam: 'Naam',
    labelCredits: 'Credits per periode',
    labelBtw: 'BTW-percentage',
    btwOptie9: '9%',
    btwOptie21: '21%',
    labelActief: 'Actief',
    opslaan: 'Opslaan',
    annuleren: 'Annuleren',
    foutLaden: 'Fout bij laden abonnementen: ',
    foutOpslaan: 'Fout bij opslaan: ',
    foutDeactiveren: 'Fout bij deactiveren: ',
    foutActieveKoppelingen: 'Dit type kan niet worden verwijderd omdat er nog actieve abonnementen aan gekoppeld zijn.',
    validatieNaam: 'Naam is verplicht.',
    validatieCredits: 'Credits per periode is verplicht.',
    labelOvereenkomst: 'Overeenkomsttekst (optioneel)',
    overeenkomstHint: 'Template voor digitale overeenkomst. Gebruik variabelen om gegevens automatisch in te vullen:',
    overeenkomstPlaceholder: 'Typ hier de overeenkomsttekst. Gebruik [naam], [abonnement], [prijs], [looptijd], [datum] en [bedrijfsnaam] als variabelen.',
    staffelsTitel: 'Staffels',
    staffelToevoegen: '+ Staffel toevoegen',
    staffelModalTitel: 'Staffel toevoegen',
    staffelModalBewerken: 'Staffel bewerken',
    labelDurationMonths: 'Looptijd',
    labelPricePerPeriod: 'Prijs per periode excl. BTW (€)',
    inclBtwPreview: 'Incl. BTW:',
    labelStaffelActief: 'Actief',
    labelPromoLabel: 'Promotielabel (optioneel)',
    promoLabelPlaceholder: 'bv. 1 maand gratis',
    promoLabelHint: 'Wordt getoond als badge op de overeenkomstpagina.',
    colPromo: 'Promo',
    staffelOpslaan: 'Opslaan',
    staffelAnnuleren: 'Annuleren',
    staffelFoutOpslaan: 'Fout bij opslaan staffel: ',
    staffelFoutLaden: 'Fout bij laden staffels: ',
    staffelAlBestaat: 'Er bestaat al een staffel voor deze looptijd.',
    validatiePrijs: 'Prijs is verplicht.',
    validatieDuur: 'Kies een looptijd.',
    duur1: '1 maand',
    duur3: '3 maanden',
    duur6: '6 maanden',
    duur12: '12 maanden',
    geenStaffels: 'Nog geen staffels. Voeg een staffel toe om prijzen in te stellen.',
    colStaffelDuur: 'Looptijd',
    colStaffelPrijs: 'Prijs excl. BTW',
    colStaffelPrijsIncl: 'Prijs incl. BTW',
    colStaffelStatus: 'Status',
    colStaffelActies: 'Acties',
    staffelDeactiveren: 'Deactiveren',
    staffelActiveren: 'Activeren',
    kiesLooptijd: 'Kies looptijd…',
    labelDescription: 'Omschrijving (optioneel)',
    descriptionPlaceholder: 'Korte omschrijving van dit abonnementstype…',
    labelPricePerMonth: 'Klantprijs per maand incl. btw (€)',
    labelPricePerPeriod2: 'Klantprijs totale looptijd incl. btw (€)',
    labelVatRate: 'BTW-percentage',
    btwOptie0: '0%',
    labelAvailableFrom: 'Beschikbaar vanaf',
    labelAvailableUntil: 'Beschikbaar t/m',
    labelPaymentFrequency: 'Betaalfrequentie',
    payFreqMonth: 'Alleen maandbetaling',
    payFreqPeriod: 'Alleen periodebetaling (eenmalig)',
    payFreqBoth: 'Beide toegestaan (client kiest)',
    labelPriceExclBtw: 'Prijs excl. BTW',
    labelPriceInclBtw: 'Prijs incl. BTW',
    warnVerstrekenStaffel: 'Let op: de einddatum van beschikbaarheid is verstreken. Bestaande contracten blijven geldig.',
    warnVerstrekenStaffelModal: 'Let op: de einddatum ligt in het verleden. Deze staffel is niet meer kiesbaar voor nieuwe lidmaatschappen. Je kunt nog steeds opslaan; bestaande contracten blijven geldig.',
    verstrekenTooltip: 'Deze staffel is verlopen en niet meer kiesbaar voor nieuwe lidmaatschappen. Bestaande contracten blijven geldig.',
    validatieLooptijdMin: 'Looptijd moet minimaal 1 maand zijn.',
    validatiePricePerMonth: 'Prijs per maand is verplicht.',
    inklappen: 'Inklappen',
    uitklappen: 'Uitklappen',
    btwLabel: 'BTW',
    colTotaal: 'Totaal',
    colExclBtw: 'Excl. BTW',
    colBetaalfreq: 'Betaalfreq.',
    colKorting: 'Korting',
    colBeschikbaar: 'Beschikbaar',
    altijdBeschikbaar: 'Altijd',
    perMaand: '/mnd',
    verstrekenLabel: 'VERSTREKEN',
    labelPeriodDiscountPct: 'Korting bij periodebetaling (%)',
    periodDiscountHint: '0 = geen korting. Alleen van toepassing bij periode- of gecombineerde betaling.',
    labelSessionType: 'Sessietype',
    sessionTypePt: '1-op-1 Personal Training',
    sessionTypePtPlus: '1-op-2 Personal Training',
    sessionTypeSmallGroup: 'Small Group Training',
    labelPtSessionsPerWeek: 'Aantal PT-sessies per week',
    labelPtPlusSessionsPerWeek: 'Aantal PT-plus-sessies per week',
    labelSmallGroupSessionsPerWeek: 'Aantal Small Group-sessies per week',
    labelSessionDuration: 'Sessieduur',
    creditsPerMaandLabel: 'credits per maand',
    creditsPerWeekLabel: '{{aantal}} credits per week',
    creditsPerMaandInfo: 'circa {{aantal}} per maand',
    creditVervalLabel: 'Vervaltermijn van credits',
    creditVervalVolgSysteem: 'Volg systeeminstelling (nu: {{waarde}})',
    creditVervalVolgSysteemLaden: 'Volg systeeminstelling',
    creditVervalEigen: 'Eigen vervaltermijn voor dit abonnementstype',
    creditVervalEenheid: 'Eenheid van de vervaltermijn',
    creditVervalEenheidWeken: 'weken',
    creditVervalEenheidMaanden: 'maanden',
    creditVervalWeken: '{{aantal}} weken',
    creditVervalMaanden: '{{aantal}} maanden',
    creditVervalHint: 'Credits worden wekelijks toegekend en vervallen na deze termijn. De termijn wordt vastgelegd op het moment van toekennen — een latere wijziging raakt alleen nieuwe credits, nooit de credits die een cliënt al heeft.',
    validatieCreditVerval: 'Vul een vervaltermijn van minimaal 1 in.',
    validatieSessies: 'Vul het aantal sessies per week in (minimaal 1).',
    validatieSessieDuur: 'Kies een sessieduur (30 of 60 minuten).',
    colSessiesPerWeek: 'Sessies/week',
    labelClientSelectable: 'Zichtbaar voor client',
    clientSelectableHint: 'Uitvinken = alleen coach kan dit abonnement toewijzen (bv. bonusabonnement)',
    labelIsRecommended: 'Markeer als aanbevolen',
    isRecommendedHint: 'Toont een groene "Aanbevolen"-badge op de kaart in de overeenkomstpagina (stap 1)',
    labelSelfLoggingDefault: 'Cliënten mogen zelfstandig trainingen loggen',
    selfLoggingDefaultHint: 'Alleen actief zolang de instelling "Zelfstandig loggen" systeembreed aan staat. Per cliënt te overrulen op de cliëntdetailpagina.',
    sectionBonussen: 'Bonus bij afsluiten',
    bonusGratisLabel: 'Automatisch inbegrepen bij afsluiten',
    bonusBetaaldLabel: 'Optioneel toe te voegen bij afsluiten',
    bonusToevoegen: '+ Bonus toevoegen',
    bonusVerwijderen: 'Verwijderen',
    bonusType: 'Bonusabonnement',
    bonusPrijs: 'Prijsoverride (€)',
    bonusPrijsHint: 'Leeg = staffelprijs, 0 = gratis',
    bonusGeenTypes: 'Geen andere abonnementstypes beschikbaar.',
    bonusFoutLaden: 'Fout bij laden bonussen: ',
    bonusFoutOpslaan: 'Fout bij opslaan bonus: ',
    bonusKiesType: 'Kies abonnementstype…',
    sectionPt: '1-op-1 Personal Training',
    sectionPtPlus: '1-op-2 Personal Training',
    sectionSmallGroup: 'Small Group Training',
    sectionGeenTypes: 'Nog geen abonnementen voor dit type.',
    sectionNieuwVoorType: '+ Nieuw abonnementstype',
    sectionPtHint: 'Reguliere 1-op-1 PT-sessies',
    sectionPtPlusHint: 'Twee clients trainen samen met één coach',
    sectionSmallGroupHint: 'Groepstrainingen voor kleine groepen',
    overzichtTitel: 'Status van het aanbod',
    actieveTypes: 'actieve abonnementstypes',
    zichtbaarVoorKlanten: 'zichtbaar voor klanten',
    aandachtspunten: 'aandachtspunten',
    zoekenLabel: 'Abonnementen zoeken',
    zoekenPlaceholder: 'Zoek op naam of omschrijving…',
    zichtbaarheidFilter: 'Filter op zichtbaarheid',
    filterAlle: 'Alle abonnementen',
    filterClient: 'Zichtbaar voor klanten',
    filterCoach: 'Alleen via coach',
    geenFilterResultaten: 'Geen abonnementen gevonden met deze filters.',
    colKlantprijs: 'Klantprijs',
    colKlantprijsIncl: 'Klantprijs incl. btw',
    vanafPrijs: 'Vanaf {{prijs}}/mnd',
    actiefLid: 'actief lid',
    actieveLeden: 'actieve leden',
    perWeek: 'per week',
    alleenViaCoach: 'Alleen via coach',
    aanbevolenKort: 'Aanbevolen',
    aandachtNodigEen: '1 aandachtspunt',
    aandachtNodigMeerdere: '{{aantal}} aandachtspunten',
    waarschuwingGeenOvereenkomst: 'Overeenkomsttekst ontbreekt',
    waarschuwingGeenPrijs: 'Geen actieve, beschikbare prijsstaffel',
    systeemstandaard: 'standaard vervaltermijn',
    maandenKort: 'maanden',
    wekenKort: 'weken',
    actiesVoor: 'Acties voor {{naam}}',
    dupliceren: 'Dupliceren',
    kopieNaam: 'Kopie van {{naam}}',
    deactiverenTitel: 'Abonnementstype deactiveren',
    activerenTitel: 'Abonnementstype activeren',
    deactiverenImpactEen: 'Je deactiveert {{naam}} voor nieuwe abonnementen. 1 actief lidmaatschap blijft ongewijzigd doorlopen.',
    deactiverenImpactMeerdere: 'Je deactiveert {{naam}} voor nieuwe abonnementen. {{aantal}} actieve lidmaatschappen blijven ongewijzigd doorlopen.',
    activerenImpact: '{{naam}} wordt opnieuw beschikbaar volgens de ingestelde zichtbaarheid en prijsstaffels.',
    foutStatusWijzigen: 'Status van abonnementstype kon niet worden gewijzigd: ',
    duurMaand: '{{aantal}} maand',
    duurMaanden: '{{aantal}} maanden',
    betaalfrequentieMaand: 'Maand',
    betaalfrequentiePeriode: 'Periode',
    betaalfrequentieBeide: 'Beide',
    sectieInklappen: '{{naam}} inklappen',
    sectieUitklappen: '{{naam}} uitklappen',
    labelDurationMonthsDetail: 'Looptijd in maanden',
    modelUitlegTitel: 'Zo is het aanbod opgebouwd',
    modelPakket: 'Pakket',
    modelPakketUitleg: ' bepaalt sessies, credits en overeenkomsttekst.',
    modelPrijs: 'Looptijdprijs',
    modelPrijsUitleg: ' bepaalt duur, klantprijs en betaalwijze.',
    modelLidmaatschap: 'Lidmaatschap',
    modelLidmaatschapUitleg: ' is het actieve abonnement van één klant.',
  },
  coachInstellingen: {
    title: 'Instellingen',
    subtitle: 'Jouw persoonlijke agenda-koppeling',
    sectionCalFeed: 'Google Agenda koppeling',
    intro: 'Abonneer op jouw persoonlijke agenda-feed en zie al je lessen en PT-afspraken direct in Google Agenda.',
    urlLabel: 'Jouw agenda-URL',
    kopierenKnop: 'Kopieer',
    gekopieerd: '✓ Gekopieerd!',
    geenToken: 'Nog geen agenda-URL gegenereerd.',
    generaterenKnop: 'Agenda-URL genereren',
    generaterenBezig: 'Genereren…',
    vernieuwenKnop: 'Link vernieuwen',
    vernieuwenWaarschuwing: 'Weet je zeker dat je de link wilt vernieuwen? Je bestaande Google Agenda-abonnement stopt dan — je moet de nieuwe URL opnieuw toevoegen.',
    vernieuwenBevestigen: 'Ja, vernieuwen',
    vernieuwenAnnuleren: 'Annuleren',
    instructieTitel: 'Zo voeg je de feed toe aan Google Agenda:',
    stap1: '1. Ga naar Google Agenda op je computer (calendar.google.com)',
    stap2: '2. Klik links op het + naast "Andere agenda\'s"',
    stap3: '3. Kies "Via URL"',
    stap4: '4. Plak de bovenstaande URL en klik op "Agenda toevoegen"',
    stap5: '5. Google Agenda vernieuwt de feed automatisch (elke paar uur)',
    foutLaden: 'Fout bij ophalen agenda-URL: ',
    foutGenereren: 'Fout bij genereren agenda-URL: ',
    foutKopieren: 'Kopiëren naar het klembord is mislukt. Selecteer de URL hierboven en kopieer hem handmatig.',
  },
  pushCat: {
    title: 'Meldingen',
    introCoach: 'Bepaal hier welke pushmeldingen je van de app ontvangt.',
    introClient: 'Bepaal hier welke pushmeldingen je van de app ontvangt.',
    alwaysOn: 'Bepaalde belangrijke meldingen (account, betalingen en wettelijk verplichte meldingen) worden altijd verstuurd, ongeacht deze instellingen.',
    foutLaden: 'Fout bij ophalen instellingen: ',
    foutOpslaan: 'Instelling kon niet worden opgeslagen: ',
    lessonsScheduleLabel: 'Groepslessen',
    lessonsScheduleDesc: 'Wachtlijstpromoties, gewijzigde of geannuleerde lessen en herinschrijvingen.',
    ptAppointmentsLabel: 'PT-afspraken',
    ptAppointmentsDesc: 'Nieuwe, bevestigde, afgewezen of gewijzigde PT-afspraken en -aanvragen.',
    billingLabel: 'Facturatie',
    billingDesc: 'Aanmaningen en herinneringen over openstaande facturen en je prolongatie.',
    agreementsLabel: 'Overeenkomsten',
    agreementsDesc: 'Uitnodigingen om een overeenkomst te ondertekenen en herinneringen daaraan.',
    coachMessagesLabel: 'Berichten van je coach',
    coachMessagesDesc: 'Persoonlijke en motiverende berichten die je coach je stuurt.',
    clientActivityLabel: 'Cliëntactiviteit',
    clientActivityDesc: 'Meldingen over activiteit van je cliënten, zoals een herinnering wanneer een PT-sessie nog niet is gelogd.',
  },
  coachBio: {
    title: 'Korte introductie',
    intro: 'Cliënten zien deze tekst bij de trainingsdetails van jouw trainingen.',
    label: 'Jouw introductie',
    placeholder: 'Bijv. specialisatie, ervaring of stijl',
    counter: '{{count}}/{{max}} tekens',
    opslaanKnop: 'Introductie opslaan',
    succes: 'Introductie opgeslagen.',
    fout: 'Kon introductie niet opslaan: ',
    fotoLabel: 'Profielfoto',
    fotoKiezen: 'Afbeelding kiezen',
    fotoUploaden: 'Uploaden…',
    fotoHint: 'JPG, PNG of WebP, maximaal 5 MB. De foto verschijnt bij trainingsdetails.',
    fotoSucces: 'Profielfoto opgeslagen.',
    fotoFout: 'Kon de afbeelding niet uploaden.',
  },
  wachtwoordWijzigen: {
    title: 'Wachtwoord wijzigen',
    intro: 'Kies een nieuw wachtwoord voor je account.',
    labelNieuw: 'Nieuw wachtwoord',
    placeholderNieuw: 'Min. 6 tekens',
    labelHerhaal: 'Herhaal nieuw wachtwoord',
    opslaanKnop: 'Wachtwoord opslaan',
    succes: 'Wachtwoord gewijzigd.',
    fout: 'Fout bij wijzigen wachtwoord: ',
    foutTeKort: 'Het nieuwe wachtwoord moet minimaal 6 tekens bevatten.',
    foutMismatch: 'De wachtwoorden komen niet overeen.',
  },
  wachtwoordReset: {
    laden: 'Bezig met controleren van je link...',
    titel: 'Nieuw wachtwoord instellen',
    intro: 'Kies hieronder een nieuw wachtwoord voor je account.',
    labelNieuw: 'Nieuw wachtwoord',
    placeholderNieuw: 'Min. 6 tekens',
    labelHerhaal: 'Herhaal nieuw wachtwoord',
    opslaanKnop: 'Wachtwoord opslaan',
    foutTeKort: 'Het nieuwe wachtwoord moet minimaal 6 tekens bevatten.',
    foutMismatch: 'De wachtwoorden komen niet overeen.',
    foutZelfdeWachtwoord: 'Dit is hetzelfde als je huidige wachtwoord. Kies een ander wachtwoord.',
    foutOnbekend: 'Er ging iets mis bij het opslaan van je nieuwe wachtwoord. Probeer het opnieuw of vraag een nieuwe resetlink aan.',
    succesTitel: 'Wachtwoord gewijzigd',
    succesUitleg: 'Je wachtwoord is succesvol gewijzigd. Je wordt doorgestuurd naar de inlogpagina...',
    succesNaarInloggen: 'Ga direct naar inloggen',
    ongeldigTitel: 'Link verlopen of ongeldig',
    ongeldigUitleg: 'Deze link om je wachtwoord opnieuw in te stellen is verlopen of al gebruikt. Vraag in de app via "Wachtwoord vergeten" een nieuwe link aan.',
    naarInloggen: 'Naar inloggen',
  },
  opzegMailInstelling: {
    title: 'E-mail bij opzegging',
    intro: 'Bepaal of je een e-mail ontvangt wanneer een aan jou gekoppelde cliënt een abonnement opzegt.',
    label: 'Ontvang een e-mail bij opzegging van een gekoppelde cliënt',
    foutLaden: 'Fout bij ophalen instelling: ',
    foutOpslaan: 'Instelling kon niet worden opgeslagen: ',
  },
  privateAgendaKoppeling: {
    title: 'Privé-agenda koppelen',
    intro: 'Koppel je privé-agenda (Google, Outlook of iCloud) zodat bij het inplannen van een afspraak automatisch wordt gecheckt op conflicten met je privéafspraken.',
    urlLabel: 'ICS-URL van je privé-agenda',
    instructieTitel: 'Zo vind je de geheime iCal-URL:',
    instructieGoogle: 'Google Agenda: Instellingen → jouw agenda → "Geheime adres in iCal-indeling"',
    instructieOutlook: 'Outlook: Instellingen → Agenda → Gedeelde agenda\'s → "ICS-koppeling publiceren"',
    instructieIcloud: 'iCloud: iCloud.com Agenda → Deel agenda → "Openbare agenda" → kopieer de webcal-link (vervang webcal:// door https://)',
    labelShareDetails: 'Details van privé-afspraken delen',
    hintShareDetails: 'Indien aan: wie voor jou inplant ziet de titel van een conflicterende privé-afspraak. Indien uit: alleen "Bezet (privé-agenda)" zonder details.',
    laatsteSyncLabel: 'Laatst gesynchroniseerd:',
    syncStatusSuccess: 'gelukt',
    syncStatusError: 'mislukt',
    syncNuKnop: 'Nu synchroniseren',
    syncBezig: 'Synchroniseren…',
    syncGelukt: 'Privé-agenda gesynchroniseerd.',
    foutSync: 'Fout bij synchroniseren: ',
    opslaanKnop: 'Opslaan',
    opgeslagen: 'Instellingen opgeslagen.',
    foutOpslaan: 'Fout bij opslaan: ',
    foutLaden: 'Fout bij ophalen instellingen: ',
    foutLegeUrl: 'Vul een ICS-URL in.',
  },
  conflicten: {
    titel: 'Roosterconflict gedetecteerd',
    beschrijving: 'De volgende afspraken/lessen van de coach overlappen met dit tijdvak:',
    typeGroepsles: 'Groepsles',
    typePT: 'PT-afspraak',
    bevestigenKnop: 'Toch opslaan',
    annulerenKnop: 'Annuleren',
    checkFout: 'Fout bij conflictcontrole: ',
    typePrivateAgenda: 'Privé-agenda',
    privateAgendaBusy: 'Bezet (privé-agenda)',
    acceptBevestigenKnop: 'Toch accepteren',
  },
  beschikbaarheid: {
    titel: 'Beschikbaarheid',
    laden: 'Beschikbaarheid laden...',
    foutLaden: 'Fout bij ophalen beschikbaarheid: ',
    legeSlot: 'Vrij',
    bezetRooster: 'Bezet (rooster)',
    bezetPrive: 'Bezet (privé-agenda)',
    klikOmTeKiezen: 'Klik op een vrij tijdslot om te kiezen',
    gekozenTijdstip: 'Gekozen tijdstip',
    gekozenConflict: 'Let op: het gekozen tijdstip overlapt met bovenstaande bezetting.',
    geenVrijeSlotsVandaag: 'Geen vrije tijdsloten op deze dag.',
    eerstvolgendeBeschikbaarheid: 'Eerstvolgende beschikbaarheid: ',
    vorigePeriode: '←',
    volgendePeriode: '→',
  },
  coachPush: {
    nieuweLes: 'Nieuwe les voor jou ingepland',
    nieuweLesBody: '{naam} op {datum}',
    lesGewijzigd: 'Les gewijzigd',
    lesGewijzigdBody: '{naam} op {datum} is bijgewerkt.',
    reeksGewijzigd: 'Reeks gewijzigd',
    reeksGewijzigdBody: 'Reeks \'{naam}\' is bijgewerkt.',
    lesGeannuleerd: 'Les geannuleerd',
    lesGeannuleerdBody: '{naam} op {datum} is geannuleerd.',
  },
  lesFormulier: {
    selecteerLocatie: '— selecteer locatie —',
    selecteerCoach: '— selecteer coach —',
    jij: ' (jij)',
    begindatumReeks: 'Begindatum reeks',
    starttijdLabel: 'Starttijd {dag}',
    wijzigen: 'wijzigen',
    markAsTrial: 'Dit is een proefsessie',
  },
  admin: {
    noLocations: 'Geen locaties gevonden',
    addLocation: 'Locatie toevoegen',
    editLocation: 'Locatie bewerken',
    newLocation: 'Nieuwe locatie',
    locationName: 'Naam',
    locationNamePlaceholder: 'Bijv. Sporthal Noord',
    locationStreet: 'Straat',
    locationStreetPlaceholder: 'Bijv. Sportlaan',
    locationHouseNumber: 'Huisnummer',
    locationHouseNumberPlaceholder: 'Bijv. 1',
    locationPostalCode: 'Postcode',
    locationPostalCodePlaceholder: 'Bijv. 1234 AB',
    locationCity: 'Woonplaats',
    locationImageUrl: 'Locatieafbeelding',
    locationCityPlaceholder: 'Bijv. Amsterdam',
    inactive: 'Inactief',
    deactivate: 'Deactiveren',
    activate: 'Activeren',
    locationToggleConfirm: '{action} \'{name}\'?',
    locationToggleTitel: 'Locatie bijwerken',
    showInactive: 'Toon inactieve',
    hideInactive: 'Verberg inactieve',
    annuleren: 'Annuleren',
    opslaan: 'Opslaan',
  },
  factuurteksten: {
    title: 'Factuurteksten',
    subtitle: 'Beheer alle teksten die op facturen en herinneringen verschijnen',
    algemeenTitel: 'Algemene factuurvoetnoot',
    labelAlgemeneVoetnoot: 'Algemene factuurvoetnoot',
    hintAlgemeen: 'Deze tekst verschijnt onderaan alle facturen, ongeacht de status.',
    voetnootTitel: 'Factuurvoetnoot per status',
    labelFooterDraft: 'Voetnoot bij concept',
    labelFooterSent: 'Voetnoot bij verzonden',
    labelFooterReminded: 'Voetnoot bij herinnerd',
    labelFooterFinalNotice: 'Voetnoot bij laatste aanmaning',
    labelFooterCollections: 'Voetnoot bij incasso',
    hintVoetnoot: 'Deze tekst verschijnt onderaan de factuur bij de bijbehorende status.',
    herinneringTitel: 'Herinnerings- en aanmaningsteksten',
    labelReminderPdfText: 'Herinneringstekst PDF',
    labelFinalNoticePdfText: 'Aanmaningstekst PDF',
    hintHerinnering: 'Deze tekst verschijnt in de PDF van de herinnering of aanmaning.',
    opslaan: 'Opslaan',
    opgeslagen: 'Factuurteksten opgeslagen.',
    foutLaden: 'Fout bij laden factuurteksten: ',
    foutOpslaan: 'Fout bij opslaan factuurteksten: ',
  },
  emailteksten: {
    title: 'E-mailteksten',
    subtitle: 'Beheer de teksten en templates die in automatische e-mails worden gebruikt',
    tekstveldenTitel: 'Tekstvelden',
    tekstveldenSubtitel: 'Stel de standaard teksten in per e-mailtype. Deze velden zijn beschikbaar voor admin_coach en superadmin.',
    variabelenTitel: 'Beschikbare variabelen',
    variabelenLegenda: '[naam], [bedrag], [factuurnummer], [betaaldatum], [bedrijfsnaam] — deze worden automatisch vervangen door de echte waarden.',
    labelAanhef: 'Aanhef (gedeeld)',
    hintAanhef: 'Gebruikt in alle e-mailtypes.',
    introTitel: 'Introductietekst per e-mailtype',
    labelIntroFactuur: 'Introductie — Factuur',
    labelIntroHerinnering: 'Introductie — Herinnering',
    labelIntroAanmaning: 'Introductie — Aanmaning',
    labelIntroIncasso: 'Introductie — Incasso',
    labelSlotgroet: 'Slotgroet (gedeeld)',
    hintSlotgroet: 'Gebruikt in alle e-mailtypes.',
    htmlTitel: 'HTML-templates (superadmin)',
    htmlSubtitel: 'Overschrijf de volledige e-mailtemplate per type. Alleen zichtbaar voor superadmin.',
    waarschuwingTitel: 'Let op',
    waarschuwingTekst: 'Dit overschrijft de volledige e-mailtemplate. Gebruik [naam], [bedrag], [factuurnummer], [betaaldatum], [bedrijfsnaam] als variabelen.',
    labelHtmlFactuur: 'HTML template — Factuur',
    labelHtmlHerinnering: 'HTML template — Herinnering',
    labelHtmlAanmaning: 'HTML template — Aanmaning',
    labelHtmlIncasso: 'HTML template — Incasso',
    opslaan: 'Opslaan',
    opgeslagen: 'Tekst opgeslagen.',
    opslagenTeksten: 'Tekstvelden opgeslagen.',
    opgeslagenHtml: 'HTML-templates opgeslagen.',
    foutLaden: 'Fout bij laden e-mailteksten: ',
    foutOpslaanTeksten: 'Fout bij opslaan tekstvelden: ',
    foutOpslaanHtml: 'Fout bij opslaan HTML-templates: ',
    tabAlgemeen: 'Algemeen',
    tabAlgemeenSubtitel: 'Aanhef en slotgroet worden in alle e-mailtypes gebruikt.',
    tabMailtypeSubtitel: 'Stel de introductietekst in voor dit e-mailtype.',
    beschikbareVariabelen: 'Beschikbare variabelen',
    klikOmTeKopieren: 'Klik om te kopiëren',
    klikChipHint: 'Klik op een variabele om hem naar het klembord te kopiëren.',
    variabelGekopieerdPrefix: 'Gekopieerd: ',
    tabOvereenkomstHerinnering: 'Herinnering — Overeenkomst',
    tabProspectHerinnering: 'Herinnering — Prospect',
    herinneringPerIndexUitleg: 'Elke herinnering heeft een eigen onderwerp en introtekst — nooit gedeeld met de andere herinneringen. Het aantal velden volgt het ingestelde maximum ({max}) op de instellingenpagina.',
    herinneringLabel: 'Herinnering {n}',
    labelOnderwerpHerinnering: 'Onderwerp',
    labelIntroHerinneringIndex: 'Introductietekst',
    geenMaximumIngesteld: 'Er is nog geen maximum aantal herinneringen ingesteld. Stel dit eerst in bij Instellingen.',
    bijlagenTitel: 'Vaste bijlage(n) bij deze herinnering',
    bijlagenUitleg: 'Deze bijlage(n) worden bij elke automatische verzending van dit herinneringsniveau meegestuurd. Niet per verzending kiesbaar.',
    bijlageUploaden: 'Bijlage toevoegen',
    bijlageVerwijderen: 'Verwijderen',
    geenBijlagen: 'Nog geen bijlage toegevoegd.',
    bijlageGeupload: 'Bijlage toegevoegd.',
    bijlageVerwijderd: 'Bijlage verwijderd.',
    foutBijlageUpload: 'Fout bij uploaden bijlage: ',
    foutBijlageVerwijderen: 'Fout bij verwijderen bijlage: ',
    foutBijlageType: 'Alleen PDF- of afbeeldingsbestanden (PDF, PNG, JPEG, WEBP) zijn toegestaan als bijlage.',
    foutBijlageGrootte: 'Bijlage is te groot — maximaal 10 MB toegestaan.',
    foutLadenHerinneringen: 'Fout bij laden herinneringsteksten: ',
    opgeslagenHerinneringen: 'Herinneringsteksten opgeslagen.',
    foutOpslaanHerinneringen: 'Fout bij opslaan herinneringsteksten: ',
  },
  welkomstmail: {
    stuurWelkomstmail: 'Welkomstmail versturen',
    checkboxLabel: 'Stuur welkomstmail naar deze client',
    bevestigingTitel: 'Welkomstmail versturen',
    bevestigingTekst: 'Wil je een welkomstmail sturen naar {naam}? De mail wordt verstuurd naar {email}.',
    versturen: 'Versturen',
    annuleren: 'Annuleren',
    succes: 'Welkomstmail verstuurd.',
    fout: 'Fout bij versturen welkomstmail: ',
    foutSessie: 'Sessie verlopen — log opnieuw in.',
  },
  instellingen_urls: {
    urlsTitel: 'App- en portaal-URL\'s',
    urlsSubtitel: 'Deze URL\'s worden gebruikt in welkomstmails en andere communicatie.',
    labelGymUrl: 'Webportaal URL',
    labelAppStoreUrl: 'App Store URL',
    labelPlayStoreUrl: 'Google Play URL',
    placeholderGymUrl: 'https://app.fitensterker.nl',
    placeholderAppStoreUrl: 'https://apps.apple.com/...',
    placeholderPlayStoreUrl: 'https://play.google.com/...',
  },
  broadcastPush: {
    title: 'Push notificaties',
    subtitle: 'Stuur een pushbericht naar een gefilterde groep cliënten en bekijk wat er eerder is verstuurd',

    tabNieuw: 'Nieuw bericht',
    tabGeschiedenis: 'Geschiedenis',

    sectionFilters: 'Filters',
    filterLocatie: 'Locatie (optioneel)',
    filterLocatiePlaceholder: 'Alle locaties',
    filterAbonnementstype: 'Abonnementstype (optioneel)',
    filterAbonnementstypePlaceholder: 'Alle abonnementen',
    filterCoach: 'Coach (optioneel)',
    filterCoachPlaceholder: 'Alle coaches',
    filterLocatieKort: 'Locatie',
    filterAbonnementstypeKort: 'Abonnement',
    filterCoachKort: 'Coach',
    filterGeen: 'Geen filters — alle gekoppelde cliënten',
    filterNvt: 'Niet van toepassing',

    previewSection: 'Ontvangers',
    previewLoading: 'Ontvangers laden…',
    previewGeenOntvangers: 'Geen ontvangers gevonden met deze filters',
    tellerTotaal: 'Cliënten gevonden',
    tellerBereikbaar: 'Bereikbaar via push',
    tellerGeenToken: 'Push niet ingesteld',
    tellerOptOut: 'Coachberichten uit',
    tellerUitgesloten: 'Handmatig uitgesloten',
    zoekPlaceholder: 'Zoek op naam…',
    selecteerAlles: 'Alles selecteren',
    deselecteerAlles: 'Alles deselecteren',
    selectieTeller: '{selected} geselecteerd van {reachable} bereikbare cliënten',
    statusBereikbaar: 'Push beschikbaar',
    statusGeenToken: 'Push niet ingesteld',
    statusOptOut: 'Coachberichten uit',
    opnieuwProberen: 'Opnieuw proberen',

    sectionBericht: 'Bericht',
    labelTitel: 'Berichttitel',
    labelTitelPlaceholder: 'Bijv. Belangrijke mededeling',
    labelTekst: 'Berichttekst',
    labelTekstPlaceholder: 'Typ hier je bericht…',
    validatieTeLang: 'Te lang — maximaal {max} tekens',
    validatieAfkapWaarschuwing: 'Wordt op veel toestellen afgekapt',

    previewTelefoon: 'Zo ziet het bericht eruit',
    previewAppNaam: 'Fit En Sterker',
    previewNu: 'nu',
    previewLegeTitel: 'Berichttitel',
    previewLegeTekst: 'Je berichttekst verschijnt hier.',
    previewToelichting: 'Indicatie: hoeveel er precies zichtbaar is verschilt per toestel en per instelling van de ontvanger.',

    limietGebruikt: 'Vandaag {used} van {limit} broadcasts gebruikt',
    limietReset: 'Limiet wordt opnieuw ingesteld op {moment}. Testberichten tellen niet mee.',
    foutLimiet: 'De dagelijkse verzendlimiet kon niet worden opgehaald. Verzenden blijft mogelijk; de definitieve controle gebeurt op de server.',

    verstuurKnop: 'Verstuur naar {count} ontvangers',
    verstuurKnopDisabled: 'Vul titel en bericht in en selecteer ontvangers',

    testKnop: 'Stuur test naar mijzelf',
    testBezig: 'Testbericht versturen…',
    testGelukt: 'Testbericht verstuurd naar je eigen toestel.',
    testGeenToken: 'Je eigen account heeft nog geen werkende pushkoppeling. Open de app op je telefoon en sta meldingen toe.',
    testOptOut: 'Je hebt coachberichten uitgezet in je eigen meldingsinstellingen. Zet ze aan om het testbericht te ontvangen.',
    testGeweigerd: 'De meldingsdienst heeft het testbericht geweigerd. Controleer of de app nog op je toestel staat.',
    testFout: 'Het testbericht kon door een technische fout niet worden verstuurd.',

    bevestigingTitel: 'Bericht versturen?',
    bevestigingVersturen: 'Definitief versturen',
    bevestigingBezig: 'Bezig met versturen…',
    bevestigingFilters: 'Actieve filters',
    bevestigingGeselecteerd: 'Geselecteerde ontvangers',
    bevestigingBereikbaar: 'Werkelijk bereikbaar',
    bevestigingGeblokkeerd: 'Niet bereikbaar',
    bevestigingGeblokkeerdWaarde: '{geenToken} zonder pushkoppeling, {optOut} met coachberichten uit',
    bevestigingWaarschuwing: 'Verzenden kan niet worden teruggedraaid.',

    resultaatTitel: 'Resultaat laatste verzending',
    resultaatGeaccepteerd: '{count} succesvol aangeboden',
    resultaatGeenToken: '{count} zonder werkende pushkoppeling',
    resultaatOptOut: '{count} met coachberichten uitgeschakeld',
    resultaatGeweigerd: '{count} geweigerd door de meldingsdienst',
    resultaatFout: '{count} door een technische fout niet verstuurd',
    resultaatDuplicaat: 'Dit bericht was al verstuurd; er is niets opnieuw verzonden.',
    foutVerzendingNogBezig: 'Deze verzending wordt nog verwerkt. Controleer de geschiedenis voordat je het opnieuw probeert.',
    foutVorigeVerzendingMislukt: 'Een eerdere poging met dit bericht is mislukt. Controleer de geschiedenis en start daarna bewust een nieuwe verzending.',

    historieFilters: 'Filters',
    historieVan: 'Van',
    historieTot: 'Tot en met',
    historieCoach: 'Verzendende coach',
    historieCoachAlle: 'Alle coaches',
    historieTotaal: '{count} verzendingen',
    historieLaden: 'Geschiedenis laden…',
    historieLeeg: 'Nog geen verzendingen',
    historieLeegUitleg: 'Zodra je een bericht of testbericht verstuurt, verschijnt het hier.',
    historieKort: '{accepted} van {selected} aangeboden',
    kolomMoment: 'Verzonden op',
    kolomCoach: 'Coach',
    kolomType: 'Type',
    kolomTitel: 'Bericht',
    kolomResultaat: 'Resultaat',
    kolomActie: 'Actie',
    typeBroadcast: 'Broadcast',
    typeTest: 'Testbericht',
    typeSelectief: 'Groepsbericht',
    statusVerzonden: 'Verzonden',
    statusBezig: 'Bezig',
    statusMislukt: 'Mislukt',
    detailKnop: 'Details',
    detailTitel: 'Verzenddetails',
    detailSluiten: 'Sluiten',
    detailGeselecteerd: '{count} ontvangers geselecteerd',
    paginaVorige: 'Vorige',
    paginaVolgende: 'Volgende',
    paginaVan: 'Pagina {pagina} van {totaal}',

    foutLaden: 'De ontvangerslijst kon niet worden geladen.',
    foutLocaties: 'De locaties konden niet worden geladen.',
    foutAbonnementen: 'De abonnementstypen konden niet worden geladen.',
    foutCoaches: 'De coaches konden niet worden geladen.',
    foutHistorie: 'De verzendgeschiedenis kon niet worden geladen.',
    foutGeenRechten: 'Je hebt geen rechten om pushberichten te versturen.',
    foutSessieVerlopen: 'Je sessie is verlopen. Log opnieuw in en probeer het pushbericht daarna opnieuw te versturen.',
    foutLegeInhoud: 'Vul zowel een titel als een berichttekst in.',
    foutTitelTeLang: 'De titel mag maximaal {max} tekens bevatten.',
    foutTekstTeLang: 'De berichttekst mag maximaal {max} tekens bevatten.',
    foutGeenOntvangers: 'Er zijn geen bereikbare ontvangers voor deze selectie.',
    foutOngeldigeInvoer: 'De verzendopdracht was onvolledig. Ververs de pagina en probeer het opnieuw.',
    foutVersturenAlgemeen: 'Het bericht kon door een technische fout niet worden verstuurd. Probeer het later opnieuw.',
    rateLimitBereikt: 'Dagelijkse limiet bereikt: je hebt vandaag al {used} van de {limit} toegestane broadcasts verstuurd. Probeer het morgen opnieuw of laat een admin de limiet aanpassen.',
  },
  prospect: {
    title: 'Prospect-status',
    statusProspect: 'Prospect',
    statusActive: 'Actief lid',
    badgeProspect: 'Prospect',
    overeenkomstOpstellenKnop: 'Overeenkomst opstellen',
    filterProspects: 'Toon alleen prospects',
    filterAll: 'Toon alle clients',
    typeLabel: 'Type client',
    typeSelectProspect: 'Prospect (potentiële klant)',
    typeSelectActive: 'Actief lid (met abonnement)',
    geenAbonnementVereist: 'Geen abonnement vereist voor prospect',
  },
  trialSession: {
    title: 'Gratis proefsessie',
    markAsTrial: 'Markeer als proefsessie',
    isTrial: 'Proefsessie',
    badgeTrial: 'Proefsessie (gratis)',
    noCreditsCharged: 'Geen credits afgetrokken (proefsessie)',
    trialExplainer: 'Een proefsessie is gratis en telt niet mee voor credits.',
    enrollAsTrial: 'Inschrijven als proefsessie (gratis)',
  },
  agreement: {
    stuurOvereenkomst: 'Nieuwe overeenkomst opstellen',
    modalTitel: 'Overeenkomst versturen',
    modalUitleg: 'Verstuur een digitale overeenkomst naar deze client. De client ontvangt een e-mail en push notificatie met een link om de overeenkomst te bekijken en digitaal te ondertekenen.',
    labelAbonnementstype: 'Abonnementstype voorstellen (optioneel)',
    clientKiestZelf: 'Client kiest zelf',
    abonnementstypeHint: 'Als je een type voorstelt, wordt dit automatisch vooraf geselecteerd. Anders kan de client zelf kiezen.',
    ontvangerInfo: 'Ontvanger',
    geldigheid: 'Link geldig voor 7 dagen',
    annuleren: 'Annuleren',
    versturen: 'Versturen',
    versturenBezig: 'Versturen…',
    verstuurdSuccess: 'Overeenkomst succesvol verstuurd! Client ontvangt een e-mail en push notificatie.',
    verstuurdFout: 'Fout bij versturen: ',
    openstaandTokensTitel: 'Openstaand — wacht op handtekening',
    statusOpenstaand: 'Verstuurd, nog niet ondertekend',
    verstuurdOp: 'Verstuurd op',
    verlooptOp: 'Verloopt op',
    geenOndertekendNogWachten: 'Client heeft de overeenkomst nog niet ondertekend.',
    intrekkenKnop: 'Intrekken',
    intrekkenTitel: 'Overeenkomst intrekken',
    intrekkenBevestig: 'Weet je zeker dat je dit token wilt intrekken? De client kan de link dan niet meer gebruiken om te ondertekenen.',
    intrekkenBevestigKnop: 'Ja, intrekken',
    intrekkenBezig: 'Bezig…',
    ingetrokkenSuccess: 'Token ingetrokken.',
    intrekkenFout: 'Fout bij intrekken: ',
    intrekkenGeenRechten: 'Je kunt deze overeenkomst niet intrekken — alleen de opsteller of een beheerder kan dat.',
    downloadFout: 'Fout bij laden PDF.',
    stuurOpnieuw: 'Opnieuw sturen',
    stuurOpnieuwSuccess: 'Overeenkomst opnieuw verstuurd!',
    stuurOpnieuwFout: 'Fout bij opnieuw versturen: ',
    kopieerLink: 'Kopieer link',
    linkGekopieerd: 'Link gekopieerd!',
    allTokensTitel: 'Verzonden overeenkomsten',
    statusOpenstaandLabel: 'Openstaand',
    statusOndertekendLabel: 'Ondertekend',
    statusAfgewezenLabel: 'Afgewezen',
    statusIngetrokkenLabel: 'Ingetrokken',
    statusVerlopenLabel: 'Verlopen',
    verlopenOp: 'Verlopen op',
    geldigTm: 'Geldig t/m',
    datumVerzonden: 'Verzonden op',
    afgewezenDoor: 'Afgewezen door',
    redenAfwijzing: 'Reden: ',
    staffelKiezen: 'Staffel kiezen',
    staffelKiezenHint: 'Selecteer de looptijd en prijs voor deze overeenkomst.',
    staffelVerplicht: 'Kies een staffel bij het geselecteerde abonnementstype.',
    customVoorwaarden: 'Aangepaste voorwaarden',
    customVoorwaardenInfo: 'Gebruik afwijkende prijs of credits voor deze specifieke overeenkomst. De looptijd en betaalfrequentie worden overgenomen van de geselecteerde staffel.',
    customNaam: 'Aangepaste naam (optioneel)',
    customPrijsPerMaand: 'Prijs per maand (€)',
    customCredits: 'Credits',
    customPrijsVerplicht: 'Prijs per maand is verplicht bij aangepaste voorwaarden.',
    customCreditsVerplicht: 'Credits zijn verplicht bij aangepaste voorwaarden.',
    customTypeVerplicht: 'Kies een abonnementstype voordat je aangepaste voorwaarden instelt.',
    customStaffelVerplicht: 'Kies een staffel voordat je aangepaste voorwaarden instelt.',
    bonusSectie: 'Bonusabonnementen meesturen',
    bonusGratis: 'Gratis',
    bonusStaffelprijs: 'Staffelprijs',
    extraToevoegen: '+ Extra abonnement toevoegen',
    overzichtTitel: 'Overzicht abonnementen',
  },
  overeenkomst: {
    titel: 'Digitale overeenkomst',
    laden: 'Overeenkomst laden...',
    foutTitel: 'Link ongeldig',
    tokenOngeldig: 'Deze link is ongeldig of verlopen. Neem contact op met je coach voor een nieuwe link.',
    typeNietGevonden: 'Het voorgestelde abonnementstype is niet meer beschikbaar.',
    foutLaden: 'Fout bij laden overeenkomst: ',
    kiesAbonnement: 'Kies je abonnement',
    kiesAbonnementUitleg: 'Selecteer het abonnement dat bij je past. Na je keuze kun je de overeenkomst lezen en ondertekenen.',
    selecteren: 'Selecteren',
    leesOvereenkomst: 'Overeenkomst',
    geenTekst: 'Nog geen overeenkomsttekst beschikbaar. Neem contact op met je coach.',
    plaatsHandtekening: 'Handtekening',
    handtekeningUitleg: 'Teken met je muis of vinger in het veld hieronder.',
    wisHandtekening: 'Wissen',
    geenHandtekening: 'Plaats eerst je handtekening voordat je ondertekent.',
    akkoordLabel: 'Ik heb de overeenkomst gelezen en ga akkoord met de voorwaarden.',
    akkoordVerplicht: 'Vink het akkoordvakje aan voordat je ondertekent.',
    voorwaardenTypeKop: 'Voorwaarden',
    ondertekenen: 'Ondertekenen en afsluiten',
    bezig: 'Bezig met ondertekenen...',
    foutOndertekenen: 'Fout bij ondertekenen: ',
    bedanktTitel: 'Overeenkomst ondertekend!',
    bedanktTekst: 'Je overeenkomst is succesvol ondertekend. Je account is nu actief en je kunt direct beginnen met trainen. Je ontvangt een bevestiging per e-mail.',
    bedanktSluiten: 'Je kunt deze pagina nu sluiten.',
    afwijzenKnop: 'Overeenkomst afwijzen',
    afwijzenTitel: 'Overeenkomst afwijzen',
    afwijzenUitleg: 'Weet je zeker dat je deze overeenkomst wilt afwijzen? Je coach wordt op de hoogte gesteld.',
    afwijzenRedenPlaceholder: 'Reden (optioneel)…',
    afwijzenAnnuleer: 'Annuleren',
    afwijzenBevestig: 'Ja, afwijzen',
    afwijzenBezig: 'Bezig…',
    foutAfwijzen: 'Fout bij afwijzen',
    afgewezenTitel: 'Overeenkomst afgewezen',
    afgewezenTekst: 'Je hebt de overeenkomst afgewezen. Neem contact op met je coach als je vragen hebt.',
    tokenAlGebruikt: 'Deze overeenkomst is al ondertekend.',
    tokenAfgewezenOfIngetrokken: 'Deze link is afgewezen of ingetrokken. Neem contact op met je coach voor een nieuwe link.',
    customVoorwaardenTitel: 'Overeengekomen voorwaarden',
    customPrijsLabel: 'Prijs',
    customCreditsLabel: 'Credits',
    openstaandTokenBannerTitel: 'Let op: er staat al een overeenkomst open voor deze cliënt',
    openstaandTokenBannerRegel: 'Verstuurd op {datum} — {type}',
    openstaandTokenBannerType: 'algemene overeenkomst (cliënt kiest zelf abonnement)',
    openstaandTokenBannerUitleg: 'Als je hieronder een nieuwe overeenkomst verstuurt, vervalt deze automatisch.',
    customLooptijdLabel: 'Looptijd',
    customDagen: 'dagen',
    extraAbonnementenTitel: 'Inbegrepen abonnementen',
    onbekendType: '(onbekend abonnementstype)',
    stepperABSteps: 'Staffel,Betaling,Overzicht,Ondertekenen',
    stepperCDSteps: 'Keuze,Configuratie,Overzicht,Ondertekenen',
    stepVolgende: 'Volgende',
    stepTerug: 'Terug',
    afwijzenRedenVerplicht: 'Geef een reden op voor het afwijzen.',
    scenarioABStaffelTitel: 'Kies je looptijd',
    scenarioABOmschrijving: 'Selecteer de looptijd die het beste bij je past.',
    scenarioCDTitel: 'Kies je abonnement',
    scenarioCDUitleg: 'Selecteer een abonnement per categorie. Je kunt per sessietype maximaal één abonnement kiezen.',
    sectionPt: '1-op-1 Personal Training',
    sectionPtPlus: '1-op-2 Personal Training',
    sectionSmallGroup: 'Small Group Training',
    minimaalEenType: 'Selecteer minimaal één abonnementstype om verder te gaan.',
    bonusGratisLabel: 'Gratis inbegrepen',
    bonusBijDitAbo: 'Bij dit abonnement ontvang je gratis:',
    bonusChipGratis: 'Gratis',
    bonusPerMaand: '/mnd',
    bonusInclusiefLabel: 'Inclusief',
    bonusGratis: 'gratis',
    bonusVoegToe: 'Voeg toe',
    bonussenSectieLabel: 'Optionele bonus- en extra abonnementen',
    bonusLooptijdAfwijking: '{hoofd} mnd hoofdabonnement, bonus geldt {bonus} mnd',
    aanbevolenBadge: 'Aanbevolen',
    vanafPrijs: 'Vanaf',
    configuratieTitel: 'Abonnement configureren',
    configuratieVoortgang: 'Abonnement {idx} van {total}',
    configuratieStaffelTitel: 'Kies je looptijd',
    // Onderdeel 4 (2026-07-28): zelfde correctie als overeenkomstBetaalfreq.kiesTitel —
    // dit is de betaaltermijn-stap (maandelijks/eenmalig), niet de betaalmethode.
    configuratieBetaalTitel: 'In welke termijn wil je betalen?',
    overzichtTitelPagina: 'Overzicht',
    overzichtHoofdAbo: 'Hoofdabonnement',
    overzichtBonussen: 'Inbegrepen bonusabonnementen',
    overzichtTotaal: 'Totaal per maand',
    overzichtGratis: 'Gratis',
    overzichtAboItem: '{months} maanden — {freq}',
    overzichtFreqMaand: 'maandbetaling',
    overzichtFreqPeriode: 'eenmalig voor periode',
    sessieduurKiezen: 'Kies sessieduur',
    sessieduur30: '30 minuten',
    sessieduur60: '60 minuten',
    sessieduurVerplicht: 'Kies een sessieduur om verder te gaan.',
    staffelVerplicht: 'Selecteer een looptijd om verder te gaan.',
    geselecteerd: 'Geselecteerd',
    vanafPerMaand: 'Vanaf {prijs}/mnd',
    creditsPerMaand: '{n} credits/mnd',
    stepperCDStepsCoach: 'Keuze,Configuratie,Overzicht',
    coachModusTitel: 'Overeenkomst opstellen',
    coachModusUitleg: 'Stel de overeenkomst samen voor {naam}. Wat je invult staat vast; wat je openlaat vult de cliënt zelf aan.',
    verstuurNaarClient: 'Verstuur naar cliënt',
    directInvullenOndertekenen: 'Direct invullen en ondertekenen',
    directNieuwTabLaden: 'Ondertekenpagina wordt geopend…',
    directPopupGeblokkeerd: 'Het nieuwe tabblad is geblokkeerd. Sta pop-ups voor deze website toe en probeer opnieuw.',
    verstuurBezig: 'Bezig met versturen...',
    verstuurGeluktTitel: 'Overeenkomst verstuurd!',
    verstuurGeluktTekst: 'De cliënt heeft een e-mail ontvangen met een link om de overeenkomst aan te vullen en te ondertekenen.',
    foutVersturen: 'Fout bij versturen: ',
    alGekozenDoorCoach: 'Al gekozen door je coach',
    clientNietGevonden: 'Deze cliënt is niet gevonden.',
    clientVerwijderd: 'Dit cliëntprofiel is verwijderd. Er kan geen nieuwe overeenkomst meer voor worden opgesteld.',
    geenToegangCoachModus: 'Je hebt geen toegang tot deze pagina.',
    aangepasteVoorwaardenToggle: 'Aangepaste voorwaarden voor dit abonnement',
    aangepasteNaamLabel: 'Naam',
    aangepastePrijsLabel: 'Prijs per maand (€)',
    aangepasteCreditsLabel: 'Credits',
    standaardNaamHelper: 'Standaard: {naam}',
    standaardPrijsHelper: 'Standaard: {prijs}/mnd',
    standaardCreditsHelper: 'Standaard: {credits} credits/periode',
    uitsluitenKnopTitel: 'Dit type uitsluiten voor deze cliënt',
    uitgeslotenLabel: 'Uitgesloten voor deze cliënt',
    uitgeslotenHerstellen: 'Ongedaan maken',
    uitgeslotenSectieTitel: 'Uitgesloten voor deze cliënt',
    // Onderdeel 1+2 (2026-07-28 vervolgsessie): al-actieve abonnementen —
    // uitgrijzen in de coach-builder (stap 1) en waarschuwen vóór ondertekenen.
    alActiefSinds: 'Al actief sinds {datum}',
    alActiefWaarschuwingTitel: 'Dit heb je al actief',
    alActiefWaarschuwingUitleg: 'Je kunt deze overeenkomst niet ondertekenen zolang dit abonnement al actief bij je staat. Neem contact op met je coach als je denkt dat dit niet klopt.',
    verstuurBevestigTitel: 'Overeenkomst versturen naar cliënt?',
    verstuurBevestigOntvanger: 'Ontvanger',
    verstuurBevestigAbonnementen: 'Gekozen abonnement(en)',
    verstuurBevestigOpenstaand: 'De cliënt vult deze keuzes zelf nog aan',
    verstuurBevestigGeenOpenstaand: 'Alle keuzes zijn al ingevuld — de cliënt hoeft alleen nog te ondertekenen.',
    verstuurBevestigAnnuleren: 'Annuleren',
    verstuurBevestigBevestigen: 'Ja, verstuur',
    customRegelsSectieTitel: 'Aanvullende afspraken',
    customRegelToevoegen: '+ Aangepaste regel toevoegen',
    customRegelVerwijderen: 'Verwijderen',
    customRegelInclBtw: '(incl. btw)',
    customRegelModalTitel: 'Aangepaste regel toevoegen',
    customRegelModalUitleg: 'Deze regel wordt vast onderdeel van de overeenkomst — de cliënt ziet ‘m, maar kan ‘m niet zelf wijzigen of verwijderen.',
    customRegelNaamLabel: 'Naam / omschrijving',
    customRegelNaamPlaceholder: 'Bijv. "Korting eerste maand"',
    customRegelBedragLabel: 'Eenmalig bedrag (€, incl. btw) — optioneel',
    customRegelBedragPlaceholder: 'Bijv. -10,00 voor korting, 25,00 voor extra kosten',
    customRegelBedragHelper: 'Positief = extra kosten op de factuur. Negatief = korting. Bedrag is inclusief btw (9%, zelfde standaardtarief als de rest van de factuur).',
    customRegelCreditsLabel: 'Eenmalige credit-toekenning (aantal) — optioneel',
    customRegelCreditsPlaceholder: 'Bijv. 1',
    customRegelPoolLabel: 'Creditpool',
    customRegelPoolKies: 'Kies een pool...',
    customRegelGeenPools: 'Geen enkele creditpool is beschikbaar — kies eerst een abonnement (of dit type heeft al een actief abonnement bij deze cliënt) voordat je hier credits aan kunt toekennen.',
    customRegelOpslaan: 'Toevoegen',
    customRegelNaamVerplicht: 'Vul een naam/omschrijving in.',
    customRegelMinimaalEen: 'Vul minimaal een bedrag of een credit-toekenning in.',
    customRegelPoolVerplicht: 'Kies een creditpool voor de credit-toekenning.',
    customRegelCreditsPositief: 'Het aantal credits moet groter dan 0 zijn.',
    nawTitel: 'Jouw gegevens',
    nawUitleg: 'Deze gegevens komen in de overeenkomst te staan. Voorgevuld indien al bij ons bekend — pas ze aan als je bent verhuisd.',
    nawLabelNaam: 'Naam',
    nawLabelStraat: 'Straat',
    nawLabelHuisnummer: 'Huisnummer',
    nawLabelPostcode: 'Postcode',
    nawLabelPlaats: 'Woonplaats',
    nawOngeldig: 'Vul een geldig adres in (straat, huisnummer, postcode en woonplaats) voordat je ondertekent.',
  },
  overeenkomstBetaalfreq: {
    // Onderdeel 4 (2026-07-28): dit scherm gaat over de betaaltermijn
    // (maandelijks vs. eenmalig voor de hele periode), niet over de
    // betaalmethode — die vraag ("Hoe wil je betalen?", manual/iDEAL/SEPA)
    // zit in overeenkomstBetaalmethode.titel en is bewust ongewijzigd.
    kiesTitel: 'In welke termijn wil je betalen?',
    maandelijks: 'Maandelijks',
    maandelijksLabel: 'per maand',
    eenmalig: 'Eenmalig',
    eenmaligMetKorting: 'Eenmalig (met korting)',
    kortingLabel: 'korting',
    kortingBesparing: 'Besparing',
    eenmaligKortingToelichting: 'Inclusief {pct}% korting voor eenmalige betaling',
    verplicht: 'Kies een betaalfrequentie om verder te gaan.',
  },
  overeenkomstBetaalmethode: {
    titel: 'Hoe wil je betalen?',
    manual: 'Handmatig (betaling via factuur)',
    ideal: 'iDEAL',
    sepa: 'SEPA-incasso (automatische afschrijving)',
    ibanLabel: 'IBAN',
    ibanPlaceholder: 'NL00 BANK 0123 4567 89',
    ibanUitleg: 'Wordt uitsluitend gebruikt om een SEPA-machtiging aan te maken. We bewaren zelf alleen de laatste 4 cijfers.',
    ibanOngeldig: 'Vul een geldig IBAN-nummer in.',
    // F4-10 SEPA-machtigingsaddendum
    sepaMachtigingAkkoordLabel: 'Ik ga akkoord met bovenstaande doorlopende SEPA-machtiging.',
    sepaMachtigingAkkoordVerplicht: 'Je moet akkoord gaan met de SEPA-machtiging om verder te gaan.',
  },
  staffelKaart: {
    kortingLabel: '{pct}% korting bij eenmalige betaling',
  },
  mijnAbonnement: {
    title: 'Mijn abonnement',
    actiefAbonnement: 'Actieve abonnementen',
    geenAbonnement: 'Geen actief abonnement gevonden.',
    naam: 'Naam abonnement',
    looptijd: 'Looptijd',
    resteCredits: 'Resterende credits',
    ptCredits: 'PT-credits',
    ptPlusCredits: 'PT-plus credits',
    smallGroupCredits: 'Small Group credits',
    status: 'Status',
    actief: 'Actief',
    verlopen: 'Verlopen',
    doorlopend: 'doorlopend',
    aangepast: 'Aangepast',
    onbekend: 'Onbekend',
    overeenkomsten: 'Overeenkomsten',
    geenOvereenkomsten: 'Nog geen overeenkomsten.',
    geenOndertekend: 'Nog geen ondertekende overeenkomsten.',
    ondertekendOp: 'Ondertekend op',
    download: 'Download',
    downloadFout: 'Fout bij downloaden PDF.',
    afsluitenTitel: 'Abonnement afsluiten',
    afsluitenInfo: 'Je kunt een nieuw abonnement afsluiten door de overeenkomst te ondertekenen.',
    afsluitenBtn: 'Sluit abonnement af',
    contactCoach: 'Neem contact op met je coach om een abonnement af te sluiten.',
    foutLaden: 'Fout bij laden: ',
    statusNietOndertekend: 'Nog niet ondertekend',
    verstuurdOp: 'Verstuurd op',
    geldigTm: 'Geldig t/m',
    ondertekenenBtn: 'Onderteken nu',
    afwijzenKnop: 'Afwijzen',
    afwijzenTitel: 'Overeenkomst afwijzen',
    afwijzenUitleg: 'Weet je zeker dat je deze overeenkomst wilt afwijzen? Je coach wordt hiervan op de hoogte gesteld.',
    afwijzenRedenLabel: 'Reden (optioneel)',
    afwijzenRedenPlaceholder: 'Licht toe waarom je de overeenkomst afwijst…',
    afwijzenAnnuleer: 'Annuleren',
    afwijzenBevestig: 'Ja, afwijzen',
    afwijzenBezig: 'Bezig…',
    afwijzenFout: 'Fout bij afwijzen: ',
    statusAfgewezen: 'Afgewezen',
    statusIngetrokken: 'Ingetrokken door coach',
    statusVerlopen: 'Verlopen',
    opzeggenKnop: 'Abonnement opzeggen',
    opzeggenBevestiging: 'Weet je zeker dat je je abonnement wilt opzeggen? Je hebt nog toegang tot {datum}.',
    opzeggenFout: 'Fout bij opzeggen: ',
    opzegdatumFout: 'De einddatum van je abonnement kon niet worden opgehaald. Probeer het later opnieuw.',
    opzeggenPushTitel: 'Abonnement opgezegd',
    opzeggenPushBody: 'Je abonnement is opgezegd. Je hebt nog toegang tot {datum}.',
    opgezegd: 'Opgezegd — loopt af op {datum}',
    heractiverenKnop: 'Heractiveer abonnement',
    heractiverenTitel: 'Abonnement heractiveren',
    heractiverenUitleg: 'Je abonnement wordt voortgezet en weer automatisch verlengd en geïncasseerd zoals voorheen.',
    heractiverenAkkoord: 'Ik ga akkoord dat de overeenkomst wordt voortgezet',
    heractiverenBevestigKnop: 'Heractiveer',
    heractiverenFout: 'Fout bij heractiveren: ',
    heractiverenNietMeerMogelijk: 'Heractiveren is niet meer mogelijk. Sluit een nieuw abonnement af of neem contact op met je coach.',
  },
  ptAanvragen: {
    titel: 'PT-aanvragen',
    geenAanvragen: 'Geen openstaande aanvragen.',
    laden: 'Aanvragen laden…',
    foutLaden: 'Kon aanvragen niet laden: ',
    statusPending: 'In behandeling',
    statusRescheduled: 'Alternatief voorgesteld',
    clientLabel: 'Cliënt',
    datumLabel: 'Datum',
    duurLabel: 'Duur',
    minutenSuffix: '{{count}} minuten',
    locatieLabel: 'Locatie',
    notitieLabel: 'Notitie',
    rescheduledNota: 'Notitie coach',
    accepteerKnop: 'Accepteren',
    afwijzenKnop: 'Afwijzen',
    alternatiefKnop: 'Alternatief voorstellen',
    bevestigenKnop: 'Bevestigen',
    geaccepteerd: 'Afspraak aangemaakt en cliënt geïnformeerd.',
    afgewezen: 'Aanvraag afgewezen en cliënt geïnformeerd.',
    alternatiefVerstuurd: 'Alternatief voorstel verstuurd naar cliënt.',
    foutBijwerken: 'Kon aanvraag niet bijwerken: ',
    alternatiefTitel: 'Alternatief voorstellen',
    nieuweDatumLabel: 'Nieuwe datum *',
    nieuwTijdLabel: 'Nieuw tijdstip *',
    notitiePlaceholder: 'Toelichting voor de cliënt…',
    verstuurKnop: 'Voorstel versturen',
    datumVerplicht: 'Vul een datum in.',
    tijdVerplicht: 'Vul een tijdstip in.',
    conflicten: 'Roosterconflicten gevonden. Toch accepteren?',
    conflictenTitel: 'Roosterconflict',
    tochAccepteren: 'Toch accepteren',
    annuleren: 'Annuleren',
    pushAccepteerdTitel: 'Je PT-aanvraag is bevestigd',
    pushAccepteerdBody: 'Je PT-aanvraag op {datum} is bevestigd.',
    pushAfgewezenTitel: 'PT-aanvraag afgewezen',
    pushAfgewezenBody: 'Je PT-aanvraag op {datum} is helaas afgewezen.',
    pushAlternatiefTitel: 'Alternatief voorstel ontvangen',
    pushAlternatiefBody: 'Je coach heeft een alternatief tijdstip voorgesteld voor je PT-afspraak. Bekijk en reageer in de app.',
  },
  blocking: {
    fallbackNaam: 'klant',
    fallbackClientNaam: 'een client',
    fallbackLesNaam: 'les',
    clientBlockedPushTitel: 'Account geblokkeerd',
    clientBlockedPushBody: 'Je account is geblokkeerd wegens een openstaande incasso. Neem contact op met je coach.',
    clientBlockedEmailSubject: 'Account geblokkeerd — Fit en Sterker',
    clientBlockedEmailHeading: 'Account geblokkeerd',
    clientBlockedEmailGreeting: 'Beste {naam},',
    clientBlockedEmailBody1: 'Je account bij Fit en Sterker is geblokkeerd wegens een openstaande incasso.',
    clientBlockedEmailBody2: 'Je hebt momenteel geen toegang tot groepslessen en PT-afspraken.',
    clientBlockedEmailBody3: 'Neem contact op met je coach om dit op te lossen.',
    emailSignatureVriendelijk: 'Met vriendelijke groet,<br/>Fit en Sterker',
    coachBlockedPushTitel: 'Client geblokkeerd',
    coachBlockedPushBody: 'Het account van {naam} is geblokkeerd wegens incasso.',
    lessonRestoredPushTitel: 'Weer ingeschreven',
    lessonRestoredPushBody: 'Je bent weer ingeschreven voor {les} op {datum}.',
    lessonRemovedPushTitel: 'Les vol',
    lessonRemovedPushBody: 'Je blokkering is opgeheven, maar {les} op {datum} is helaas vol. Schrijf je opnieuw in als er plek vrijkomt.',
    clientUnblockedPushTitel: 'Account gedeblokkeerd',
    clientUnblockedPushBody: 'Je account is gedeblokkeerd. Je hebt weer volledige toegang.',
    clientUnblockedEmailSubject: 'Account gedeblokkeerd — Fit en Sterker',
    clientUnblockedEmailHeading: 'Account gedeblokkeerd',
    clientUnblockedEmailBody1: 'Je account bij Fit en Sterker is gedeblokkeerd. Je hebt weer volledige toegang tot groepslessen en PT-afspraken.',
    clientUnblockedEmailRestoredNote: 'Je bent automatisch weer ingeschreven voor {count} les(sen).',
    clientUnblockedEmailRemovedNote: 'Voor {count} les(sen) was helaas geen plek meer. Schrijf je opnieuw in via de app.',
    emailSignatureSportief: 'Met sportieve groet,<br/>Fit en Sterker',
    coachUnblockedPushTitel: 'Client gedeblokkeerd',
    coachUnblockedPushBody: 'Het account van {naam} is gedeblokkeerd.',
  },
  acties: {
    eyebrow: 'Werkvoorraad',
    titel: 'Actiecentrum',
    subtitel: 'Alleen zaken die nu opvolging nodig hebben of van de normale voortgang afwijken.',
    samenvattingLabel: 'Samenvatting actiecentrum',
    nuOpvolgen: 'nu opvolgen',
    uitzonderingen: 'uitzonderingen',
    ptAanvragen: 'PT-aanvragen',
    ptAangevraagdVoor: 'Aangevraagd voor {datum}',
    ptTegenvoorstel: 'Tegenvoorstel voor {datum}',
    beoordelen: 'Beoordelen',
    prospectActies: 'Prospectacties vandaag',
    prospectActieZonderOmschrijving: 'Geplande opvolging zonder omschrijving',
    achterstalligSinds: 'Achterstallig sinds {datum}, {tijd}',
    vandaagOm: 'Vandaag om {tijd}',
    openInPipeline: 'Open in pipeline',
    afgewezenOvereenkomsten: 'Afgewezen overeenkomsten',
    verlopenOvereenkomsten: 'Verlopen overeenkomsten',
    openstaandeIncasso: 'Openstaande incasso',
    geenActies: 'Alles is bijgewerkt',
    geenActiesUitleg: 'Er zijn geen acties voor vandaag en geen uitzonderingen die aandacht vragen.',
    overeenkomstOpstellen: 'Overeenkomst opstellen',
    overeenkomstOmschrijving: 'Overeenkomst van {datum}',
    nietMeerTonen: 'Niet meer tonen',
    foutAfhandelen: 'Fout bij afhandelen: ',
    afgewezenOp: 'Afgewezen op',
    verlopenOp: 'Verlopen op',
    incassoOmschrijving: 'Factuur {nummer} · {bedrag} openstaand',
    factuurBekijken: 'Naar facturen',
    onbekendeClient: 'Onbekende cliënt',
    datumOnbekend: 'Datum onbekend',
    foutLaden: 'Het Actiecentrum kon niet worden geladen: ',
  },
  nietGelogdeSessies: {
    titel: 'Nog te loggen PT-sessies',
    subtitel: 'PT-afspraken van de afgelopen {dagen} dagen die al zijn geweest, zonder afgeronde training.',
    terugNaarDashboard: 'Terug naar dashboard',
    geenSessies: 'Alle recente PT-sessies zijn gelogd.',
    kolomClient: 'Cliënt',
    kolomMoment: 'Afspraak',
    kolomCoach: 'Coach',
    kolomActie: 'Actie',
    naarRooster: 'Naar rooster',
    paginaVorige: 'Vorige',
    paginaVolgende: 'Volgende',
    paginaVan: 'Pagina {pagina} van {totaal}',
    foutLaden: 'De lijst kon niet worden geladen: ',
  },
  cronDashboard: {
    titel: 'Cron-dashboard',
    subtitel: 'Overzicht van geautomatiseerde jobs: planning, uitvoeringshistorie en preview van de volgende run.',
    laden: 'Dashboard laden…',
    tabPlanning: 'Planning',
    tabHistorie: 'Historie',
    tabPreview: 'Preview',
    tabRunstatus: 'Runstatus',

    // Runstatus (cron_run_log — de werkelijke run-uitkomst)
    runstatusTitel: 'Werkelijke run-status per job',
    runstatusUitleg: 'De échte uitkomst van elke cron-run uit cron_run_log. In tegenstelling tot de uitvoeringshistorie (cron.job_run_details), die altijd "succeeded" toont zodra het HTTP-verzoek is ingepland — ook als de Edge Function daarna crashte.',
    runstatusRecenteTitel: 'Recente runs',
    runstatusVoetnoot: 'Groen = laatste run geslaagd. Oranje = geslaagd maar met overgeslagen/gefaalde items (of gedetecteerde problemen bij de health-check). Rood = run gefaald.',
    geenRunstatus: 'Nog geen runs gelogd in cron_run_log.',
    colLaatsteRun: 'Laatste run',
    colSamenvatting: 'Samenvatting',
    colFouten: 'Fouten',
    colBetrouwbaarheid: 'Succes (30 dagen)',
    geenFouten: 'Geen',
    statusSuccess: 'Geslaagd',
    statusPartial: 'Aandacht',
    statusFailed: 'Gefaald',
    nooitGedraaid: 'Nog niet gedraaid',
    jobHealthCheck: 'Cron-signaleringscheck',
    jobSync: 'Agenda-synchronisatie',

    // Planning
    planningTitel: 'Geplande jobs',
    planningVoetnoot: 'Alle tijden zijn in UTC. De lokale tijd kan afwijken afhankelijk van de tijdzone.',
    colNaam: 'Job naam',
    colOmschrijving: 'Omschrijving',
    colSchema: 'Schema',
    colVolgende: 'Volgende uitvoering',
    colActief: 'Status',
    actief: 'Actief',
    inactief: 'Inactief',
    teLaat: 'Te laat',
    geenJobs: 'Geen cron jobs gevonden.',
    dagelijksOm: 'Dagelijks om',
    elkeMinuten: 'Elke {aantal} minuten',
    elkeUren: 'Elke {aantal} uur',
    wekelijksOp: 'Wekelijks op',
    weekdag0: 'zondag',
    weekdag1: 'maandag',
    weekdag2: 'dinsdag',
    weekdag3: 'woensdag',
    weekdag4: 'donderdag',
    weekdag5: 'vrijdag',
    weekdag6: 'zaterdag',
    onbekend: 'Onbekend',

    // Job labels
    jobFactuur: 'Factuurherinneringen',
    jobProspect: 'Prospect herinneringen',
    jobAkkoord: 'Overeenkomst herinneringen',
    jobFactuurDesc: 'Verstuurt automatisch betalingsherinneringen (14 dgn na vervaldatum) en aanmaningen (14 dgn na herinnering) voor openstaande facturen.',
    jobProspectDesc: 'Stuurt push-herinneringen naar prospects die een gratis proefsessie hebben gehad maar nog geen lid zijn geworden.',
    jobAkkoordDesc: 'Stuurt e-mail herinneringen naar clients met een openstaand, niet-ondertekend overeenkomsttoken.',
    jobAbonnement: 'Abonnementsbeheer',
    jobAbonnementDesc: 'Dagelijkse verwerking: deactiveert opgezegde abonnementen, boekt credits bij, verlengt naar rolling (Wet van Dam) en maakt maandelijkse facturen aan.',
    jobVerloopHerinneringen: 'Abonnementsverloopherinneringen',
    jobVerloopHerinneringenDesc: 'Stuurt push- en e-mailherinneringen naar clients bij naderende abonnementsverlenging, op de verlengingsdag zelf en bij een naderende opzegging.',
    jobVerlopenUitnodigingen: 'Verlopen uitnodigingen opruimen',
    jobVerlopenUitnodigingenDesc: 'Verwijdert verlopen pending_confirmation les-uitnodigingen en stuurt een pushbericht naar de betreffende client.',
    jobArchiveTemplates: 'Verlopen trainingssjablonen archiveren',
    jobArchiveTemplatesDesc: 'Archiveert dagelijks trainingssjablonen waarvan de ingestelde "geldig tot"-datum is verstreken.',
    jobUnloggedSessionReminders: 'Herinnering niet-gelogde PT-sessies',
    jobUnloggedSessionRemindersDesc: 'Controleert elk uur (indien ingeschakeld) welke PT-sessies na de ingestelde vertraging nog niet gelogd zijn en stuurt de uitvoerende coach een pushherinnering.',
    jobMealSchedule: 'Voedingsschema materialiseren',
    jobMealScheduleDesc: 'Maakt de dagelijkse voedingslogregels aan vanuit de geldige weekschema’s.',
    jobInfiniteRecurrences: 'Doorlopende lesreeksen aanvullen',
    jobInfiniteRecurrencesDesc: 'Vult oneindige lesreeksen wekelijks vooruit aan en bewaakt de planningshorizon.',
    jobBirthdays: 'Verjaardagsmeldingen coaches',
    jobBirthdaysDesc: 'Controleert iedere vijf minuten welke opt-in coach zijn wekelijkse verjaardagsmelding moet ontvangen.',
    jobScheduledInvoiceEmails: 'Geplande factuurmails',
    jobScheduledInvoiceEmailsDesc: 'Verstuurt iedere vijf minuten factuurmails waarvan het geplande verzendmoment is bereikt.',
    jobMollieReconcile: 'Mollie-betalingsreconciliatie',
    jobMollieReconcileDesc: 'Controleert iedere vier uur niet-definitieve Mollie-betalingen als vangnet voor gemiste webhooks.',
    jobChargebacks: 'Mollie-chargebackcontrole',
    jobChargebacksDesc: 'Controleert wekelijks recente Mollie-chargebacks als achtervang voor gemiste webhooks.',
    jobSepaRetry: 'SEPA-incasso’s opnieuw proberen',
    jobSepaRetryDesc: 'Probeert dagelijks in aanmerking komende mislukte SEPA-incasso’s één keer opnieuw.',
    jobSyncDesc: 'Synchroniseert elke twintig minuten de externe agenda’s van coaches.',
    jobHealthCheckDesc: 'Controleert dagelijks of alle bewaakte cronjobs op tijd en zonder fouten hebben gedraaid.',
    jobCleanup: 'Cronhistorie opschonen',
    jobCleanupDesc: 'Verwijdert dagelijks oude detailruns uit cron_run_log en pg_cron.',

    // Historie
    historieTitelUitvoering: 'Uitvoeringshistorie (cron runs)',
    historieMisleidendNote: 'Let op: deze tabel komt uit cron.job_run_details en toont "succeeded" zodra het HTTP-verzoek is ingepland — óók als de Edge Function daarna crashte. Voor de werkelijke run-uitkomst: zie de tab Runstatus.',
    historieTitelBerichten: 'Verzonden berichten',
    filterJob: 'Filter op job:',
    alleJobs: 'Alle jobs',
    geenUitvoeringsdata: 'Geen uitvoeringsdata beschikbaar. Dit vereist pg_cron v1.4 of hoger.',
    geenBerichten: 'Nog geen berichten verzonden.',
    colStarttijd: 'Starttijd',
    colJob: 'Job',
    colStatus: 'Status',
    colDuur: 'Duur',
    colResultaat: 'Resultaat',
    colDatum: 'Datum',
    colClient: 'Cliënt',
    colType: 'Type',
    colDetails: 'Details',

    // Preview
    previewUitleg: 'Dry run: toont wie bij de volgende uitvoering een bericht zou ontvangen, zonder daadwerkelijk te versturen.',
    previewVernieuwen: 'Preview vernieuwen',
    previewLaden: 'Preview laden…',
    volgendeUitvoering: 'Volgende uitvoering',
    geenVerzendingen: 'Geen berichten bij de volgende uitvoering.',
    berichtenBijVolgendeRun: 'berichten bij de volgende uitvoering',
    previewRenewalsGeenActies: 'Geen acties bij de volgende uitvoering.',
    previewRenewalsCancellations: 'Abonnementen te deactiveren',
    previewRenewalsCredits: 'Credits bij te boeken',
    previewRenewalsProlongations: 'Abonnementen te verlengen naar rolling',
    previewRenewalsInvoices: 'Facturen aan te maken',
    previewMembershipGeenHerinneringen: 'Geen herinneringen bij de volgende uitvoering.',
    previewMembershipProlongReminders: 'Verlengingsherinneringen (kandidaten)',
    previewMembershipCancReminders: 'Opzeggingsherinneringen (kandidaten)',
    colFactuurnummer: 'Factuurnummer',
    colBetaaldatum: 'Betaaldatum',
    colDagenVervallen: 'Dagen vervallen',
    colBedrag: 'Bedrag',
    colProefsessie: 'Proefsessie',
    colAantalHerinneringen: 'Herinneringen verstuurd',
    colLaatsteHerinnering: 'Laatste herinnering',
    colInterval: 'Interval',
    colMax: 'Max',
    colVerlooptOp: 'Verloopt op',
    dagAfkorting: 'dgn',
    dagen: 'dagen',
    ongeldigTestadres: 'Vul een geldig testadres in.',
    resultaatFactuur: 'herinneringen/aanmaningen',
    resultaatProspect: 'prospectherinneringen',
    resultaatAkkoord: 'overeenkomstherinneringen',
    testResultaat: 'Testrun geslaagd: {aantal} {type} als testmail verzonden{details}',

    // Berichttypen
    typeHerinnering: 'Betalingsherinnering',
    typeAanmaning: 'Aanmaning',
    typeProspect: 'Prospect herinnering',
    typeAkkoord: 'Overeenkomst herinnering',

    // Fouten
    foutLaden: 'Fout bij laden dashboard: ',
    foutPreview: 'Fout bij laden preview: ',
    foutTrigger: 'Fout bij uitvoeren job: ',

    // Handmatige trigger — knoppen
    btnTestDraaien: 'Test draaien',
    btnLiveDraaien: 'Live draaien',
    bezig: 'Bezig…',

    // Handmatige trigger — testmodus
    testEmailLabel: 'Testadres (e-mail)',
    testEmailPlaceholder: 'jouw@emailadres.nl',
    testResultaatTitel: 'Testrun geslaagd',
    testResultaatInvoice: 'herinneringen/aanmaningen als testmail naar testadres verstuurd.',
    testResultaatProspect: 'prospect herinneringen als testpush naar testadres verstuurd.',
    testResultaatAgreement: 'overeenkomst herinneringen als testmail naar testadres verstuurd.',
    testGeenEligible: 'Geen cliënten kwamen in aanmerking bij deze run.',

    // Handmatige trigger — live bevestiging
    liveModalTitel: 'Live berichten versturen',
    liveModalWaarschuwing: 'Je staat op het punt ECHTE berichten te versturen. Cliënten die al eerder een bericht ontvingen, worden overgeslagen (idempotentie gewaarborgd).',
    liveModalAantalPrefix: 'Op dit moment komen',
    liveModalAantalSuffix: 'cliënt(en) in aanmerking voor een bericht.',
    liveModalGeenClients: 'Op dit moment zijn er geen cliënten die een bericht zouden ontvangen. Toch doorgaan?',
    liveModalTypeerLabel: 'Typ VERSTUUR om te bevestigen:',
    liveModalTypeerPlaceholder: 'VERSTUUR',
    liveModalBevestigKnop: 'Ja, verstuur nu echte berichten',
    liveModalAnnuleren: 'Annuleren',
    liveResultaatTitel: 'Live run geslaagd',
    liveResultaatInvoice: 'herinneringen/aanmaningen verstuurd naar echte cliënten.',
    liveResultaatProspect: 'prospect herinneringen verstuurd naar echte cliënten.',
    liveResultaatAgreement: 'overeenkomst herinneringen verstuurd naar echte cliënten.',

    // Idempotentie
    previewLadenVoorLive: 'Actueel aantal ophalen…',
  },
  afspraken: {
    title: 'PT-afspraken',
    nieuweKnop: '+ Nieuwe afspraak aanvragen',
    nieuweTitel: 'PT-afspraak aanvragen',
    coach: 'Coach',
    locatie: 'Locatie',
    datum: 'Datum',
    tijd: 'Tijd',
    duur: 'Duur (min)',
    credits: 'Credits',
    notitie: 'Notitie',
    notitiePlaceholder: 'Eventuele opmerkingen…',
    selecteerCoach: 'Selecteer coach…',
    selecteerLocatie: 'Selecteer locatie…',
    annuleren: 'Annuleren',
    indienen: 'Aanvraag indienen',
    bezig: 'Bezig…',
    coachVerplicht: 'Selecteer een coach.',
    locatieVerplicht: 'Selecteer een locatie.',
    duurVerplicht: 'Voer een geldige duur in (min. 15 min).',
    creditsVerplicht: 'Voer een geldig aantal credits in.',
    ingediend: 'Aanvraag succesvol ingediend.',
    foutOpslaan: 'Fout bij indienen aanvraag: ',
    foutLaden: 'Fout bij laden afspraken: ',
    foutReageren: 'Fout bij reageren: ',
    geenAanvragen: 'Je hebt nog geen PT-afspraken aangevraagd.',
    geenAanvragenSub: 'Klik op "+ Nieuwe afspraak aanvragen" om je eerste PT-sessie te boeken.',
    colDatum: 'Datum & tijd',
    colCoach: 'Coach',
    colLocatie: 'Locatie',
    colDuur: 'Duur',
    colCredits: 'Credits',
    colStatus: 'Status',
    statusPending: 'In behandeling',
    statusAccepted: 'Geaccepteerd',
    statusDeclined: 'Afgewezen',
    statusRescheduled: 'Nieuw voorstel',
    voorstelCoach: 'Alternatief voorstel van de coach:',
    origineelAangevraagd: 'Oorspronkelijk aangevraagd',
    accepteren: 'Accepteren',
    afwijzen: 'Afwijzen',
    geaccepteerd: 'Voorstel geaccepteerd.',
    afgewezen: 'Voorstel afgewezen.',
  },
  gebruikersBeheer: {
    title: 'Gebruikersbeheer',
    zoekPlaceholder: 'Zoeken op naam of e-mail…',
    filterAll: 'Alle',
    filterClient: 'Cliënten',
    filterCoach: 'Coaches',
    filterProspect: 'Prospects',
    colNaam: 'Naam',
    colEmail: 'E-mail',
    colRol: 'Rol',
    colStatus: 'Status',
    colCoach: 'Primaire coach',
    colActies: 'Acties',
    bewerken: 'Bewerken',
    bewerkTitel: 'Gebruiker bewerken',
    labelNaam: 'Naam',
    labelEmail: 'E-mailadres',
    labelRol: 'Rol',
    labelCoach: 'Primaire coach toewijzen',
    labelStatus: 'Client status',
    selecteerRol: 'Selecteer rol…',
    selecteerCoach: 'Selecteer coach…',
    geenCoach: 'Geen coach',
    opslaan: 'Opslaan',
    annuleren: 'Annuleren',
    bezig: 'Opslaan…',
    opslaanSucces: 'Gebruiker succesvol bijgewerkt.',
    opslaanFout: 'Fout bij opslaan: ',
    foutLaden: 'Fout bij laden gebruikers: ',
    geenResultaat: 'Geen gebruikers gevonden.',
    nieuweGebruiker: '+ Nieuwe gebruiker',
    aanmakenTitel: 'Nieuwe gebruiker aanmaken',
    labelWachtwoord: 'Wachtwoord',
    wachtwoordTonenTitel: 'Wachtwoord voor nieuwe gebruiker',
    wachtwoordTonenUitleg: 'Dit wachtwoord is automatisch gegenereerd voor {naam} en wordt maar één keer getoond — noteer het of stuur het door.',
    wachtwoordTonenNietGemaild: 'Er is geen e-mail verstuurd — geef dit wachtwoord zelf door aan de gebruiker.',
    wachtwoordTonenSluiten: 'Ik heb het genoteerd, sluiten',
    aanmakenSucces: 'Gebruiker succesvol aangemaakt.',
    aanmakenFout: 'Fout bij aanmaken cliënt: ',
    geenSessie: 'Sessie verlopen — log opnieuw in.',
    validatieNaam: 'Naam is verplicht.',
    validatieEmail: 'E-mailadres is verplicht.',
    validatieRol: 'Rol is verplicht.',
    validatieCoach: 'Kies een coach — zonder coach is de gebruiker niet zichtbaar in de portal.',
    rolSuperadmin: 'Superadmin',
    rolAdminCoach: 'Admin Coach',
    rolCoach: 'Coach',
    rolClient: 'Cliënt',
    statusVerwijderd: 'Verwijderd',
    verwijderen: 'Account verwijderen',
    verwijderTitel: 'Coach-account verwijderen',
    verwijderTekst: 'Weet je zeker dat je het account van {naam} wilt verwijderen? De persoonsgegevens (naam, e-mailadres, telefoon, adres) worden gewist en inloggen wordt geblokkeerd. Gekoppelde lessen, afspraken, overeenkomsten en administratie blijven bestaan en tonen voortaan "Verwijderde coach" — dat is wettelijk en administratief noodzakelijk en kan niet ongedaan worden gemaakt.',
    verwijderBevestig: 'Ja, account verwijderen',
    verwijderSucces: 'Account verwijderd: de persoonsgegevens zijn gewist en inloggen is geblokkeerd.',
    verwijderLoginNietGeblokkeerd: 'De persoonsgegevens zijn gewist, maar het inloggen kon niet worden geblokkeerd. Meld dit bij de beheerder.',
    verwijderFout: 'Fout bij verwijderen: ',
    statusActive: 'Actief',
    statusProspect: 'Prospect',
    statusInactive: 'Inactief',
  },
  betalingBevestiging: {
    titel: 'Betaling',
    laden: 'Even geduld, we controleren de status van je betaling...',
    paid: 'Bedankt! Je betaling is verwerkt.',
    pending: 'Bedankt, we verwerken je betaling. Dit kan enkele minuten duren.',
    failed: 'De betaling is niet gelukt of geannuleerd. Neem contact op met je coach als je vragen hebt.',
    notFound: 'Deze factuur kon niet gevonden worden.',
    terugNaarApp: 'Je kunt dit venster nu sluiten.',
  },
  accountVerwijderen: {
    titel: 'Account en gegevens verwijderen',
    intro: 'Wil je je account bij Fit En Sterker en de daaraan gekoppelde persoonsgegevens laten verwijderen? Hieronder lees je hoe dat werkt, wat er precies gebeurt en welke gegevens wij wettelijk verplicht moeten bewaren.',

    metAppTitel: 'Je hebt nog toegang tot de app',
    metAppIntro: 'Je kunt je account dan zelf verwijderen vanuit de app. Dit gaat direct in.',
    metAppStap1: 'Open de Fit En Sterker-app en log in.',
    metAppStap2: 'Ga naar het tabblad Instellingen en scroll naar het onderdeel "Account verwijderen".',
    metAppStap3: 'Tik op de knop "Account verwijderen".',
    metAppStap4: 'Typ ter bevestiging je eigen e-mailadres in het venster dat verschijnt en tik op "Verwijderen". Je account wordt direct verwijderd en je wordt uitgelogd.',
    metAppLet: 'Let op: staat er nog een onbetaalde factuur open, dan kan het account nog niet worden verwijderd. Neem in dat geval eerst contact op met je coach.',

    zonderAppTitel: 'Je hebt geen toegang (meer) tot de app',
    zonderAppIntro: 'Kun je niet meer inloggen of heb je de app niet meer? Stuur dan een verzoek per e-mail naar:',
    zonderAppVermeld: 'Vermeld in je e-mail in elk geval:',
    zonderAppVermeld1: 'je volledige naam;',
    zonderAppVermeld2: 'het e-mailadres waarmee je account is aangemaakt;',
    zonderAppVermeld3: 'de duidelijke vermelding dat je je account en persoonsgegevens wilt laten verwijderen.',
    zonderAppTermijn: 'Wij verwerken je verzoek binnen 30 dagen en bevestigen de verwijdering per e-mail. We kunnen je vragen je identiteit te bevestigen voordat we het verzoek uitvoeren.',

    gevolgenTitel: 'Wat gebeurt er bij verwijdering?',
    gevolg1: 'Je persoonsgegevens worden verwijderd of geanonimiseerd: naam, e-mailadres, telefoonnummer en adresgegevens worden gewist of overschreven.',
    gevolg2: 'Je toegang tot de app en de webportal wordt direct geblokkeerd; inloggen is daarna niet meer mogelijk.',
    gevolg3: 'Lopende abonnementen worden opgezegd en resterende credits komen te vervallen.',
    gevolg4: 'De verwijdering is definitief en kan niet ongedaan worden gemaakt. Wil je later opnieuw gebruikmaken van onze diensten, dan maak je een nieuw account aan.',

    bewaarTitel: 'Wat blijft wettelijk bewaard?',
    bewaarUitleg: 'Facturen en de bijbehorende financiële administratie moeten wij op grond van de fiscale bewaarplicht 7 jaar bewaren. Deze gegevens kunnen wij daarom niet op verzoek verwijderen.',
    bewaarScheiding: 'Deze financiële gegevens worden na verwijdering niet meer gekoppeld aan je overige persoonsgegevens: die zijn immers gewist of geanonimiseerd. Ze worden uitsluitend nog gebruikt voor de wettelijke administratie en niet voor andere doeleinden.',

    vragen: 'Heb je vragen over de verwerking van je persoonsgegevens of over dit verzoek? Neem dan contact op via bovenstaand e-mailadres.',
  },
  opzeggingen: {
    title: 'Opzeggingen',
    aantalGevonden: 'opzeggingen gevonden',
    foutLaden: 'Fout bij laden: ',
    geenOpzeggingen: 'Nog geen opzeggingen.',
    onbekend: 'Onbekend',
    geenReden: 'Geen reden opgegeven',
    colClient: 'Cliënt',
    colType: 'Abonnement',
    colOpzegdatum: 'Opzegdatum',
    colReden: 'Opzegreden',
    colEinddatum: 'Einddatum looptijd',
    colStatus: 'Status',
    statusNogLopend: 'Nog lopend tot {datum}',
    statusHeractiveerd: 'Heractiveerd op {datum}',
    statusDefinitiefVerlopen: 'Definitief verlopen',
  },
  agendaSync: {
    title: 'Agenda-synchronisatie',
    intro: 'Abonneer op jouw persoonlijke agenda-feed en zie al je trainingen en afspraken direct in je agenda-app.',
    urlLabel: 'Jouw agenda-URL',
    copyBtn: 'Kopieer',
    copied: '✓ Gekopieerd!',
    noToken: 'Nog geen agenda-URL gegenereerd.',
    generateBtn: 'Agenda-URL genereren',
    generating: 'Genereren…',
    regenerateBtn: 'Link vernieuwen',
    regenerateWarning: 'Weet je zeker dat je de link wilt vernieuwen? Je bestaande agenda-abonnement stopt dan — je moet de nieuwe URL opnieuw toevoegen.',
    regenerateConfirm: 'Ja, vernieuwen',
    regenerateCancel: 'Annuleren',
    instructionTitle: 'Zo voeg je de feed toe aan je agenda:',
    step1: '1. Open je agenda-app (Google Agenda, Apple Calendar of Outlook)',
    step2: '2. Kies \'Abonneren op agenda\' of \'Via URL toevoegen\'',
    step3: '3. Plak de bovenstaande URL',
    step4: '4. Je agenda wordt automatisch bijgewerkt (elke paar uur)',
    foutLaden: 'Fout bij ophalen agenda-URL: ',
    foutGenereren: 'Fout bij genereren agenda-URL: ',
    foutKopieren: 'Kopiëren naar het klembord is mislukt.',
  },
  buddies: {
    title: "Buddy's",
    myCode: 'Jouw buddy-code',
    myCodeDesc: 'Deel deze code met iemand die je als buddy wil toevoegen.',
    addBuddy: 'Buddy toevoegen',
    addBuddyDesc: 'Voer de buddy-code in van de persoon die je wil koppelen.',
    incoming: 'Inkomende verzoeken',
    outgoing: 'Verzonden verzoeken',
    pending: 'Wacht op bevestiging',
    myBuddies: "Mijn buddy's",
    noBuddies: "Je hebt nog geen buddy's.",
    requestSent: 'Buddy-verzoek verstuurd!',
    accepted: 'Buddy geaccepteerd!',
    rejectConfirm: 'Weet je zeker dat je dit buddy-verzoek wilt afwijzen?',
    removeConfirm: 'Weet je zeker dat je deze buddy wilt verwijderen? De ander ontvangt hiervan geen melding.',
    errorGeneric: 'Er is iets misgegaan. Probeer het opnieuw.',
    error_invalid_code: 'Deze code is ongeldig of bestaat niet.',
    error_self_request: 'Je kunt jezelf niet als buddy toevoegen.',
    error_already_connected: 'Je bent al gekoppeld of hebt al een verzoek lopen met deze persoon.',
    error_max_buddies_requester: 'Je hebt het maximale aantal buddy\'s bereikt.',
    error_max_buddies_receiver: 'Deze persoon heeft het maximale aantal buddy\'s bereikt.',
    error_cooldown: 'Je kunt pas na de afkoelperiode opnieuw een verzoek sturen naar deze persoon.',
    error_rate_limited: 'Je hebt te veel buddy-codes geprobeerd. Probeer het over een uur opnieuw.',
    unknown: 'Onbekend',
  },
  clientNotes: {
    title: 'Interne notities',
    placeholder: 'Schrijf een notitie over deze relatie…',
    add: 'Notitie toevoegen',
    empty: 'Er zijn nog geen algemene notities bij deze relatie.',
    saved: 'Notitie toegevoegd.',
    loadError: 'Notities konden niet worden geladen: ',
    saveError: 'Notitie kon niet worden opgeslagen: ',
    unknownAuthor: 'Onbekende coach',
  },
  clientActivity: {
    title: 'Recente activiteit',
    latest: 'Laatste gebeurtenissen bij deze cliënt',
    empty: 'Geen activiteit binnen dit filter.',
    showMore: 'Nog {count} tonen',
    showLess: 'Minder tonen',
    noteAdded: 'Interne notitie toegevoegd',
    workoutCompleted: 'Training afgerond',
    workoutWithoutTemplate: 'Training zonder sjabloon',
    appointment: 'Training of afspraak',
    training: 'Training',
    creditsAdded: 'Credits toegevoegd',
    creditsUsed: 'Credits gebruikt',
    credits: 'credits',
    membershipChanged: 'Abonnement gewijzigd',
    invoiceCreated: 'Factuur aangemaakt',
    filters: {
      all: 'Alles',
      training: 'Training',
      notes: 'Notities',
      membership: 'Abonnement',
      finance: 'Financieel',
    },
  },
  accountActivation: {
    checkboxLabel: 'Activeringsmail direct versturen',
    title: 'Activeer je account',
    intro: 'Kies zelf een wachtwoord om je account te activeren.',
    submit: 'Account activeren',
    successTitle: 'Account geactiveerd',
    successText: 'Je account is geactiveerd. Je wordt doorgestuurd naar de inlogpagina…',
    statusActive: 'Account geactiveerd',
    statusPending: 'Wacht op activatie',
    statusActiveShort: 'Geactiveerd',
    statusPendingShort: 'Niet geactiveerd',
    sendButton: 'Activeringsmail sturen',
    confirmTitle: 'Account activeren',
    confirmText: 'Stuur een activeringsmail naar {naam}. De cliënt kan daarmee een eigen wachtwoord kiezen en inloggen.',
    sent: 'Activeringsmail verstuurd.',
    sendError: 'Activeringsmail kon niet worden verstuurd: ',
    agreementTitle: 'Activeer ook je account',
    agreementText: 'Je account is nog niet geactiveerd. Kies zelf een wachtwoord om in te kunnen loggen.',
    agreementButton: 'Account activeren',
  },
  // Onderdeel 10 — centrale foutvertaling (web). Nooit ruwe database-
  // meldingen, constraintnamen of UUID's in een gebruikerstekst.
  errors: {
    referenceLabel: '(ref. {reference})',
    validatie: {
      title: 'Invoer niet geaccepteerd',
      message: 'Een van de ingevulde waarden kan niet worden opgeslagen. Controleer de invoer en probeer het opnieuw.',
    },
    verbinding: {
      title: 'Geen verbinding',
      message: 'De server was niet bereikbaar. Controleer de internetverbinding en probeer het opnieuw.',
    },
    autorisatie: {
      title: 'Geen toegang',
      message: 'Je hebt geen toestemming voor deze actie, of je sessie is verlopen. Log opnieuw in.',
    },
    opslag: {
      title: 'Tijdelijk niet gelukt',
      message: 'De server kon dit even niet verwerken. Probeer het over een paar seconden opnieuw.',
    },
    onbekend: {
      title: 'Er ging iets mis',
      message: 'Deze actie kon niet worden afgerond. Probeer het opnieuw; blijft het misgaan, geef dan de foutreferentie door.',
    },
  },
  // Onderdeel 6 — trainingslogboek voor de cliënt in de webportal.
  clientTraining: {
    titel: 'Trainingslogboek',
    subtitel: 'Al je gelogde trainingen, door jezelf of door je coach vastgelegd',
    leegTitel: 'Nog geen trainingen gelogd',
    leegTekst: 'Zodra jij of je coach een training logt, verschijnt die hier met datum, oefeningen, sets en resultaten.',
    alleOefeningen: 'Alle {aantal} oefeningen tonen',
    minderTonen: 'Minder tonen',
    bewerken: 'Datum en opmerking aanpassen',
    verwijderen: 'Verwijderen',
    annuleren: 'Annuleren',
    opslaan: 'Opslaan',
    opgeslagen: 'Trainingssessie bijgewerkt.',
    verwijderd: 'Trainingssessie verwijderd.',
    veldDatum: 'Trainingsdatum',
    veldDatumHint: 'De datum waarop je deze training deed. Een datum in de toekomst is niet mogelijk.',
    veldNotitie: 'Opmerking',
    alleenLezen: 'Deze sessie is door je coach gelogd en kun je alleen bekijken.',
    verwijderTitel: 'Trainingssessie verwijderen?',
    verwijderTekst: 'De sessie van {datum} en alle bijbehorende oefeningen en sets worden voorgoed verwijderd. Dit kan niet ongedaan worden gemaakt.',
    verwijderBevestig: 'Ja, verwijderen',
  },
};

export const t = (key, vars) => {
  const str = key.split('.').reduce((o, k) => o?.[k], nl) ?? key;
  if (!vars || typeof str !== 'string') return str;
  return str.replace(/\{(\w+)\}/g, (_, k) => (vars[k] !== undefined ? vars[k] : `{${k}}`));
};
export default nl;
